module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0063":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "00ea":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 16 12",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-515 -372)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/checkmark",
        "transform": "translate(515 372)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M.398 5.597a.578.578 0 00.001.81l4.52 4.578a.723.723 0 001.03 0L15.55 1.32a.617.617 0 00-.018-.886.654.654 0 00-.913.024L6.884 8.41 5.368 9.757l-4.17-4.164a.563.563 0 00-.8.004z",
        "id": "Shape-Copy"
      }
    })])])])]));
  }
};

/***/ }),

/***/ "02bc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorTabs_vue_vue_type_style_index_0_id_536327da_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a55a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorTabs_vue_vue_type_style_index_0_id_536327da_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorTabs_vue_vue_type_style_index_0_id_536327da_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0344":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "04f8":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "04fe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-total/AdvisorResultsTotal.vue?vue&type=template&id=963fc638&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"advisor-results-total"},[_c('h2',{staticClass:"results-title"},[_vm._v(" "+_vm._s(_vm.$t("results_total.materials_found"))+" "),_c('span',{staticClass:"total-results"},[_vm._v(_vm._s(_vm.totalResults))])])]):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-results-total/AdvisorResultsTotal.vue?vue&type=template&id=963fc638&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-total/AdvisorResultsTotal.vue?vue&type=script&lang=ts



let AdvisorResultsTotalvue_type_script_lang_ts_AdvisorResultsBar = class AdvisorResultsBar extends vue_property_decorator["c" /* Vue */] {};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: true
})], AdvisorResultsTotalvue_type_script_lang_ts_AdvisorResultsBar.prototype, "visible", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: 0
})], AdvisorResultsTotalvue_type_script_lang_ts_AdvisorResultsBar.prototype, "totalResults", void 0);
AdvisorResultsTotalvue_type_script_lang_ts_AdvisorResultsBar = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorResultsTotalvue_type_script_lang_ts_AdvisorResultsBar);
/* harmony default export */ var AdvisorResultsTotalvue_type_script_lang_ts = (AdvisorResultsTotalvue_type_script_lang_ts_AdvisorResultsBar);
// CONCATENATED MODULE: ./src/components/advisor-results-total/AdvisorResultsTotal.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_results_total_AdvisorResultsTotalvue_type_script_lang_ts = (AdvisorResultsTotalvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-results-total/AdvisorResultsTotal.vue?vue&type=style&index=0&id=963fc638&prod&lang=scss&scoped=true
var AdvisorResultsTotalvue_type_style_index_0_id_963fc638_prod_lang_scss_scoped_true = __webpack_require__("b7e4");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-results-total/AdvisorResultsTotal.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_results_total_AdvisorResultsTotalvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "963fc638",
  null
  
)

/* harmony default export */ var AdvisorResultsTotal = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "05ee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailureDisclaimer_vue_vue_type_style_index_0_id_1d5232c0_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3e2b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailureDisclaimer_vue_vue_type_style_index_0_id_1d5232c0_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailureDisclaimer_vue_vue_type_style_index_0_id_1d5232c0_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var call = __webpack_require__("c65b");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var hasOwn = __webpack_require__("1a2d");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "07dd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "07fa":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("50c4");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d1e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0d51":
/***/ (function(module, exports) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "0dad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresAccordion_vue_vue_type_style_index_0_id_7a706d09_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("82fa");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresAccordion_vue_vue_type_style_index_0_id_7a706d09_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresAccordion_vue_vue_type_style_index_0_id_7a706d09_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "109d":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 22 20",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, attrs),
      ...rest
    }, children.concat([_c('defs', [_c('path', {
      attrs: {
        "d": "M22 5.806c0 .254-.09.47-.267.649a.884.884 0 01-.65.267.884.884 0 01-.649-.267L19.059 5.08 9.778 14.4a.884.884 0 01-.65.267.884.884 0 01-.649-.268l-.878-.878a.884.884 0 01-.268-.65c0-.254.09-.47.268-.649l9.32-9.281-1.376-1.375a.884.884 0 01-.267-.65c0-.254.089-.47.267-.649a.884.884 0 01.65-.267h4.888c.255 0 .471.09.65.267a.884.884 0 01.267.65v4.889zm-6.455 4.545a.776.776 0 01.65-.287.997.997 0 01.649.268c.178.165.267.388.267.668v6.722c0 .51-.178.942-.535 1.299-.356.356-.789.535-1.298.535H1.833c-.509 0-.942-.179-1.298-.535A1.768 1.768 0 010 17.722V4.278c0-.51.178-.942.535-1.299.356-.356.79-.535 1.298-.535H13.14c.254 0 .47.09.65.268a.884.884 0 01.267.65c0 .254-.09.47-.268.648l-.61.612a.884.884 0 01-.65.267H2.444V17.11h12.223v-5.5c0-.255.089-.47.267-.65l.611-.61z",
        "id": "path-1"
      }
    })]), _c('g', {
      attrs: {
        "id": "Artboard",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Regular/calendar-times"
      }
    }, [_c('mask', {
      attrs: {
        "id": "mask-2",
        "fill": "#fff"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#path-1"
      }
    })]), _c('use', {
      attrs: {
        "id": "",
        "fill": "#009FE3",
        "xlink:href": "#path-1"
      }
    }), _c('g', {
      attrs: {
        "id": "Group",
        "mask": "url(#mask-2)",
        "fill": "#FFF"
      }
    }, [_c('g', {
      attrs: {
        "id": "Branding-/-Colors-/-DSM-Cyan"
      }
    }, [_c('path', {
      attrs: {
        "id": "Rectangle-Copy",
        "d": "M0 0h22v19.556H0z"
      }
    })])])])])]));
  }
};

/***/ }),

/***/ "1183":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorProgressActiveStep_vue_vue_type_style_index_0_id_6720efcd_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8393");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorProgressActiveStep_vue_vue_type_style_index_0_id_6720efcd_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorProgressActiveStep_vue_vue_type_style_index_0_id_6720efcd_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "118a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsLinkList_vue_vue_type_style_index_0_id_8e256c80_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0344");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsLinkList_vue_vue_type_style_index_0_id_8e256c80_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsLinkList_vue_vue_type_style_index_0_id_8e256c80_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1214":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsItemSm_vue_vue_type_style_index_0_id_ce2950de_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0d1e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsItemSm_vue_vue_type_style_index_0_id_ce2950de_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsItemSm_vue_vue_type_style_index_0_id_ce2950de_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "12c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsLinkList_vue_vue_type_style_index_1_id_8e256c80_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("07dd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsLinkList_vue_vue_type_style_index_1_id_8e256c80_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsLinkList_vue_vue_type_style_index_1_id_8e256c80_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "13d2":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var DESCRIPTORS = __webpack_require__("83ab");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("5e77").CONFIGURABLE;
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "14d9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var setArrayLength = __webpack_require__("3a34");
var doesNotExceedSafeInteger = __webpack_require__("3511");
var fails = __webpack_require__("d039");

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var SILENT_ON_NON_WRITABLE_LENGTH = !function () {
  try {
    // eslint-disable-next-line es-x/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
}();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: INCORRECT_TO_LENGTH || SILENT_ON_NON_WRITABLE_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ "1538":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-risk-picker/FailuresRiskPicker.vue?vue&type=template&id=74473790&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"risk-picker"},_vm._l((_vm.labels),function(item,index){return _c('div',{key:index,staticClass:"risk-picker__item",class:{ selected: _vm.selected === index },on:{"click":function($event){return _vm.valueChanged(index)}}},[_c('div',{staticClass:"risk-picker__risk-value",style:({ backgroundColor: _vm.calcBackgroundColor(index) + '' })},[_vm._v(" "+_vm._s(index + 1)+" ")]),_c('div',{staticClass:"risk-picker__risk-title"},[_vm._v(_vm._s(item))])])}),0)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failures-risk-picker/FailuresRiskPicker.vue?vue&type=template&id=74473790&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-risk-picker/FailuresRiskPicker.vue?vue&type=script&lang=ts


let FailuresRiskPickervue_type_script_lang_ts_FailuresRiskPicker = class FailuresRiskPicker extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.backgroundColor = "#B7B9BA";
    this.colors = ["#7DE9A4", "#CBF6DB", "#E3FB76", "#FF9E9B", "#FF5E59"];
    this.reversColors = [...this.colors].reverse();
  }
  calcBackgroundColor(index) {
    if (index == this.selected) {
      if (this.revers) {
        return this.reversColors[index];
      } else {
        return this.colors[index];
      }
    }
    return this.backgroundColor;
  }
  valueChanged(value) {
    this.$emit("valueChanged", value);
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Array(String)
})], FailuresRiskPickervue_type_script_lang_ts_FailuresRiskPicker.prototype, "labels", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Number
})], FailuresRiskPickervue_type_script_lang_ts_FailuresRiskPicker.prototype, "selected", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Boolean,
  default: false
})], FailuresRiskPickervue_type_script_lang_ts_FailuresRiskPicker.prototype, "revers", void 0);
FailuresRiskPickervue_type_script_lang_ts_FailuresRiskPicker = Object(tslib_es6["a" /* __decorate */])([vue_property_decorator["a" /* Component */]], FailuresRiskPickervue_type_script_lang_ts_FailuresRiskPicker);
/* harmony default export */ var FailuresRiskPickervue_type_script_lang_ts = (FailuresRiskPickervue_type_script_lang_ts_FailuresRiskPicker);
// CONCATENATED MODULE: ./src/components/failures-risk-picker/FailuresRiskPicker.vue?vue&type=script&lang=ts
 /* harmony default export */ var failures_risk_picker_FailuresRiskPickervue_type_script_lang_ts = (FailuresRiskPickervue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failures-risk-picker/FailuresRiskPicker.vue?vue&type=style&index=0&id=74473790&prod&lang=scss&scoped=true
var FailuresRiskPickervue_type_style_index_0_id_74473790_prod_lang_scss_scoped_true = __webpack_require__("1cbc");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failures-risk-picker/FailuresRiskPicker.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failures_risk_picker_FailuresRiskPickervue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "74473790",
  null
  
)

/* harmony default export */ var failures_risk_picker_FailuresRiskPicker = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "1594":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M495.9 166.6c3.2 8.7.5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4l-55.6 17.8c-8.8 2.8-18.6.3-24.5-6.8-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4c-1.1-8.4-1.7-16.9-1.7-25.5s.6-17.1 1.7-25.4l-43.3-39.4c-6.9-6.2-9.6-15.9-6.4-24.6 4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2 5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8 8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 100-160 80 80 0 100 160z"
      }
    })]));
  }
};

/***/ }),

/***/ "15c0":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 576 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M0 24C0 10.7 10.7 0 24 0h45.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zm128 440a48 48 0 1196 0 48 48 0 11-96 0zm336-48a48 48 0 110 96 48 48 0 110-96z"
      }
    })]));
  }
};

/***/ }),

/***/ "1626":
/***/ (function(module, exports, __webpack_require__) {

var $documentAll = __webpack_require__("8ea1");

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "1af0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-cta-bar/AdvisorCtaBar.vue?vue&type=template&id=43e824fd&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.visible)?_c('div',{staticClass:"advisor-cta-bar"},[_c('h2',{staticClass:"cta-bar-title mb-2"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"cta-bar-description",domProps:{"innerHTML":_vm._s(_vm.description)}}),(_vm.buttons.length > 0)?_c('div',{staticClass:"cta-bar-btn-group"},_vm._l((_vm.buttons),function(btn,index){return _c('button',{key:index,staticClass:"btn btn-ev-light-blue btn-icon",attrs:{"type":"button","target":btn.target},on:{"click":function($event){return _vm.link(btn)}}},[_c('span',[_vm._v(_vm._s(btn.label))]),_c('advisor-icon',{attrs:{"name":"faArrowRight"}})],1)}),0):_vm._e()]):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-cta-bar/AdvisorCtaBar.vue?vue&type=template&id=43e824fd&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-cta-bar/AdvisorCtaBar.vue?vue&type=script&lang=ts



let AdvisorCtaBarvue_type_script_lang_ts_AdvisorCtaBar = class AdvisorCtaBar extends vue_property_decorator["c" /* Vue */] {
  link(btn) {
    if (btn.link.indexOf("router:") !== -1) {
      this.$emit("routerLink", btn.link.substring(btn.link.lastIndexOf(":") + 1));
    } else {
      window.open(btn.link, btn.target);
    }
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: true
})], AdvisorCtaBarvue_type_script_lang_ts_AdvisorCtaBar.prototype, "visible", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorCtaBarvue_type_script_lang_ts_AdvisorCtaBar.prototype, "title", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorCtaBarvue_type_script_lang_ts_AdvisorCtaBar.prototype, "description", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorCtaBarvue_type_script_lang_ts_AdvisorCtaBar.prototype, "buttons", void 0);
AdvisorCtaBarvue_type_script_lang_ts_AdvisorCtaBar = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorCtaBarvue_type_script_lang_ts_AdvisorCtaBar);
/* harmony default export */ var AdvisorCtaBarvue_type_script_lang_ts = (AdvisorCtaBarvue_type_script_lang_ts_AdvisorCtaBar);
// CONCATENATED MODULE: ./src/components/advisor-cta-bar/AdvisorCtaBar.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_cta_bar_AdvisorCtaBarvue_type_script_lang_ts = (AdvisorCtaBarvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-cta-bar/AdvisorCtaBar.vue?vue&type=style&index=0&id=43e824fd&prod&lang=scss&scoped=true
var AdvisorCtaBarvue_type_style_index_0_id_43e824fd_prod_lang_scss_scoped_true = __webpack_require__("daa6");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-cta-bar/AdvisorCtaBar.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_cta_bar_AdvisorCtaBarvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "43e824fd",
  null
  
)

/* harmony default export */ var advisor_cta_bar_AdvisorCtaBar = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "1b70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-icon/AdvisorIcon.vue?vue&type=template&id=758ece00
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advisor-icon",class:_vm.svgIconClass},[_c(_vm.svgIconName,{tag:"component"})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-icon/AdvisorIcon.vue?vue&type=template&id=758ece00

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/assets/icons/adobeicon.svg?inline
var adobeiconinline = __webpack_require__("8d3b");
var adobeiconinline_default = /*#__PURE__*/__webpack_require__.n(adobeiconinline);

// EXTERNAL MODULE: ./src/assets/icons/carticon.svg?inline
var carticoninline = __webpack_require__("c571");
var carticoninline_default = /*#__PURE__*/__webpack_require__.n(carticoninline);

// EXTERNAL MODULE: ./src/assets/icons/chaticon.svg?inline
var chaticoninline = __webpack_require__("924b");
var chaticoninline_default = /*#__PURE__*/__webpack_require__.n(chaticoninline);

// EXTERNAL MODULE: ./src/assets/icons/checkmarkicon.svg?inline
var checkmarkiconinline = __webpack_require__("00ea");
var checkmarkiconinline_default = /*#__PURE__*/__webpack_require__.n(checkmarkiconinline);

// EXTERNAL MODULE: ./src/assets/icons/closeicon.svg?inline
var closeiconinline = __webpack_require__("1ef0");
var closeiconinline_default = /*#__PURE__*/__webpack_require__.n(closeiconinline);

// EXTERNAL MODULE: ./src/assets/icons/cogicon.svg?inline
var cogiconinline = __webpack_require__("a893");
var cogiconinline_default = /*#__PURE__*/__webpack_require__.n(cogiconinline);

// EXTERNAL MODULE: ./src/assets/icons/emailicon.svg?inline
var emailiconinline = __webpack_require__("eade");
var emailiconinline_default = /*#__PURE__*/__webpack_require__.n(emailiconinline);

// EXTERNAL MODULE: ./src/assets/icons/excelicon.svg?inline
var exceliconinline = __webpack_require__("8a0b");
var exceliconinline_default = /*#__PURE__*/__webpack_require__.n(exceliconinline);

// EXTERNAL MODULE: ./src/assets/icons/externalicon.svg?inline
var externaliconinline = __webpack_require__("d977");
var externaliconinline_default = /*#__PURE__*/__webpack_require__.n(externaliconinline);

// EXTERNAL MODULE: ./src/assets/icons/homeicon.svg?inline
var homeiconinline = __webpack_require__("82a6");
var homeiconinline_default = /*#__PURE__*/__webpack_require__.n(homeiconinline);

// EXTERNAL MODULE: ./src/assets/icons/lefticon.svg?inline
var lefticoninline = __webpack_require__("f292");
var lefticoninline_default = /*#__PURE__*/__webpack_require__.n(lefticoninline);

// EXTERNAL MODULE: ./src/assets/icons/questionicon.svg?inline
var questioniconinline = __webpack_require__("c967");
var questioniconinline_default = /*#__PURE__*/__webpack_require__.n(questioniconinline);

// EXTERNAL MODULE: ./src/assets/icons/quoteicon.svg?inline
var quoteiconinline = __webpack_require__("727b");
var quoteiconinline_default = /*#__PURE__*/__webpack_require__.n(quoteiconinline);

// EXTERNAL MODULE: ./src/assets/icons/resultsicon.svg?inline
var resultsiconinline = __webpack_require__("2326");
var resultsiconinline_default = /*#__PURE__*/__webpack_require__.n(resultsiconinline);

// EXTERNAL MODULE: ./src/assets/icons/righticon.svg?inline
var righticoninline = __webpack_require__("d869");
var righticoninline_default = /*#__PURE__*/__webpack_require__.n(righticoninline);

// EXTERNAL MODULE: ./src/assets/icons/saveicon.svg?inline
var saveiconinline = __webpack_require__("629d");
var saveiconinline_default = /*#__PURE__*/__webpack_require__.n(saveiconinline);

// EXTERNAL MODULE: ./src/assets/icons/telephoneicon.svg?inline
var telephoneiconinline = __webpack_require__("4c34");
var telephoneiconinline_default = /*#__PURE__*/__webpack_require__.n(telephoneiconinline);

// EXTERNAL MODULE: ./src/assets/icons/shareblueicon.svg?inline
var shareblueiconinline = __webpack_require__("e216");
var shareblueiconinline_default = /*#__PURE__*/__webpack_require__.n(shareblueiconinline);

// EXTERNAL MODULE: ./src/assets/icons/sharewhiteicon.svg?inline
var sharewhiteiconinline = __webpack_require__("109d");
var sharewhiteiconinline_default = /*#__PURE__*/__webpack_require__.n(sharewhiteiconinline);

// EXTERNAL MODULE: ./src/assets/icons/contactblueicon.svg?inline
var contactblueiconinline = __webpack_require__("24ae");
var contactblueiconinline_default = /*#__PURE__*/__webpack_require__.n(contactblueiconinline);

// EXTERNAL MODULE: ./src/assets/icons/contactwhiteicon.svg?inline
var contactwhiteiconinline = __webpack_require__("5f22");
var contactwhiteiconinline_default = /*#__PURE__*/__webpack_require__.n(contactwhiteiconinline);

// EXTERNAL MODULE: ./src/assets/icons/warningicon.svg?inline
var warningiconinline = __webpack_require__("7124");
var warningiconinline_default = /*#__PURE__*/__webpack_require__.n(warningiconinline);

// EXTERNAL MODULE: ./src/assets/icons/communicationicon.svg?inline
var communicationiconinline = __webpack_require__("c57a");
var communicationiconinline_default = /*#__PURE__*/__webpack_require__.n(communicationiconinline);

// EXTERNAL MODULE: ./src/assets/icons/exclamationicon.svg?inline
var exclamationiconinline = __webpack_require__("8619");
var exclamationiconinline_default = /*#__PURE__*/__webpack_require__.n(exclamationiconinline);

// EXTERNAL MODULE: ./src/assets/icons/pagericon.svg?inline
var pagericoninline = __webpack_require__("8c5c");
var pagericoninline_default = /*#__PURE__*/__webpack_require__.n(pagericoninline);

// EXTERNAL MODULE: ./src/assets/icons/phoneicon.svg?inline
var phoneiconinline = __webpack_require__("8406");
var phoneiconinline_default = /*#__PURE__*/__webpack_require__.n(phoneiconinline);

// EXTERNAL MODULE: ./src/assets/icons/umbrellaicon.svg?inline
var umbrellaiconinline = __webpack_require__("3faa");
var umbrellaiconinline_default = /*#__PURE__*/__webpack_require__.n(umbrellaiconinline);

// EXTERNAL MODULE: ./src/assets/icons/fa-arrow-right.svg?inline
var fa_arrow_rightinline = __webpack_require__("6275");
var fa_arrow_rightinline_default = /*#__PURE__*/__webpack_require__.n(fa_arrow_rightinline);

// EXTERNAL MODULE: ./src/assets/icons/fa-arrow-left.svg?inline
var fa_arrow_leftinline = __webpack_require__("991c");
var fa_arrow_leftinline_default = /*#__PURE__*/__webpack_require__.n(fa_arrow_leftinline);

// EXTERNAL MODULE: ./src/assets/icons/fa-comment.svg?inline
var fa_commentinline = __webpack_require__("1f4c");
var fa_commentinline_default = /*#__PURE__*/__webpack_require__.n(fa_commentinline);

// EXTERNAL MODULE: ./src/assets/icons/fa-share.svg?inline
var fa_shareinline = __webpack_require__("dc04");
var fa_shareinline_default = /*#__PURE__*/__webpack_require__.n(fa_shareinline);

// EXTERNAL MODULE: ./src/assets/icons/fa-caret-down.svg?inline
var fa_caret_downinline = __webpack_require__("581a");
var fa_caret_downinline_default = /*#__PURE__*/__webpack_require__.n(fa_caret_downinline);

// EXTERNAL MODULE: ./src/assets/icons/fa-caret-up.svg?inline
var fa_caret_upinline = __webpack_require__("ec83");
var fa_caret_upinline_default = /*#__PURE__*/__webpack_require__.n(fa_caret_upinline);

// EXTERNAL MODULE: ./src/assets/icons/fa-file.svg?inline
var fa_fileinline = __webpack_require__("48d0");
var fa_fileinline_default = /*#__PURE__*/__webpack_require__.n(fa_fileinline);

// EXTERNAL MODULE: ./src/assets/icons/fa-cart-shopping.svg?inline
var fa_cart_shoppinginline = __webpack_require__("15c0");
var fa_cart_shoppinginline_default = /*#__PURE__*/__webpack_require__.n(fa_cart_shoppinginline);

// EXTERNAL MODULE: ./src/assets/icons/fa-gear.svg?inline
var fa_gearinline = __webpack_require__("1594");
var fa_gearinline_default = /*#__PURE__*/__webpack_require__.n(fa_gearinline);

// EXTERNAL MODULE: ./src/assets/icons/infoicon.svg?inline
var infoiconinline = __webpack_require__("9826");
var infoiconinline_default = /*#__PURE__*/__webpack_require__.n(infoiconinline);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-icon/AdvisorIcon.vue?vue&type=script&lang=ts







































let AdvisorIconvue_type_script_lang_ts_AdvisorIcon = class AdvisorIcon extends vue_property_decorator["c" /* Vue */] {
  get svgIconName() {
    return `${this.name}Icon`;
  }
  get svgIconClass() {
    return `${this.name}`;
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorIconvue_type_script_lang_ts_AdvisorIcon.prototype, "name", void 0);
AdvisorIconvue_type_script_lang_ts_AdvisorIcon = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    adobeIcon: adobeiconinline_default.a,
    cartIcon: carticoninline_default.a,
    chatIcon: chaticoninline_default.a,
    checkmarkIcon: checkmarkiconinline_default.a,
    closeIcon: closeiconinline_default.a,
    cogIcon: cogiconinline_default.a,
    emailIcon: emailiconinline_default.a,
    excelIcon: exceliconinline_default.a,
    externalIcon: externaliconinline_default.a,
    homeIcon: homeiconinline_default.a,
    leftIcon: lefticoninline_default.a,
    questionIcon: questioniconinline_default.a,
    quoteIcon: quoteiconinline_default.a,
    resultsIcon: resultsiconinline_default.a,
    rightIcon: righticoninline_default.a,
    saveIcon: saveiconinline_default.a,
    telephoneIcon: telephoneiconinline_default.a,
    shareBlueIcon: shareblueiconinline_default.a,
    shareWhiteIcon: sharewhiteiconinline_default.a,
    contactBlueIcon: contactblueiconinline_default.a,
    contactWhiteIcon: contactwhiteiconinline_default.a,
    warningIcon: warningiconinline_default.a,
    communicationIcon: communicationiconinline_default.a,
    exclamationIcon: exclamationiconinline_default.a,
    pagerIcon: pagericoninline_default.a,
    phoneIcon: phoneiconinline_default.a,
    umbrellaIcon: umbrellaiconinline_default.a,
    faArrowRightIcon: fa_arrow_rightinline_default.a,
    faArrowLeftIcon: fa_arrow_leftinline_default.a,
    faCommentIcon: fa_commentinline_default.a,
    faShareIcon: fa_shareinline_default.a,
    faCaretDownIcon: fa_caret_downinline_default.a,
    faCaretUpIcon: fa_caret_upinline_default.a,
    faFileIcon: fa_fileinline_default.a,
    faCartIcon: fa_cart_shoppinginline_default.a,
    faGearIcon: fa_gearinline_default.a,
    faInfoIcon: infoiconinline_default.a
  }
})], AdvisorIconvue_type_script_lang_ts_AdvisorIcon);
/* harmony default export */ var AdvisorIconvue_type_script_lang_ts = (AdvisorIconvue_type_script_lang_ts_AdvisorIcon);
// CONCATENATED MODULE: ./src/components/advisor-icon/AdvisorIcon.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_icon_AdvisorIconvue_type_script_lang_ts = (AdvisorIconvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue?vue&type=style&index=0&id=758ece00&prod&lang=scss
var AdvisorIconvue_type_style_index_0_id_758ece00_prod_lang_scss = __webpack_require__("dcbd");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-icon/AdvisorIcon.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_icon_AdvisorIconvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var advisor_icon_AdvisorIcon = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "1cbc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRiskPicker_vue_vue_type_style_index_0_id_74473790_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b3d7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRiskPicker_vue_vue_type_style_index_0_id_74473790_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRiskPicker_vue_vue_type_style_index_0_id_74473790_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1d80":
/***/ (function(module, exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__("7234");

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1e38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRootCauseList_vue_vue_type_style_index_0_id_7e756ee7_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6619");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRootCauseList_vue_vue_type_style_index_0_id_7e756ee7_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRootCauseList_vue_vue_type_style_index_0_id_7e756ee7_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1eb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* unused harmony default export */ var _unused_webpack_default_export = (null);


/***/ }),

/***/ "1ef0":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 14 14",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-72 -24)"
      }
    }, [_c('g', {
      attrs: {
        "id": "symbol/close",
        "transform": "translate(67 19)"
      }
    }, [_c('path', {
      attrs: {
        "id": "+",
        "transform": "scale(-1 1) rotate(-45 0 41.51)",
        "d": "M13.55 20.191v-6.738h6.817V10.7h-6.816V4h-2.754v6.7H4v2.753h6.797v6.738z"
      }
    })])])])]));
  }
};

/***/ }),

/***/ "1f4c":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M512 240c0 114.9-114.6 208-256 208-37.1 0-72.3-6.4-104.1-17.9-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.8 3.4-17.4l.3-.3c.3-.3.7-.7 1.3-1.4 1.1-1.2 2.8-3.1 4.9-5.7 4.1-5 9.6-12.4 15.2-21.6 10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240 0 125.1 114.6 32 256 32s256 93.1 256 208z"
      }
    })]));
  }
};

/***/ }),

/***/ "20f7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresCondensedOptions_vue_vue_type_style_index_0_id_53966c1c_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dcf9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresCondensedOptions_vue_vue_type_style_index_0_id_53966c1c_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresCondensedOptions_vue_vue_type_style_index_0_id_53966c1c_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2326":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 16 17",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-227 -322)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/results",
        "transform": "translate(227 322.2)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M14 0c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2V2C0 .897.897 0 2 0zm0 2H2v12h12V2zm-2 8a.999.999 0 110 2H7a.999.999 0 110-2zm-8 0a1 1 0 110 2 1 1 0 010-2zm8-3a.999.999 0 110 2H7a.999.999 0 110-2zM4 7a1 1 0 110 2 1 1 0 010-2zm8-3a.999.999 0 110 2H7a.999.999 0 110-2zM4 4a1 1 0 110 2 1 1 0 010-2z",
        "id": "Combined-Shape"
      }
    })])])])]));
  }
};

/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsBar_vue_vue_type_style_index_0_id_3e7965a3_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("264e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsBar_vue_vue_type_style_index_0_id_3e7965a3_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsBar_vue_vue_type_style_index_0_id_3e7965a3_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var defineBuiltIn = __webpack_require__("cb2d");
var defineGlobalProperty = __webpack_require__("6374");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "24ae":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 27 27",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Artboard",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "help",
        "fill": "#003478",
        "fill-rule": "nonzero"
      }
    }, [_c('path', {
      attrs: {
        "d": "M26.4 17.866a8.553 8.553 0 00-6.25-8.223C19.922 4.287 15.493 0 10.08 0 4.522 0 0 4.522 0 10.08c0 1.812.482 3.576 1.398 5.124l-1.36 4.92 4.919-1.36a10.043 10.043 0 004.686 1.386 8.553 8.553 0 008.223 6.25c1.536 0 3.03-.41 4.343-1.186l4.154 1.149-1.15-4.154a8.503 8.503 0 001.187-4.343zm-21.2-.775l-2.944.814.814-2.945-.185-.29a8.505 8.505 0 01-1.338-4.59c0-4.705 3.828-8.533 8.533-8.533 4.706 0 8.534 3.828 8.534 8.533 0 4.706-3.828 8.534-8.534 8.534a8.505 8.505 0 01-4.589-1.338l-.29-.185zm18.944 7.053l-2.185-.604-.292.19a6.96 6.96 0 01-3.8 1.123 7.004 7.004 0 01-6.624-4.76c4.631-.533 8.317-4.219 8.85-8.85a7.005 7.005 0 014.76 6.623 6.96 6.96 0 01-1.123 3.801l-.19.292.604 2.185z",
        "id": "Shape"
      }
    })])])]));
  }
};

/***/ }),

/***/ "2524":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsItemRd_vue_vue_type_style_index_0_id_7900db05_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8f0c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsItemRd_vue_vue_type_style_index_0_id_7900db05_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsItemRd_vue_vue_type_style_index_0_id_7900db05_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "252c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizeObserver; });
function getInternetExplorerVersion() {
	var ua = window.navigator.userAgent;

	var msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		// IE 10 or older => return version number
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	var trident = ua.indexOf('Trident/');
	if (trident > 0) {
		// IE 11 => return version number
		var rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}

	var edge = ua.indexOf('Edge/');
	if (edge > 0) {
		// Edge (IE 12+) => return version number
		return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	}

	// other browser
	return -1;
}

var isIE = void 0;

function initCompat() {
	if (!initCompat.init) {
		initCompat.init = true;
		isIE = getInternetExplorerVersion() !== -1;
	}
}

var ResizeObserver = { render: function render() {
		var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "resize-observer", attrs: { "tabindex": "-1" } });
	}, staticRenderFns: [], _scopeId: 'data-v-b329ee4c',
	name: 'resize-observer',

	methods: {
		compareAndNotify: function compareAndNotify() {
			if (this._w !== this.$el.offsetWidth || this._h !== this.$el.offsetHeight) {
				this._w = this.$el.offsetWidth;
				this._h = this.$el.offsetHeight;
				this.$emit('notify');
			}
		},
		addResizeHandlers: function addResizeHandlers() {
			this._resizeObject.contentDocument.defaultView.addEventListener('resize', this.compareAndNotify);
			this.compareAndNotify();
		},
		removeResizeHandlers: function removeResizeHandlers() {
			if (this._resizeObject && this._resizeObject.onload) {
				if (!isIE && this._resizeObject.contentDocument) {
					this._resizeObject.contentDocument.defaultView.removeEventListener('resize', this.compareAndNotify);
				}
				delete this._resizeObject.onload;
			}
		}
	},

	mounted: function mounted() {
		var _this = this;

		initCompat();
		this.$nextTick(function () {
			_this._w = _this.$el.offsetWidth;
			_this._h = _this.$el.offsetHeight;
		});
		var object = document.createElement('object');
		this._resizeObject = object;
		object.setAttribute('aria-hidden', 'true');
		object.setAttribute('tabindex', -1);
		object.onload = this.addResizeHandlers;
		object.type = 'text/html';
		if (isIE) {
			this.$el.appendChild(object);
		}
		object.data = 'about:blank';
		if (!isIE) {
			this.$el.appendChild(object);
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.removeResizeHandlers();
	}
};

// Install the components
function install(Vue) {
	Vue.component('resize-observer', ResizeObserver);
	Vue.component('ResizeObserver', ResizeObserver);
}

// Plugin
var plugin = {
	// eslint-disable-next-line no-undef
	version: "0.4.5",
	install: install
};

// Auto-install
var GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}


/* unused harmony default export */ var _unused_webpack_default_export = (plugin);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "264e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "265c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failure-report/FailureReport.vue?vue&type=template&id=7ed54e95&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"failure-report"},[(_vm.title)?_c('h2',{staticClass:"failure-report__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"failure-report__wrapper"},[(_vm.description)?_c('p',{staticClass:"failure-report__description"},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e(),(_vm.disclaimer)?_c('div',{staticClass:"failure-report__disclaimer"},[_c('div',{staticClass:"failure-report__disclaimer-icon"},[_c('advisor-icon',{attrs:{"name":"warning"}})],1),_c('div',{staticClass:"failure-report__disclaimer-text"},[_c('p',{staticClass:"mb-0"},[_c('span',{staticClass:"failure-report__disclaimer-title"},[_vm._v("Disclaimer:")]),_vm._v(" "+_vm._s(_vm.disclaimer)+" ")])])]):_vm._e(),(_vm.contactButtonTitle || _vm.subButtonTitle)?_c('div',{staticClass:"failure-report__info-block"},[(_vm.contactButtonTitle)?_c('a',{staticClass:"btn btn-orange btn-with-icon",attrs:{"href":"#","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.contactButtonTitle)+" "),_c('advisor-icon',{attrs:{"name":"communication"}})],1):_vm._e(),(_vm.subButtonTitle)?_c('button',{staticClass:"btn btn-outline-orange"},[_vm._v(" "+_vm._s(_vm.subButtonTitle)+" ")]):_vm._e()]):_vm._e()])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failure-report/FailureReport.vue?vue&type=template&id=7ed54e95&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failure-report/FailureReport.vue?vue&type=script&lang=ts




let FailureReportvue_type_script_lang_ts_FailureReport = class FailureReport extends vue_property_decorator["c" /* Vue */] {};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailureReportvue_type_script_lang_ts_FailureReport.prototype, "title", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailureReportvue_type_script_lang_ts_FailureReport.prototype, "description", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailureReportvue_type_script_lang_ts_FailureReport.prototype, "disclaimer", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailureReportvue_type_script_lang_ts_FailureReport.prototype, "contactButtonTitle", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailureReportvue_type_script_lang_ts_FailureReport.prototype, "subButtonTitle", void 0);
FailureReportvue_type_script_lang_ts_FailureReport = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */],
    CommunicationIcon: AdvisorIcon["a" /* default */]
  }
})], FailureReportvue_type_script_lang_ts_FailureReport);
/* harmony default export */ var FailureReportvue_type_script_lang_ts = (FailureReportvue_type_script_lang_ts_FailureReport);
// CONCATENATED MODULE: ./src/components/failure-report/FailureReport.vue?vue&type=script&lang=ts
 /* harmony default export */ var failure_report_FailureReportvue_type_script_lang_ts = (FailureReportvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failure-report/FailureReport.vue?vue&type=style&index=0&id=7ed54e95&prod&lang=scss&scoped=true
var FailureReportvue_type_style_index_0_id_7ed54e95_prod_lang_scss_scoped_true = __webpack_require__("d0b6");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failure-report/FailureReport.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failure_report_FailureReportvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "7ed54e95",
  null
  
)

/* harmony default export */ var failure_report_FailureReport = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "2877":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "2a67":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2adc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorFloatingActions_vue_vue_type_style_index_0_id_5c94825d_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("84c7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorFloatingActions_vue_vue_type_style_index_0_id_5c94825d_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorFloatingActions_vue_vue_type_style_index_0_id_5c94825d_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "3157":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-accordion/FailuresAccordion.vue?vue&type=template&id=7a706d09&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion",attrs:{"id":'accordion-' + _vm.number}},[_c('div',{staticClass:"accordion__wrapper",class:{ closed: !_vm.open, disabled: _vm.disabled }},[_c('div',{staticClass:"accordion__top-line",on:{"click":_vm.toggle}},[_c('div'),_c('div',[_c('svg',{staticStyle:{"enable-background":"new 0 0 330 330"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 330 330","xml:space":"preserve"}},[_c('path',{attrs:{"id":"XMLID_225_","d":"M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393\n          c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393\n          s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"}})])]),_c('div')]),_c('div',{staticClass:"accordion__header",on:{"click":_vm.toggle}},[_c('div',{staticClass:"accordion__number"},[_c('div',[_vm._v(_vm._s(_vm.number))])]),_c('div',{staticClass:"accordion__title"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{ref:"header",staticClass:"accordion__header-slot"},[_vm._t("header")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}],ref:"content",staticClass:"accordion__content"},[_vm._t("content")],2)])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failures-accordion/FailuresAccordion.vue?vue&type=template&id=7a706d09&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-accordion/FailuresAccordion.vue?vue&type=script&lang=ts


let FailuresAccordionvue_type_script_lang_ts_FailuresAccordion = class FailuresAccordion extends vue_property_decorator["c" /* Vue */] {
  mounted() {
    this.onOpenChanged(this.open);
  }
  updated() {
    vue_property_decorator["c" /* Vue */].nextTick(() => {
      this.onOpenChanged(this.open);
    });
  }
  toggle() {
    if (this.disabled) return;
    this.$emit("toggle");
  }
  onOpenChanged(open) {
    this.open !== this.open;
    // const elem = this.$refs.content as HTMLElement;
    // if(elem !== undefined) {
    //   if (!open) {
    //     elem.style.maxHeight = "";
    //   } else {
    //     elem.style.maxHeight = elem.scrollHeight + "px";
    //   }
    // }
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Boolean
})], FailuresAccordionvue_type_script_lang_ts_FailuresAccordion.prototype, "open", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: String
})], FailuresAccordionvue_type_script_lang_ts_FailuresAccordion.prototype, "number", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: String
})], FailuresAccordionvue_type_script_lang_ts_FailuresAccordion.prototype, "title", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: false,
  type: Boolean
})], FailuresAccordionvue_type_script_lang_ts_FailuresAccordion.prototype, "disabled", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["d" /* Watch */])("open")], FailuresAccordionvue_type_script_lang_ts_FailuresAccordion.prototype, "onOpenChanged", null);
FailuresAccordionvue_type_script_lang_ts_FailuresAccordion = Object(tslib_es6["a" /* __decorate */])([vue_property_decorator["a" /* Component */]], FailuresAccordionvue_type_script_lang_ts_FailuresAccordion);
/* harmony default export */ var FailuresAccordionvue_type_script_lang_ts = (FailuresAccordionvue_type_script_lang_ts_FailuresAccordion);
// CONCATENATED MODULE: ./src/components/failures-accordion/FailuresAccordion.vue?vue&type=script&lang=ts
 /* harmony default export */ var failures_accordion_FailuresAccordionvue_type_script_lang_ts = (FailuresAccordionvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failures-accordion/FailuresAccordion.vue?vue&type=style&index=0&id=7a706d09&prod&lang=scss&scoped=true
var FailuresAccordionvue_type_style_index_0_id_7a706d09_prod_lang_scss_scoped_true = __webpack_require__("0dad");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failures-accordion/FailuresAccordion.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failures_accordion_FailuresAccordionvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "7a706d09",
  null
  
)

/* harmony default export */ var failures_accordion_FailuresAccordion = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "31d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-tab/AdvisorResultsLinkList.vue?vue&type=template&id=8e256c80&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advisor-results-link-list"},[(_vm.linkList.length > 0)?_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.linkList),function(item,index){return _c('li',{key:index},[_c('a',{staticClass:"link",attrs:{"href":item.link,"target":item.target}},[(item.icon !== '')?_c('advisor-icon',{attrs:{"name":item.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(item.title))])],1)])}),0):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-results-tab/AdvisorResultsLinkList.vue?vue&type=template&id=8e256c80&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-tab/AdvisorResultsLinkList.vue?vue&type=script&lang=ts



let AdvisorResultsLinkListvue_type_script_lang_ts_AdvisorResultsLinkList = class AdvisorResultsLinkList extends vue_property_decorator["c" /* Vue */] {};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorResultsLinkListvue_type_script_lang_ts_AdvisorResultsLinkList.prototype, "linkList", void 0);
AdvisorResultsLinkListvue_type_script_lang_ts_AdvisorResultsLinkList = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorResultsLinkListvue_type_script_lang_ts_AdvisorResultsLinkList);
/* harmony default export */ var AdvisorResultsLinkListvue_type_script_lang_ts = (AdvisorResultsLinkListvue_type_script_lang_ts_AdvisorResultsLinkList);
// CONCATENATED MODULE: ./src/components/advisor-results-tab/AdvisorResultsLinkList.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_results_tab_AdvisorResultsLinkListvue_type_script_lang_ts = (AdvisorResultsLinkListvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-results-tab/AdvisorResultsLinkList.vue?vue&type=style&index=0&id=8e256c80&prod&lang=scss
var AdvisorResultsLinkListvue_type_style_index_0_id_8e256c80_prod_lang_scss = __webpack_require__("118a");

// EXTERNAL MODULE: ./src/components/advisor-results-tab/AdvisorResultsLinkList.vue?vue&type=style&index=1&id=8e256c80&prod&lang=scss&scoped=true
var AdvisorResultsLinkListvue_type_style_index_1_id_8e256c80_prod_lang_scss_scoped_true = __webpack_require__("12c9");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-results-tab/AdvisorResultsLinkList.vue







/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_results_tab_AdvisorResultsLinkListvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "8e256c80",
  null
  
)

/* harmony default export */ var advisor_results_tab_AdvisorResultsLinkList = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "32e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-compare/AdvisorCompare.vue?vue&type=template&id=691b1baf&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"advisorCompare",staticClass:"advisor-compare",class:{ 'is-open': _vm.showDetails }},[_c('div',{staticClass:"advisor-compare-header",on:{"click":function($event){_vm.showDetails = !_vm.showDetails}}},[_c('h4',{staticClass:"compare-header--title"},[_vm._v(" "+_vm._s(_vm.$t("advisor_compare.title"))+" ("+_vm._s(_vm.compareItems.length)+") ")]),_c('div',{staticClass:"compare-header--toggle"},[_c('advisor-icon',{attrs:{"name":"left"}})],1)]),_c('div',{staticClass:"advisor-compare-content"},[_c('ul',{staticClass:"list-unstyled compare-list"},_vm._l((_vm.compareItems),function(compareItem,index){return _c('li',{key:index,staticClass:"compare-list-item"},[_c('span',[_vm._v(_vm._s(compareItem.title))]),_c('div',{staticClass:"compare-list--close",on:{"click":function($event){return _vm.compareItemRemove(index)}}},[_c('advisor-icon',{attrs:{"name":"close"}})],1)])}),0),_c('button',{staticClass:"btn btn-ev-pure-black btn-block btn-sm btn-icon justify-content-between",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('compareItems')}}},[_c('span',[_vm._v("Compare selection")]),_c('advisor-icon',{attrs:{"name":"faArrowRight"}})],1)])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-compare/AdvisorCompare.vue?vue&type=template&id=691b1baf&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-compare/AdvisorCompare.vue?vue&type=script&lang=ts



let AdvisorComparevue_type_script_lang_ts_AdvisorCompare = class AdvisorCompare extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.showDetails = false;
  }
  compareItemRemove(index) {
    this.$emit("compareItemRemove", index);
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: true
})], AdvisorComparevue_type_script_lang_ts_AdvisorCompare.prototype, "visible", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorComparevue_type_script_lang_ts_AdvisorCompare.prototype, "compareItems", void 0);
AdvisorComparevue_type_script_lang_ts_AdvisorCompare = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorComparevue_type_script_lang_ts_AdvisorCompare);
/* harmony default export */ var AdvisorComparevue_type_script_lang_ts = (AdvisorComparevue_type_script_lang_ts_AdvisorCompare);
// CONCATENATED MODULE: ./src/components/advisor-compare/AdvisorCompare.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_compare_AdvisorComparevue_type_script_lang_ts = (AdvisorComparevue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-compare/AdvisorCompare.vue?vue&type=style&index=0&id=691b1baf&prod&lang=scss&scoped=true
var AdvisorComparevue_type_style_index_0_id_691b1baf_prod_lang_scss_scoped_true = __webpack_require__("8625");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-compare/AdvisorCompare.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_compare_AdvisorComparevue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "691b1baf",
  null
  
)

/* harmony default export */ var advisor_compare_AdvisorCompare = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "3300":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresCardQuestion_vue_vue_type_style_index_0_id_036621e0_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c4ac");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresCardQuestion_vue_vue_type_style_index_0_id_036621e0_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresCardQuestion_vue_vue_type_style_index_0_id_036621e0_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "33ba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-info/FailuresInfo.vue?vue&type=template&id=1d5647fa&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"info"},[_c('advisor-icon',{attrs:{"name":"faInfo"}}),_c('div',{staticClass:"info__tooltip",class:{ right: _vm.right }},[_vm._t("default")],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failures-info/FailuresInfo.vue?vue&type=template&id=1d5647fa&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-info/FailuresInfo.vue?vue&type=script&lang=ts



let FailuresInfovue_type_script_lang_ts_FailuresInfo = class FailuresInfo extends vue_property_decorator["c" /* Vue */] {};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: false,
  type: Boolean
})], FailuresInfovue_type_script_lang_ts_FailuresInfo.prototype, "right", void 0);
FailuresInfovue_type_script_lang_ts_FailuresInfo = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], FailuresInfovue_type_script_lang_ts_FailuresInfo);
/* harmony default export */ var FailuresInfovue_type_script_lang_ts = (FailuresInfovue_type_script_lang_ts_FailuresInfo);
// CONCATENATED MODULE: ./src/components/failures-info/FailuresInfo.vue?vue&type=script&lang=ts
 /* harmony default export */ var failures_info_FailuresInfovue_type_script_lang_ts = (FailuresInfovue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failures-info/FailuresInfo.vue?vue&type=style&index=0&id=1d5647fa&prod&lang=scss&scoped=true
var FailuresInfovue_type_style_index_0_id_1d5647fa_prod_lang_scss_scoped_true = __webpack_require__("f04a");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failures-info/FailuresInfo.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failures_info_FailuresInfovue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "1d5647fa",
  null
  
)

/* harmony default export */ var failures_info_FailuresInfo = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "3511":
/***/ (function(module, exports) {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ "3610":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsItem_vue_vue_type_style_index_0_id_f4d5c746_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7eee");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsItem_vue_vue_type_style_index_0_id_f4d5c746_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsItem_vue_vue_type_style_index_0_id_f4d5c746_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3769":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3891":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-spinner/AdvisorSpinner.vue?vue&type=template&id=11a0560e&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"spinner"},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-rolling"},[_c('div')])}]


// CONCATENATED MODULE: ./src/components/advisor-spinner/AdvisorSpinner.vue?vue&type=template&id=11a0560e&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-spinner/AdvisorSpinner.vue?vue&type=script&lang=ts


let AdvisorSpinnervue_type_script_lang_ts_AdvisorSpinner = class AdvisorSpinner extends vue_property_decorator["c" /* Vue */] {};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: false
})], AdvisorSpinnervue_type_script_lang_ts_AdvisorSpinner.prototype, "visible", void 0);
AdvisorSpinnervue_type_script_lang_ts_AdvisorSpinner = Object(tslib_es6["a" /* __decorate */])([vue_property_decorator["a" /* Component */]], AdvisorSpinnervue_type_script_lang_ts_AdvisorSpinner);
/* harmony default export */ var AdvisorSpinnervue_type_script_lang_ts = (AdvisorSpinnervue_type_script_lang_ts_AdvisorSpinner);
// CONCATENATED MODULE: ./src/components/advisor-spinner/AdvisorSpinner.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_spinner_AdvisorSpinnervue_type_script_lang_ts = (AdvisorSpinnervue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-spinner/AdvisorSpinner.vue?vue&type=style&index=0&id=11a0560e&prod&scoped=true&lang=scss
var AdvisorSpinnervue_type_style_index_0_id_11a0560e_prod_scoped_true_lang_scss = __webpack_require__("b0bf");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-spinner/AdvisorSpinner.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_spinner_AdvisorSpinnervue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "11a0560e",
  null
  
)

/* harmony default export */ var advisor_spinner_AdvisorSpinner = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "399f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3a34":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var isArray = __webpack_require__("e8b5");

var $TypeError = TypeError;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es-x/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ "3a9b":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "3d27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failure-question/FailureQuestion.vue?vue&type=template&id=78a66bb3&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"failure-question"},[_c('div',{staticClass:"failure-question__wrapper"},[(!_vm.hasAnyOfAnswers(_vm.question.answers))?_c('div',[_c('div',{staticClass:"failure-question__question"},[(_vm.question.questionNumber.includes('.'))?_c('h4',{staticClass:"failure-question__title"},[_vm._v(" "+_vm._s(_vm.questionNumber)+". "+_vm._s(_vm.$t(_vm.question.i18nQuestion))+" ")]):_vm._e()])]):_vm._e(),(!_vm.hasAnyOfAnswers(_vm.question.answers))?_c('div',{staticClass:"failure-question__answers-list",class:{ 'answers-more-then-two': _vm.question.answers.length > 2 }},_vm._l((_vm.question.answers),function(answer){return _c('label',{key:answer.value,staticClass:"failure-question__answer-item",on:{"click":function($event){return _vm.$emit('answer', answer, _vm.question, _vm.parentQuestion)}}},[(answer.imgUrl !== '')?_c('div',{staticClass:"failure-question__image"},[_c('img',{attrs:{"src":answer.imgUrl}})]):_vm._e(),_c('div',{staticClass:"failure-question__answer-inner"},[_c('h3',{staticClass:"failure-question__answer-title"},[_vm._v(" "+_vm._s(_vm.$t(answer.i18nDescription))+" ")])])])}),0):_vm._e(),_c('div',_vm._l((_vm.question.answers),function(answer){return _c('div',{key:answer.value},[(answer.subQuestions.length > 0 && answer.isSelected)?_c('div',_vm._l((answer.subQuestions),function(subQuestion,index){return _c('failure-question',{key:index,attrs:{"question":subQuestion,"question-number":(_vm.questionNumber + "." + (index + 1)),"parent-question":_vm.question},on:{"answer":_vm.onSubQuestionAnswer}})}),1):_vm._e()])}),0)])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failure-question/FailureQuestion.vue?vue&type=template&id=78a66bb3&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failure-question/FailureQuestion.vue?vue&type=script&lang=ts



let FailureQuestionvue_type_script_lang_ts_FailureQuestion = class FailureQuestion extends vue_property_decorator["c" /* Vue */] {
  onSubQuestionAnswer(answer, question) {
    this.$emit("answer", answer, question, this.question);
  }
  hasAnyOfAnswers(answers) {
    return answers.filter(answer => answer.isSelected).length == 1;
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailureQuestionvue_type_script_lang_ts_FailureQuestion.prototype, "parentQuestion", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailureQuestionvue_type_script_lang_ts_FailureQuestion.prototype, "question", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailureQuestionvue_type_script_lang_ts_FailureQuestion.prototype, "questionNumber", void 0);
FailureQuestionvue_type_script_lang_ts_FailureQuestion = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  name: "FailureQuestion",
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], FailureQuestionvue_type_script_lang_ts_FailureQuestion);
/* harmony default export */ var FailureQuestionvue_type_script_lang_ts = (FailureQuestionvue_type_script_lang_ts_FailureQuestion);
// CONCATENATED MODULE: ./src/components/failure-question/FailureQuestion.vue?vue&type=script&lang=ts
 /* harmony default export */ var failure_question_FailureQuestionvue_type_script_lang_ts = (FailureQuestionvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failure-question/FailureQuestion.vue?vue&type=style&index=0&id=78a66bb3&prod&lang=scss&scoped=true
var FailureQuestionvue_type_style_index_0_id_78a66bb3_prod_lang_scss_scoped_true = __webpack_require__("f283");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failure-question/FailureQuestion.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failure_question_FailureQuestionvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "78a66bb3",
  null
  
)

/* harmony default export */ var failure_question_FailureQuestion = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "3d8c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StepEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StepType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StepProgress; });
var StepEvent;
(function (StepEvent) {
  StepEvent["PREVIOUS"] = "previous";
  StepEvent["NEXT"] = "next";
  StepEvent["STEP"] = "step";
})(StepEvent || (StepEvent = {}));
var StepType;
(function (StepType) {
  StepType["HOME"] = "home";
  StepType["QUESTION"] = "question";
  StepType["ADVISE"] = "advise";
})(StepType || (StepType = {}));
var StepProgress;
(function (StepProgress) {
  StepProgress["UNANSWERED"] = "unanswered";
  StepProgress["ACTIVE"] = "active";
  StepProgress["SKIPPED"] = "skipped";
  StepProgress["COMPLETED"] = "completed";
})(StepProgress || (StepProgress = {}));

/***/ }),

/***/ "3e2b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3faa":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 640 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M320 0c17.7 0 32 14.3 32 32v17.7C483.8 63.4 589.7 161 605.9 285.9c2 15.6-17.3 24.4-27.8 12.7-14-15.6-41.3-26.6-66.1-26.6-38.7 0-71 27.5-78.4 64.1-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C391 299.5 358.7 272 320 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C199 299.5 166.7 272 128 272c-24.8 0-52.1 11-66.1 26.7-10.5 11.7-29.8 2.9-27.8-12.7C50.3 161 156.2 63.4 288 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2v114.4c0 45-36.5 81.4-81.4 81.4-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6 9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"
      }
    })]));
  }
};

/***/ }),

/***/ "404b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "40d5":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "4699":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorBreadcrumb_vue_vue_type_style_index_0_id_400001a0_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6cb6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorBreadcrumb_vue_vue_type_style_index_0_id_400001a0_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorBreadcrumb_vue_vue_type_style_index_0_id_400001a0_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "485a":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "48d0":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 384 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M0 64C0 28.7 28.7 0 64 0h160v128c0 17.7 14.3 32 32 32h128v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0l128 128z"
      }
    })]));
  }
};

/***/ }),

/***/ "4c34":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 18 18",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-70 -83)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/telephone",
        "transform": "translate(70 83)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M17.537 13.276l-2.238-2.237a1.584 1.584 0 00-2.238 0l-1.017 1.017a1.2 1.2 0 01-1.695 0L5.94 7.643a1.198 1.198 0 010-1.695l1.018-1.017a1.581 1.581 0 00-.001-2.238L4.72.463A1.584 1.584 0 002.484.46l-.815.809a5.712 5.712 0 000 8.069l6.985 6.988a5.702 5.702 0 008.069 0l.814-.813a1.584 1.584 0 000-2.238zM3.228 1.21a.528.528 0 01.747 0l2.237 2.23a.527.527 0 010 .746l-.373.373-2.982-2.981.371-.368zM9.4 15.582l-6.986-6.99a4.637 4.637 0 01-.29-6.257l2.972 2.973a2.251 2.251 0 00.098 3.081l4.409 4.412c.846.846 2.195.88 3.082.099l2.973 2.973a4.628 4.628 0 01-6.258-.291zm7.39-.814l-.372.373-2.984-2.984.373-.373a.528.528 0 01.746 0l2.238 2.238a.528.528 0 010 .746z",
        "id": "Shape"
      }
    })])])])]));
  }
};

/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5380":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-root-cause-list/FailuresRootCauseList.vue?vue&type=template&id=7e756ee7&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-causes"},[_vm._l((_vm.causes),function(option,index){return _c('div',{key:index,staticClass:"root-causes__item",class:{
      'root-causes__item--disabled':
        _vm.selected.length === _vm.maxSelectableItems && !_vm.selected.includes(index)
    }},[_c('label',{staticClass:"root-causes__label",attrs:{"for":index}},[_c('div',{staticClass:"checkbox-wrapper"},[_c('input',{staticClass:"root-causes__input",attrs:{"type":"checkbox","id":index,"disabled":_vm.selected.length === _vm.maxSelectableItems &&
              !_vm.selected.includes(index)},domProps:{"checked":_vm.selected.includes(index)},on:{"change":function($event){return _vm.valueSelected(index)}}}),_c('span',{staticClass:"checkmark checkmark--white"})]),_c('div',{staticClass:"root-causes__content-wrapper"},[_c('span',{staticClass:"root-causes__name"},[_vm._v(" "+_vm._s(option.name)+" ")]),_c('span',{staticClass:"root-causes__phase"},[_vm._v(" "+_vm._s(option.phase)+" ")])])])])}),_c('div',{staticClass:"root-causes__button"},[_c('button',{staticClass:"btn btn-ev-primary btn-md btn-icon",attrs:{"type":"button","disabled":!(_vm.selected.length >= 1)},on:{"click":_vm.onButtonClick}},[_c('span',[_vm._v("Go next step")]),_c('advisor-icon',{attrs:{"name":"faArrowRight"}})],1)])],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failures-root-cause-list/FailuresRootCauseList.vue?vue&type=template&id=7e756ee7&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-root-cause-list/FailuresRootCauseList.vue?vue&type=script&lang=ts



let FailuresRootCauseListvue_type_script_lang_ts_FailureRootCauseList = class FailureRootCauseList extends vue_property_decorator["c" /* Vue */] {
  valueSelected(value) {
    this.$emit("valueChanged", value);
  }
  onButtonClick() {
    for (let i = 0; i < this.selected.length; i++) {
      const index = this.selected[i];
      this.causes[index].isSelected = true;
    }
    this.$emit("rootCasesClick");
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Array(Object)
})], FailuresRootCauseListvue_type_script_lang_ts_FailureRootCauseList.prototype, "causes", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Array(Number)
})], FailuresRootCauseListvue_type_script_lang_ts_FailureRootCauseList.prototype, "selected", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Number
})], FailuresRootCauseListvue_type_script_lang_ts_FailureRootCauseList.prototype, "maxSelectableItems", void 0);
FailuresRootCauseListvue_type_script_lang_ts_FailureRootCauseList = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], FailuresRootCauseListvue_type_script_lang_ts_FailureRootCauseList);
/* harmony default export */ var FailuresRootCauseListvue_type_script_lang_ts = (FailuresRootCauseListvue_type_script_lang_ts_FailureRootCauseList);
// CONCATENATED MODULE: ./src/components/failures-root-cause-list/FailuresRootCauseList.vue?vue&type=script&lang=ts
 /* harmony default export */ var failures_root_cause_list_FailuresRootCauseListvue_type_script_lang_ts = (FailuresRootCauseListvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failures-root-cause-list/FailuresRootCauseList.vue?vue&type=style&index=0&id=7e756ee7&prod&lang=scss&scoped=true
var FailuresRootCauseListvue_type_style_index_0_id_7e756ee7_prod_lang_scss_scoped_true = __webpack_require__("1e38");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failures-root-cause-list/FailuresRootCauseList.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failures_root_cause_list_FailuresRootCauseListvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "7e756ee7",
  null
  
)

/* harmony default export */ var FailuresRootCauseList = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.25.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.25.2/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "581a":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 320 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9S301 191.9 288 191.9L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
      }
    })]));
  }
};

/***/ }),

/***/ "5926":
/***/ (function(module, exports, __webpack_require__) {

var trunc = __webpack_require__("b42e");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "5937":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "59ed":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var tryToString = __webpack_require__("0d51");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5e77":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var hasOwn = __webpack_require__("1a2d");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "5f22":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 27 27",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Artboard",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "help",
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    }, [_c('path', {
      attrs: {
        "d": "M26.4 17.866a8.553 8.553 0 00-6.25-8.223C19.922 4.287 15.493 0 10.08 0 4.522 0 0 4.522 0 10.08c0 1.812.482 3.576 1.398 5.124l-1.36 4.92 4.919-1.36a10.043 10.043 0 004.686 1.386 8.553 8.553 0 008.223 6.25c1.536 0 3.03-.41 4.343-1.186l4.154 1.149-1.15-4.154a8.503 8.503 0 001.187-4.343zm-21.2-.775l-2.944.814.814-2.945-.185-.29a8.505 8.505 0 01-1.338-4.59c0-4.705 3.828-8.533 8.533-8.533 4.706 0 8.534 3.828 8.534 8.533 0 4.706-3.828 8.534-8.534 8.534a8.505 8.505 0 01-4.589-1.338l-.29-.185zm18.944 7.053l-2.185-.604-.292.19a6.96 6.96 0 01-3.8 1.123 7.004 7.004 0 01-6.624-4.76c4.631-.533 8.317-4.219 8.85-8.85a7.005 7.005 0 014.76 6.623 6.96 6.96 0 01-1.123 3.801l-.19.292.604 2.185z",
        "id": "Shape"
      }
    })])])]));
  }
};

/***/ }),

/***/ "5fac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-item/AdvisorResultsItem.vue?vue&type=template&id=f4d5c746&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"advisor-results-item",class:_vm.resultsItemClass,attrs:{"id":'item-' + _vm.item.id}},[_c('div',{staticClass:"item-header",on:{"click":function($event){return _vm.toggleItem($event)}}},[_c('div',{staticClass:"item-header--match"},[_c('span',[_vm._v(_vm._s(_vm.item.matchScore)+"%")])]),_c('div',{staticClass:"item-header--title"},[_c('h3',{staticClass:"header"},[_c('a',{attrs:{"href":_vm.item.url,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(_vm.item.title))]),_c('advisor-icon',{attrs:{"name":"external"}})],1)])]),_c('div',{staticClass:"item-header--separator"}),_c('div',{staticClass:"item-header--match-sm"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t("results_item.match_score")))]),_c('span',{staticClass:"value"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"inner",style:(_vm.setProgressMatchScore(_vm.item.matchScore))},[_vm._v(" "+_vm._s(_vm.item.matchScore)+"% ")])])])]),_c('div',{staticClass:"item-header--polymer"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t("results_item.polymer")))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.item.polymer))])]),_c('div',{staticClass:"item-header--separator"}),_c('div',{staticClass:"item-header--processing"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t("results_item.processing_technology")))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.item.processing))])]),_c('div',{staticClass:"item-header--separator"}),_c('div',{staticClass:"item-header--special"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t("results_item.special_features")))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.item.special))])]),_c('div',{staticClass:"item-header--separator"}),_c('div',{staticClass:"item-header--compare"},[_c('label',{class:{ disabled: !_vm.allowedToCompare(_vm.item.id) }},[_c('input',{attrs:{"type":"checkbox","disabled":!_vm.allowedToCompare(_vm.item.id)},domProps:{"value":_vm.item.id,"checked":_vm.compareExists(_vm.item.id)},on:{"change":function($event){return _vm.compareItem($event)}}}),_vm._v(" "+_vm._s(_vm.$t("results_item.compare"))+" ")])]),_c('div',{staticClass:"item-header--toggle"},[_c('advisor-icon',{attrs:{"name":"left"}})],1)]),(_vm.item.active || _vm.showDetails)?_c('div',{staticClass:"item-content"},[_vm._t("default")],2):_vm._e()])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-results-item/AdvisorResultsItem.vue?vue&type=template&id=f4d5c746&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-item/AdvisorResultsItem.vue?vue&type=script&lang=ts



let AdvisorResultsItemvue_type_script_lang_ts_AdvisorResultsItem = class AdvisorResultsItem extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.showDetails = false;
    this.activeItem = "home";
  }
  get resultsItemClass() {
    let cssClass = "";
    if (this.item.active || this.showDetails) {
      cssClass = "is-active";
    }
    if (parseInt(this.item.matchScore) > parseInt(this.scoreMap[2])) {
      cssClass += " is-match-high";
    } else if (parseInt(this.item.matchScore) > parseInt(this.scoreMap[1])) {
      cssClass += " is-match-medium";
    } else {
      cssClass += " is-match-low";
    }
    return cssClass;
  }
  setProgressMatchScore(score) {
    return "right:" + (100 - score) + "px;";
  }
  toggleItem(e) {
    if (e.target.nodeName !== "A" && e.target.nodeName !== "INPUT" && e.target.nodeName !== "LABEL") {
      this.showDetails = !this.showDetails;
      this.$emit("toggleItem");
    }
  }
  allowedToCompare(item) {
    const allowed = false;
    const compareItemExists = this.compareItems.some(compareItem => compareItem.id === item);
    if (this.compareItems.length < this.compareMax || compareItemExists) {
      return true;
    }
    return allowed;
  }
  compareExists(item) {
    return this.compareItems.some(compareItem => compareItem.id === item);
  }
  compareItem(e) {
    const CompareItem = {
      id: "",
      title: ""
    };
    CompareItem.id = this.item.id;
    CompareItem.title = this.item.title;
    const checked = e.target.checked;
    this.$emit("compareItem", checked, CompareItem);
  }
  isActive(menuItem) {
    return this.activeItem === menuItem;
  }
  setActive(menuItem) {
    this.activeItem = menuItem;
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: false
})], AdvisorResultsItemvue_type_script_lang_ts_AdvisorResultsItem.prototype, "multiple", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: () => [0, 50, 70],
  type: Array
})], AdvisorResultsItemvue_type_script_lang_ts_AdvisorResultsItem.prototype, "scoreMap", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorResultsItemvue_type_script_lang_ts_AdvisorResultsItem.prototype, "item", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorResultsItemvue_type_script_lang_ts_AdvisorResultsItem.prototype, "compareItems", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: 5
})], AdvisorResultsItemvue_type_script_lang_ts_AdvisorResultsItem.prototype, "compareMax", void 0);
AdvisorResultsItemvue_type_script_lang_ts_AdvisorResultsItem = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorResultsItemvue_type_script_lang_ts_AdvisorResultsItem);
/* harmony default export */ var AdvisorResultsItemvue_type_script_lang_ts = (AdvisorResultsItemvue_type_script_lang_ts_AdvisorResultsItem);
// CONCATENATED MODULE: ./src/components/advisor-results-item/AdvisorResultsItem.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_results_item_AdvisorResultsItemvue_type_script_lang_ts = (AdvisorResultsItemvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-results-item/AdvisorResultsItem.vue?vue&type=style&index=0&id=f4d5c746&prod&lang=scss&scoped=true
var AdvisorResultsItemvue_type_style_index_0_id_f4d5c746_prod_lang_scss_scoped_true = __webpack_require__("3610");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-results-item/AdvisorResultsItem.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_results_item_AdvisorResultsItemvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "f4d5c746",
  null
  
)

/* harmony default export */ var advisor_results_item_AdvisorResultsItem = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "60a3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ vue_class_component_esm; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ external_commonjs_vue_commonjs2_vue_root_Vue_default.a; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Prop; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ Watch; });

// UNUSED EXPORTS: Mixins, Inject, InjectReactive, Provide, ProvideReactive, Model, PropSync, Emit, Ref

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) {}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof external_commonjs_vue_commonjs2_vue_root_Vue_default.a ? superProto.constructor : external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = [// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter'];
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) {}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function vue_class_component_esm_Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

vue_class_component_esm_Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (vue_class_component_esm_Component);


// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js
/** vue-property-decorator verson 8.5.1 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>




/** Used for keying reactive provide/inject properties */
var reactiveInjectKey = '__reactiveInject__';
/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}
/**
 * decorator of a reactive inject
 * @param from key
 * @return PropertyDecorator
 */
function InjectReactive(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            var fromKey_1 = !!options ? options.from || options : key;
            var defaultVal_1 = (!!options && options.default) || undefined;
            if (!componentOptions.computed)
                componentOptions.computed = {};
            componentOptions.computed[key] = function () {
                var obj = this[reactiveInjectKey];
                return obj ? obj[fromKey_1] : defaultVal_1;
            };
            componentOptions.inject[reactiveInjectKey] = reactiveInjectKey;
        }
    });
}
function produceProvide(original) {
    var provide = function () {
        var _this = this;
        var rv = typeof original === 'function' ? original.call(this) : original;
        rv = Object.create(rv || null);
        // set reactive services (propagates previous services if necessary)
        rv[reactiveInjectKey] = this[reactiveInjectKey] || {};
        for (var i in provide.managed) {
            rv[provide.managed[i]] = this[i];
        }
        var _loop_1 = function (i) {
            rv[provide.managedReactive[i]] = this_1[i]; // Duplicates the behavior of `@Provide`
            Object.defineProperty(rv[reactiveInjectKey], provide.managedReactive[i], {
                enumerable: true,
                get: function () { return _this[i]; },
            });
        };
        var this_1 = this;
        for (var i in provide.managedReactive) {
            _loop_1(i);
        }
        return rv;
    };
    provide.managed = {};
    provide.managedReactive = {};
    return provide;
}
function needToProduceProvide(original) {
    return (typeof original !== 'function' ||
        (!original.managed && !original.managedReactive));
}
/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managed[k] = key || k;
    });
}
/**
 * decorator of a reactive provide
 * @param key key
 * @return PropertyDecorator | void
 */
function ProvideReactive(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        // inject parent reactive services (if any)
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject = componentOptions.inject || {};
            componentOptions.inject[reactiveInjectKey] = {
                from: reactiveInjectKey,
                default: {},
            };
        }
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managedReactive[k] = key || k;
    });
}
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}
/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    // @ts-ignore
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, [emitName].concat(args));
                    }
                }
                else {
                    if (args.length === 0) {
                        _this.$emit(emitName, returnValue);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, returnValue, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, [emitName, returnValue].concat(args));
                    }
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
/**
 * decorator of a ref prop
 * @param refKey the ref key defined in template
 */
function Ref(refKey) {
    return createDecorator(function (options, key) {
        options.computed = options.computed || {};
        options.computed[key] = {
            cache: false,
            get: function () {
                return this.$refs[refKey || key];
            },
        };
    });
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}


/***/ }),

/***/ "6275":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h306.7L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
      }
    })]));
  }
};

/***/ }),

/***/ "629d":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 23 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-1393 -153)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/save",
        "transform": "translate(1393 152)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M20.312 24.625a2.437 2.437 0 002.438-2.437V8.572c0-.557-.32-1.33-.714-1.723l-4.26-4.26c-.394-.394-1.166-.714-1.723-.714H2.437A2.437 2.437 0 000 4.313v17.875a2.437 2.437 0 002.437 2.437h17.875zm-4.671-13H3.859a.61.61 0 01-.609-.61v-5.28a.61.61 0 01.61-.61h11.604a.61.61 0 01.43.179l.177.176a.7.7 0 01.179.431v5.105a.61.61 0 01-.61.609zm-4.266 9.75a3.25 3.25 0 110-6.5 3.25 3.25 0 010 6.5z",
        "id": ""
      }
    })])])])]));
  }
};

/***/ }),

/***/ "62ad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-tab/AdvisorResultsButtonList.vue?vue&type=template&id=e35f8f8e&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advisor-results-button-list"},[(_vm.linkList.length > 0)?_c('div',{staticClass:"buttons-group"},_vm._l((_vm.linkList),function(item,index){return _c('button',{key:index,staticClass:"btn btn-md  btn-icon",class:index === 0 ? 'btn-ev-primary' : 'btn-ev-blueberry-teal',attrs:{"type":"button"},on:{"click":function($event){return _vm.link(item)}}},[_c('span',[_vm._v(_vm._s(item.title))]),(item.icon !== '')?_c('advisor-icon',{attrs:{"name":item.icon}}):_vm._e()],1)}),0):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-results-tab/AdvisorResultsButtonList.vue?vue&type=template&id=e35f8f8e&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-tab/AdvisorResultsButtonList.vue?vue&type=script&lang=ts



let AdvisorResultsButtonListvue_type_script_lang_ts_AdvisorResultsButtonList = class AdvisorResultsButtonList extends vue_property_decorator["c" /* Vue */] {
  link(btn) {
    if (btn.link.indexOf("router:") !== -1) {
      this.$emit("routerLink", btn.link.substring(btn.link.lastIndexOf(":") + 1));
    } else if (btn.link.indexOf("iframe:") !== -1) {
      this.$emit("iframeLink", btn, this.param);
    } else {
      window.open(btn.link, btn.target);
    }
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorResultsButtonListvue_type_script_lang_ts_AdvisorResultsButtonList.prototype, "linkList", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorResultsButtonListvue_type_script_lang_ts_AdvisorResultsButtonList.prototype, "param", void 0);
AdvisorResultsButtonListvue_type_script_lang_ts_AdvisorResultsButtonList = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorResultsButtonListvue_type_script_lang_ts_AdvisorResultsButtonList);
/* harmony default export */ var AdvisorResultsButtonListvue_type_script_lang_ts = (AdvisorResultsButtonListvue_type_script_lang_ts_AdvisorResultsButtonList);
// CONCATENATED MODULE: ./src/components/advisor-results-tab/AdvisorResultsButtonList.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_results_tab_AdvisorResultsButtonListvue_type_script_lang_ts = (AdvisorResultsButtonListvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-results-tab/AdvisorResultsButtonList.vue?vue&type=style&index=0&id=e35f8f8e&prod&lang=scss
var AdvisorResultsButtonListvue_type_style_index_0_id_e35f8f8e_prod_lang_scss = __webpack_require__("e9bd");

// EXTERNAL MODULE: ./src/components/advisor-results-tab/AdvisorResultsButtonList.vue?vue&type=style&index=1&id=e35f8f8e&prod&lang=scss&scoped=true
var AdvisorResultsButtonListvue_type_style_index_1_id_e35f8f8e_prod_lang_scss_scoped_true = __webpack_require__("965f");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-results-tab/AdvisorResultsButtonList.vue







/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_results_tab_AdvisorResultsButtonListvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "e35f8f8e",
  null
  
)

/* harmony default export */ var advisor_results_tab_AdvisorResultsButtonList = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "6374":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "63e6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-condensed-options/FailuresCondensedOptions.vue?vue&type=template&id=53966c1c&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options"},_vm._l((_vm.options),function(value,index){return _c('div',{key:index,staticClass:"options__item",class:{ selected: _vm.isSelected(index) },on:{"click":function($event){return _vm.valueChanged(index)}}},[_vm._v(" "+_vm._s(value)+" ")])}),0)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failures-condensed-options/FailuresCondensedOptions.vue?vue&type=template&id=53966c1c&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-condensed-options/FailuresCondensedOptions.vue?vue&type=script&lang=ts


let FailuresCondensedOptionsvue_type_script_lang_ts_FailuresCondensedOptions = class FailuresCondensedOptions extends vue_property_decorator["c" /* Vue */] {
  valueChanged(value) {
    this.$emit("valueChanged", value);
  }
  isSelected(value) {
    if (typeof this.selected === "number") {
      return this.selected === value;
    } else if (Array.isArray(this.selected)) {
      return this.selected.indexOf(value) != -1;
    }
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Array
})], FailuresCondensedOptionsvue_type_script_lang_ts_FailuresCondensedOptions.prototype, "options", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: [Array, Number]
})], FailuresCondensedOptionsvue_type_script_lang_ts_FailuresCondensedOptions.prototype, "selected", void 0);
FailuresCondensedOptionsvue_type_script_lang_ts_FailuresCondensedOptions = Object(tslib_es6["a" /* __decorate */])([vue_property_decorator["a" /* Component */]], FailuresCondensedOptionsvue_type_script_lang_ts_FailuresCondensedOptions);
/* harmony default export */ var FailuresCondensedOptionsvue_type_script_lang_ts = (FailuresCondensedOptionsvue_type_script_lang_ts_FailuresCondensedOptions);
// CONCATENATED MODULE: ./src/components/failures-condensed-options/FailuresCondensedOptions.vue?vue&type=script&lang=ts
 /* harmony default export */ var failures_condensed_options_FailuresCondensedOptionsvue_type_script_lang_ts = (FailuresCondensedOptionsvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failures-condensed-options/FailuresCondensedOptions.vue?vue&type=style&index=0&id=53966c1c&prod&lang=scss&scoped=true
var FailuresCondensedOptionsvue_type_style_index_0_id_53966c1c_prod_lang_scss_scoped_true = __webpack_require__("20f7");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failures-condensed-options/FailuresCondensedOptions.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failures_condensed_options_FailuresCondensedOptionsvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "53966c1c",
  null
  
)

/* harmony default export */ var failures_condensed_options_FailuresCondensedOptions = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "6466":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6619":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("cdce");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var hasOwn = __webpack_require__("1a2d");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "69fd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-item-rd/AdvisorResultsItemRd.vue?vue&type=template&id=7900db05&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"advisor-results-item-rd",class:_vm.resultsItemClass,attrs:{"id":'item-' + _vm.item.id}},[_c('div',{staticClass:"item-header",on:{"click":function($event){return _vm.toggleItem($event)}}},[_c('div',{staticClass:"item-header--compare"},[_c('label',{staticClass:"checkbox-wrapper",class:{ disabled: !_vm.allowedToCompare(_vm.item.id) }},[_c('input',{attrs:{"type":"checkbox","disabled":!_vm.allowedToCompare(_vm.item.id)},domProps:{"value":_vm.item.id,"checked":_vm.compareExists(_vm.item.id)},on:{"change":function($event){return _vm.compareItem($event)}}}),_c('span',{staticClass:"checkmark"})])]),_c('div',{staticClass:"item-header--title"},[_c('h3',{staticClass:"header"},[_c('a',{attrs:{"href":_vm.item.url,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(_vm.item.title))]),_c('advisor-icon',{attrs:{"name":"faArrowRight"}})],1)]),_c('div',{staticClass:"polymer"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t("results_item.polymer"))+": ")]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.item.polymer))])]),_c('div',{staticClass:"features"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t("results_item.features"))+": ")]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.item.special))])])]),_c('div',{staticClass:"item-header--separator"}),_c('div',{staticClass:"item-header--answers"},[_c('div',{staticClass:"answers"},[_vm._l((_vm.answersInChunks),function(chunck,i){return _c('div',{key:'column-' + i,staticClass:"answers-column"},[_vm._l((chunck),function(match,j){return _c('div',{key:j,staticClass:"answer",class:{
                'is-match': match.match,
                'is-unanswered': match.your_answer === '-'
              }},[_c('div',{staticClass:"match-score-icon"},[(match.match)?_c('advisor-icon',{attrs:{"name":"checkmark"}}):_c('advisor-icon',{attrs:{"name":"close"}})],1),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t(match.label))),_c('span',[_vm._v(":")])]),_c('span',{staticClass:"your-answer",attrs:{"title":_vm.$t(match.your_answer)}},[_vm._v(_vm._s(_vm.$t(match.your_answer)))])])}),(_vm.answersInChunks.length - 1 === i && _vm.refineQuestions)?_c('span',{staticClass:"answer-toggle"},[_vm._v(_vm._s(_vm.$t("results_item.score_card")))]):_vm._e()],2)}),_vm._l((_vm.matchScore),function(match,j){return _c('div',{key:j,staticClass:"answer answer-sm",class:{
              'is-match': match.match,
              'is-unanswered': match.your_answer === '-'
            }},[_c('div',{staticClass:"match-score-icon"},[(match.match)?_c('advisor-icon',{attrs:{"name":"checkmark"}}):_c('advisor-icon',{attrs:{"name":"close"}})],1),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t(match.label))),_c('span',[_vm._v(":")])])])})],2)]),_c('div',{staticClass:"item-header--match"},[_c('span',[_vm._v(_vm._s(_vm.item.matchScore)+"%")]),_c('advisor-icon',{attrs:{"name":"left"}})],1)]),(_vm.item.active || _vm.showDetails)?_c('div',{staticClass:"item-content"},[_vm._t("default")],2):_vm._e()])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-results-item-rd/AdvisorResultsItemRd.vue?vue&type=template&id=7900db05&scoped=true

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("14d9");

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-item-rd/AdvisorResultsItemRd.vue?vue&type=script&lang=ts




let AdvisorResultsItemRdvue_type_script_lang_ts_AdvisorResultsItemRd = class AdvisorResultsItemRd extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.showDetails = false;
    this.activeItem = "home";
  }
  get resultsItemClass() {
    let cssClass = "";
    if (this.item.active || this.showDetails) {
      cssClass = "is-active";
    }
    if (parseInt(this.item.matchScore) >= parseInt(this.scoreMap[2])) {
      cssClass += " is-match-high";
    } else if (parseInt(this.item.matchScore) >= parseInt(this.scoreMap[1])) {
      cssClass += " is-match-medium";
    } else if (parseInt(this.item.matchScore) >= parseInt(this.scoreMap[0])) {
      cssClass += " is-match-low";
    } else {
      cssClass += " is-match-very-low";
    }
    return cssClass;
  }
  get answersInChunks() {
    const results = [];
    const chunk = 3;
    if (this.matchScore) {
      const items = this.matchScore;
      if (items.length > 0) {
        for (let i = 0; i < items.length; i += chunk) {
          const item = items.slice(i, i + chunk);
          if (typeof item !== "undefined") {
            results.push(item);
          }
        }
      }
    }
    return results;
  }
  setProgressMatchScore(score) {
    return "right:" + (100 - score) + "px;";
  }
  toggleItem(e) {
    if (e.target.nodeName !== "A" && e.target.nodeName !== "INPUT" && e.target.nodeName !== "LABEL" && e.target.className !== "checkmark") {
      this.showDetails = !this.showDetails;
      this.$emit("toggleItem");
    }
  }
  allowedToCompare(item) {
    const allowed = false;
    const compareItemExists = this.compareItems.some(compareItem => compareItem.id === item);
    if (this.compareItems.length < this.compareMax || compareItemExists) {
      return true;
    }
    return allowed;
  }
  compareExists(item) {
    return this.compareItems.some(compareItem => compareItem.id === item);
  }
  compareItem(e) {
    const CompareItem = {
      id: "",
      title: ""
    };
    CompareItem.id = this.item.id;
    CompareItem.title = this.item.title;
    const checked = e.target.checked;
    this.$emit("compareItem", checked, CompareItem);
  }
  isActive(menuItem) {
    return this.activeItem === menuItem;
  }
  setActive(menuItem) {
    this.activeItem = menuItem;
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: false
})], AdvisorResultsItemRdvue_type_script_lang_ts_AdvisorResultsItemRd.prototype, "multiple", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: () => [50, 70, 100],
  type: Array
})], AdvisorResultsItemRdvue_type_script_lang_ts_AdvisorResultsItemRd.prototype, "scoreMap", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorResultsItemRdvue_type_script_lang_ts_AdvisorResultsItemRd.prototype, "item", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorResultsItemRdvue_type_script_lang_ts_AdvisorResultsItemRd.prototype, "matchScore", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: false
})], AdvisorResultsItemRdvue_type_script_lang_ts_AdvisorResultsItemRd.prototype, "refineQuestions", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorResultsItemRdvue_type_script_lang_ts_AdvisorResultsItemRd.prototype, "compareItems", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: 5
})], AdvisorResultsItemRdvue_type_script_lang_ts_AdvisorResultsItemRd.prototype, "compareMax", void 0);
AdvisorResultsItemRdvue_type_script_lang_ts_AdvisorResultsItemRd = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorResultsItemRdvue_type_script_lang_ts_AdvisorResultsItemRd);
/* harmony default export */ var AdvisorResultsItemRdvue_type_script_lang_ts = (AdvisorResultsItemRdvue_type_script_lang_ts_AdvisorResultsItemRd);
// CONCATENATED MODULE: ./src/components/advisor-results-item-rd/AdvisorResultsItemRd.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_results_item_rd_AdvisorResultsItemRdvue_type_script_lang_ts = (AdvisorResultsItemRdvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-results-item-rd/AdvisorResultsItemRd.vue?vue&type=style&index=0&id=7900db05&prod&lang=scss&scoped=true
var AdvisorResultsItemRdvue_type_style_index_0_id_7900db05_prod_lang_scss_scoped_true = __webpack_require__("2524");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-results-item-rd/AdvisorResultsItemRd.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_results_item_rd_AdvisorResultsItemRdvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "7900db05",
  null
  
)

/* harmony default export */ var advisor_results_item_rd_AdvisorResultsItemRd = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "6ad2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorTab_vue_vue_type_style_index_0_id_3c97b63c_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5937");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorTab_vue_vue_type_style_index_0_id_3c97b63c_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorTab_vue_vue_type_style_index_0_id_3c97b63c_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6b75":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6b8b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6bd5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorShare_vue_vue_type_style_index_0_id_e28a02f8_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fb41");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorShare_vue_vue_type_style_index_0_id_e28a02f8_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorShare_vue_vue_type_style_index_0_id_e28a02f8_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6cb6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6e04":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-refine-question/AdvisorRefineQuestion.vue?vue&type=template&id=3bc14c1e&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"advisor-refine-question-sm",class:{ 'is-answered': _vm.userAnswer }},[_c('div',{staticClass:"filter-toggle"},[_c('advisor-icon',{attrs:{"name":"left"}})],1),_c('div',{staticClass:"refine-question-header",on:{"click":function($event){_vm.showAnswers = !_vm.showAnswers}}},[_c('h2',[_vm._v(" "+_vm._s(_vm.questionIndex)+". "+_vm._s(_vm.$t(_vm.question.i18nShortQuestion))),(_vm.userAnswer)?_c('span',[_vm._v(": "+_vm._s(_vm.userAnswer))]):_vm._e()])]),(_vm.showAnswers)?_c('div',{staticClass:"refine-question-content"},[_c('div',{staticClass:"refine-question-content--question"},[_vm._v(" "+_vm._s(_vm.$t(_vm.question.i18nQuestion))+" ")]),_c('div',{staticClass:"refine-question-content--answers"},_vm._l((_vm.question.answers),function(answer){return _c('button',{key:answer.value,staticClass:"btn btn-sm",class:answer.value === _vm.userAnswer
              ? 'btn-primary'
              : 'btn-outline-primary',on:{"click":function($event){return _vm.handleClick('answer', answer)}}},[_vm._v(" "+_vm._s(_vm.$t(answer.i18nDescription))+" ")])}),0)]):_vm._e()]),_c('div',{staticClass:"advisor-refine-question"},[_c('label',{staticClass:"refine-question"},[_vm._v(_vm._s(_vm.$t(_vm.question.i18nQuestion)))]),_c('div',{staticClass:"refine-answer custom-selectbox"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userAnswer),expression:"userAnswer"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.userAnswer=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.handleClickOnchange]}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t("refine.select_your_answer")))]),_vm._l((_vm.question.answers),function(qAnswer){return _c('option',{key:qAnswer.value,domProps:{"value":qAnswer.value}},[_vm._v(" "+_vm._s(_vm.$t(qAnswer.i18nDescription))+" ")])})],2)])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-refine-question/AdvisorRefineQuestion.vue?vue&type=template&id=3bc14c1e&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-refine-question/AdvisorRefineQuestion.vue?vue&type=script&lang=ts



let AdvisorRefineQuestionvue_type_script_lang_ts_AdvisorRefineQuestion = class AdvisorRefineQuestion extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.showAnswers = false;
    this.userAnswer = "";
  }
  created() {
    if (this.answer !== null) {
      this.userAnswer = this.answer.value;
    }
  }
  handleClickOnchange() {
    this.$emit("answer", this.question, this.question.answers.find(answer => {
      return answer.value === this.userAnswer;
    }));
  }
  handleClick(handle, answer) {
    this.$emit(handle, this.question, answer);
    this.userAnswer = answer.value;
    this.showAnswers = !this.showAnswers;
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorRefineQuestionvue_type_script_lang_ts_AdvisorRefineQuestion.prototype, "question", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorRefineQuestionvue_type_script_lang_ts_AdvisorRefineQuestion.prototype, "answer", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorRefineQuestionvue_type_script_lang_ts_AdvisorRefineQuestion.prototype, "questionIndex", void 0);
AdvisorRefineQuestionvue_type_script_lang_ts_AdvisorRefineQuestion = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorRefineQuestionvue_type_script_lang_ts_AdvisorRefineQuestion);
/* harmony default export */ var AdvisorRefineQuestionvue_type_script_lang_ts = (AdvisorRefineQuestionvue_type_script_lang_ts_AdvisorRefineQuestion);
// CONCATENATED MODULE: ./src/components/advisor-refine-question/AdvisorRefineQuestion.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_refine_question_AdvisorRefineQuestionvue_type_script_lang_ts = (AdvisorRefineQuestionvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-refine-question/AdvisorRefineQuestion.vue?vue&type=style&index=0&id=3bc14c1e&prod&lang=scss&scoped=true
var AdvisorRefineQuestionvue_type_style_index_0_id_3bc14c1e_prod_lang_scss_scoped_true = __webpack_require__("ed0b");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-refine-question/AdvisorRefineQuestion.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_refine_question_AdvisorRefineQuestionvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "3bc14c1e",
  null
  
)

/* harmony default export */ var advisor_refine_question_AdvisorRefineQuestion = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "7124":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7.2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8.2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32z"
      }
    })]));
  }
};

/***/ }),

/***/ "7234":
/***/ (function(module, exports) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ "727b":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 17 16",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, attrs),
      ...rest
    }, children.concat([_c('defs', [_c('path', {
      attrs: {
        "d": "M13 0H1.981A1.982 1.982 0 000 1.981V14c0 1.094.887 1.981 1.981 1.981h11.882C14.956 15.981 16 15.094 16 14V3l-3-3zm1 13.919a.26.26 0 01-.137.062H2V2h8v4h4v7.919zM12 4V2l2 2h-2z",
        "id": "quoteIcon"
      }
    })]), _c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-496 -248)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/quote",
        "transform": "translate(496.216 248)"
      }
    }, [_c('mask', {
      attrs: {
        "id": "mask-2"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#path-1"
      }
    })]), _c('use', {
      attrs: {
        "id": "Shape",
        "fill-rule": "evenodd",
        "xlink:href": "#quoteIcon"
      }
    })])])])]));
  }
};

/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "75f1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7d2f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-tab/AdvisorTab.vue?vue&type=template&id=3c97b63c&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"advisor-tab-content"},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-tab/AdvisorTab.vue?vue&type=template&id=3c97b63c&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-tab/AdvisorTab.vue?vue&type=script&lang=ts


let AdvisorTabvue_type_script_lang_ts_AdvisorTab = class AdvisorTab extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.isActive = true;
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: "Tab"
})], AdvisorTabvue_type_script_lang_ts_AdvisorTab.prototype, "title", void 0);
AdvisorTabvue_type_script_lang_ts_AdvisorTab = Object(tslib_es6["a" /* __decorate */])([vue_property_decorator["a" /* Component */]], AdvisorTabvue_type_script_lang_ts_AdvisorTab);
/* harmony default export */ var AdvisorTabvue_type_script_lang_ts = (AdvisorTabvue_type_script_lang_ts_AdvisorTab);
// CONCATENATED MODULE: ./src/components/advisor-tab/AdvisorTab.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_tab_AdvisorTabvue_type_script_lang_ts = (AdvisorTabvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-tab/AdvisorTab.vue?vue&type=style&index=0&id=3c97b63c&prod&lang=scss&scoped=true
var AdvisorTabvue_type_style_index_0_id_3c97b63c_prod_lang_scss_scoped_true = __webpack_require__("6ad2");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-tab/AdvisorTab.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_tab_AdvisorTabvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "3c97b63c",
  null
  
)

/* harmony default export */ var advisor_tab_AdvisorTab = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "7eee":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "82a6":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 16 16",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-395 -370)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/home",
        "transform": "translate(395 370)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M7.326.24a.998.998 0 011.3 0l6.994 5.988a.998.998 0 11-1.298 1.517l-.35-.3v7.526a.998.998 0 01-1.995 0l.057-9.185-4.057-3.474L3.992 5.73v9.24a.998.998 0 01-1.996 0V7.444l-.348.298a.998.998 0 11-1.3-1.515zm.658 7.744a2.998 2.998 0 012.995 2.995v3.992a.998.998 0 01-1.997 0v-3.992a1 1 0 00-1.996 0c0 1.084.044 3.942.044 3.98a.998.998 0 01-.986 1.01h-.012a.998.998 0 01-.998-.987c-.002-.159-.044-2.908-.044-4.003a2.998 2.998 0 012.994-2.995z",
        "id": "Combined-Shape"
      }
    })])])])]));
  }
};

/***/ }),

/***/ "82fa":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8393":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8406":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6l40.4 49.3c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"
      }
    })]));
  }
};

/***/ }),

/***/ "84c7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8568":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRootCause_vue_vue_type_style_index_0_id_5fa9912a_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("404b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRootCause_vue_vue_type_style_index_0_id_5fa9912a_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRootCause_vue_vue_type_style_index_0_id_5fa9912a_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8619":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 128 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M96 64c0-17.7-14.3-32-32-32S32 46.3 32 64v256c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM64 480c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40 17.9 40 40 40z"
      }
    })]));
  }
};

/***/ }),

/***/ "861d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var $documentAll = __webpack_require__("8ea1");

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "8625":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorCompare_vue_vue_type_style_index_0_id_691b1baf_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("87fb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorCompare_vue_vue_type_style_index_0_id_691b1baf_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorCompare_vue_vue_type_style_index_0_id_691b1baf_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "873f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "87fb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var isCallable = __webpack_require__("1626");
var store = __webpack_require__("c6cd");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8965":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failure-disclaimer/FailureDisclaimer.vue?vue&type=template&id=1d5232c0&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disclaimer"},[(_vm.title)?_c('h2',{staticClass:"disclaimer__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"disclaimer__description"},[_vm._t("default")],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failure-disclaimer/FailureDisclaimer.vue?vue&type=template&id=1d5232c0&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failure-disclaimer/FailureDisclaimer.vue?vue&type=script&lang=ts



let FailureDisclaimervue_type_script_lang_ts_FailureDisclaimer = class FailureDisclaimer extends vue_property_decorator["c" /* Vue */] {};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailureDisclaimervue_type_script_lang_ts_FailureDisclaimer.prototype, "title", void 0);
FailureDisclaimervue_type_script_lang_ts_FailureDisclaimer = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], FailureDisclaimervue_type_script_lang_ts_FailureDisclaimer);
/* harmony default export */ var FailureDisclaimervue_type_script_lang_ts = (FailureDisclaimervue_type_script_lang_ts_FailureDisclaimer);
// CONCATENATED MODULE: ./src/components/failure-disclaimer/FailureDisclaimer.vue?vue&type=script&lang=ts
 /* harmony default export */ var failure_disclaimer_FailureDisclaimervue_type_script_lang_ts = (FailureDisclaimervue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failure-disclaimer/FailureDisclaimer.vue?vue&type=style&index=0&id=1d5232c0&prod&lang=scss&scoped=true
var FailureDisclaimervue_type_style_index_0_id_1d5232c0_prod_lang_scss_scoped_true = __webpack_require__("05ee");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failure-disclaimer/FailureDisclaimer.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failure_disclaimer_FailureDisclaimervue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "1d5232c0",
  null
  
)

/* harmony default export */ var failure_disclaimer_FailureDisclaimer = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "8990":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-floating-actions/AdvisorFloatingActions.vue?vue&type=template&id=5c94825d&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floating-actions"},[(_vm.showContact)?_c('div',{ref:"floatingActionsHelp",staticClass:"floating-actions-group support",class:{ open: _vm.openHelp }},[_c('div',{staticClass:"floating-action toggle",on:{"click":_vm.toggleOpenHelp}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.openHelp)?_c('div',{staticClass:"toggle-open"},[_c('advisor-icon',{attrs:{"name":"close"}}),_c('span',[_vm._v(_vm._s(_vm.$t("floating_actions.contact_and_support")))])],1):_c('div',{staticClass:"toggle-close"},[_c('span',[_vm._v("Ask our experts")]),_c('advisor-icon',{attrs:{"name":"faComment"}})],1)])],1),(_vm.openHelp)?_c('div',{staticClass:"floating-action",on:{"click":function($event){return _vm.$emit('email_support')}}},[_c('advisor-icon',{attrs:{"name":"email"}}),_c('span',[_vm._v(_vm._s(_vm.$t("floating_actions.email_your_question")))])],1):_vm._e(),(_vm.openHelp)?_c('div',{staticClass:"floating-action",on:{"click":function($event){return _vm.$emit('locate_office')}}},[_c('advisor-icon',{attrs:{"name":"email"}}),_c('span',[_vm._v(_vm._s(_vm.$t("floating_actions.locate_our_office")))])],1):_vm._e()]):_vm._e(),(_vm.showShare)?_c('div',{staticClass:"floating-actions-group share",class:{ open: _vm.openFile }},[_c('div',{staticClass:"floating-action toggle",on:{"click":_vm.toggleOpenFile}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.openFile)?_c('div',{staticClass:"toggle-open"},[_c('advisor-icon',{attrs:{"name":"close"}}),_c('span',[_vm._v(_vm._s(_vm.$t("floating_actions.share_and_support")))])],1):_c('div',{staticClass:"toggle-close"},[_c('span',[_vm._v("Share & save")]),_c('advisor-icon',{attrs:{"name":"faShare"}})],1)])],1),(_vm.openFile)?_c('div',{staticClass:"floating-action",on:{"click":function($event){return _vm.$emit('download_pdf')}}},[_c('advisor-icon',{attrs:{"name":"email"}}),_vm._v(" "+_vm._s(_vm.$t("floating_actions.download_pdf"))+" ")],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-floating-actions/AdvisorFloatingActions.vue?vue&type=template&id=5c94825d&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-floating-actions/AdvisorFloatingActions.vue?vue&type=script&lang=ts



let AdvisorFloatingActionsvue_type_script_lang_ts_AdvisorFloatingActions = class AdvisorFloatingActions extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.openHelp = false;
    this.openHelpClickHandler = false;
    this.openFile = false;
    this.openFileClickHandler = false;
  }
  mounted() {
    // Open
    if (this.showOnce) {
      setTimeout(() => {
        this.openHelp = !this.openHelp;
      }, 1000);
      // Close
      setTimeout(() => {
        this.openHelp = !this.openHelp;
      }, 3000);
    }
  }
  toggleOpenHelp() {
    if (!this.openHelp) {
      vue_property_decorator["c" /* Vue */].nextTick(() => {
        window.addEventListener("click", this.floatingActionClickHandlerHelp);
        this.openHelp = true;
      });
    } else {
      this.openHelp = false;
      this.openHelpClickHandler = false;
      window.removeEventListener("click", this.floatingActionClickHandlerHelp);
    }
  }
  toggleOpenFile() {
    if (!this.openFile) {
      this.openFile = true;
      vue_property_decorator["c" /* Vue */].nextTick(() => {
        window.addEventListener("click", this.floatingActionClickHandlerFile);
      });
    } else {
      this.openFile = false;
      this.openFileClickHandler = false;
      window.removeEventListener("click", this.floatingActionClickHandlerFile);
    }
  }
  floatingActionClickHandlerHelp() {
    if (this.openHelpClickHandler) {
      this.openHelp = false;
      this.openHelpClickHandler = false;
      window.removeEventListener("click", this.floatingActionClickHandlerHelp);
    } else {
      this.openHelpClickHandler = true;
    }
  }
  floatingActionClickHandlerFile() {
    if (this.openFileClickHandler) {
      this.openFile = false;
      this.openFileClickHandler = false;
      window.removeEventListener("click", this.floatingActionClickHandlerFile);
    } else {
      this.openFileClickHandler = true;
    }
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: true
})], AdvisorFloatingActionsvue_type_script_lang_ts_AdvisorFloatingActions.prototype, "showOnce", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: true
})], AdvisorFloatingActionsvue_type_script_lang_ts_AdvisorFloatingActions.prototype, "showContact", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: true
})], AdvisorFloatingActionsvue_type_script_lang_ts_AdvisorFloatingActions.prototype, "showShare", void 0);
AdvisorFloatingActionsvue_type_script_lang_ts_AdvisorFloatingActions = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorFloatingActionsvue_type_script_lang_ts_AdvisorFloatingActions);
/* harmony default export */ var AdvisorFloatingActionsvue_type_script_lang_ts = (AdvisorFloatingActionsvue_type_script_lang_ts_AdvisorFloatingActions);
// CONCATENATED MODULE: ./src/components/advisor-floating-actions/AdvisorFloatingActions.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_floating_actions_AdvisorFloatingActionsvue_type_script_lang_ts = (AdvisorFloatingActionsvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-floating-actions/AdvisorFloatingActions.vue?vue&type=style&index=0&id=5c94825d&prod&lang=scss&scoped=true
var AdvisorFloatingActionsvue_type_style_index_0_id_5c94825d_prod_lang_scss_scoped_true = __webpack_require__("2adc");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-floating-actions/AdvisorFloatingActions.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_floating_actions_AdvisorFloatingActionsvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "5c94825d",
  null
  
)

/* harmony default export */ var advisor_floating_actions_AdvisorFloatingActions = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "8a0b":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 11 15",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-1153 -324)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/excel",
        "transform": "translate(1153 324.75)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M9.844 14a.655.655 0 00.656-.656V4.375H6.781a.658.658 0 01-.656-.656V0H.656A.655.655 0 000 .656v12.688c0 .363.293.656.656.656h9.188zM10.5 3.5v-.167a.654.654 0 00-.191-.462L7.632.191A.656.656 0 007.167 0H7v3.5h3.5zm-6.538 8.753h-.954a.329.329 0 01-.276-.506L4.38 9.19 2.732 6.634a.328.328 0 01.276-.506h.951a.33.33 0 01.29.172c.714 1.334.547.919 1.001 1.873 0 0 .167-.32 1-1.873a.33.33 0 01.29-.172h.952a.326.326 0 01.276.503L6.125 9.187l1.643 2.557a.329.329 0 01-.276.506h-.954a.33.33 0 01-.29-.172c-.536-.99-.998-1.879-.998-1.879-.175.405-.273.547-1 1.881a.325.325 0 01-.288.173z",
        "id": ""
      }
    })])])])]));
  }
};

/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8c5c":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M0 128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm16 160c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-48z"
      }
    })]));
  }
};

/***/ }),

/***/ "8d3b":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 11 15",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-1161 -364)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/Adobe",
        "transform": "translate(1161 364.75)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M9.844 14a.655.655 0 00.656-.656V4.375H6.781a.658.658 0 01-.656-.656V0H.656A.655.655 0 000 .656v12.688c0 .363.293.656.656.656h9.188zM10.5 3.5v-.167a.654.654 0 00-.191-.462L7.629.191A.656.656 0 007.164 0H7v3.5h3.5zm-8.045 8.747c-.15 0-.434-.085-.587-.273-.523-.643.749-1.48 1.49-1.86.003 0 .003-.002.005-.002.331-.58.799-1.592 1.116-2.346-.233-.9-.358-1.605-.222-2.106.148-.539 1.179-.618 1.307.186.148.481-.046 1.25-.17 1.756.258.678.622 1.137 1.168 1.47.528-.068 1.633-.174 2.013.198.314.311.26 1.186-.539 1.186-.462 0-1.156-.21-1.75-.533-.68.112-1.454.402-2.16.634-.694 1.198-1.181 1.69-1.67 1.69zm2.519-5.244c.153-.274.175-1.283-.055-1.283-.08 0-.082.845.055 1.283zm-.823 3.005c.5-.192 1.066-.47 1.72-.599a3.542 3.542 0 01-.944-1.116c-.21.553-.473 1.184-.776 1.715zm4.131-.156c.113-.074-.068-.325-1.17-.246 1.015.432 1.17.246 1.17.246zm-4.973.755c-.184.172-.796.67-.955 1.099 0 .022.361-.148.955-1.1z",
        "id": ""
      }
    })])])])]));
  }
};

/***/ }),

/***/ "8ddf":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8ea1":
/***/ (function(module, exports) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ "8f0c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9030":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-related-insights/FailuresRelatedInsights.vue?vue&type=template&id=32b43797&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insights"},_vm._l((_vm.insights),function(insight,index){return _c('a',{key:index,staticClass:"insights__item",attrs:{"href":insight.linkURL}},[_c('div',{staticClass:"insights__item-image",style:({ backgroundImage: 'url(' + insight.image + ')' })}),_c('div',{staticClass:"insights__item-content"},[_c('div',{staticClass:"insights__item-title"},[_vm._v(_vm._s(insight.title))]),_c('div',{staticClass:"insights__item-description"},[_vm._v(" "+_vm._s(insight.description)+" ")]),_c('div',{staticClass:"insights__item-link-title"},[_vm._v(_vm._s(insight.linkText))])])])}),0)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failures-related-insights/FailuresRelatedInsights.vue?vue&type=template&id=32b43797&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-related-insights/FailuresRelatedInsights.vue?vue&type=script&lang=ts


let FailuresRelatedInsightsvue_type_script_lang_ts_FailuresRelatedInsights = class FailuresRelatedInsights extends vue_property_decorator["c" /* Vue */] {};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: ["a"],
  type: Array
})], FailuresRelatedInsightsvue_type_script_lang_ts_FailuresRelatedInsights.prototype, "insights", void 0);
FailuresRelatedInsightsvue_type_script_lang_ts_FailuresRelatedInsights = Object(tslib_es6["a" /* __decorate */])([vue_property_decorator["a" /* Component */]], FailuresRelatedInsightsvue_type_script_lang_ts_FailuresRelatedInsights);
/* harmony default export */ var FailuresRelatedInsightsvue_type_script_lang_ts = (FailuresRelatedInsightsvue_type_script_lang_ts_FailuresRelatedInsights);
// CONCATENATED MODULE: ./src/components/failures-related-insights/FailuresRelatedInsights.vue?vue&type=script&lang=ts
 /* harmony default export */ var failures_related_insights_FailuresRelatedInsightsvue_type_script_lang_ts = (FailuresRelatedInsightsvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failures-related-insights/FailuresRelatedInsights.vue?vue&type=style&index=0&id=32b43797&prod&lang=scss&scoped=true
var FailuresRelatedInsightsvue_type_style_index_0_id_32b43797_prod_lang_scss_scoped_true = __webpack_require__("f4ad");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failures-related-insights/FailuresRelatedInsights.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failures_related_insights_FailuresRelatedInsightsvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "32b43797",
  null
  
)

/* harmony default export */ var failures_related_insights_FailuresRelatedInsights = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "904a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-progress/AdvisorProgressText.vue?vue&type=template&id=38ef0796&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advisor-progress-text"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"step",class:_vm.stepCssClass(step),attrs:{"title":_vm.$t(step.i18nLabel)},on:{"click":function($event){return _vm.onStep(step)}}},[_c('div',{staticClass:"label"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t(step.i18nLabel)))])])])}),0)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-progress/AdvisorProgressText.vue?vue&type=template&id=38ef0796&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// EXTERNAL MODULE: ./src/components/advisor.ts
var advisor = __webpack_require__("3d8c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-progress/AdvisorProgressText.vue?vue&type=script&lang=ts




let AdvisorProgressTextvue_type_script_lang_ts_AdvisorProgressText = class AdvisorProgressText extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    // expose type to template
    this.StepType = advisor["c" /* StepType */];
    this.StepProgress = advisor["b" /* StepProgress */];
  }
  /**
   * Gets the first step with progress active;
   */
  get activeStep() {
    return this.steps.find(step => step.progress === advisor["b" /* StepProgress */].ACTIVE);
  }
  get previousStepAvailable() {
    return this.activeStep && this.activeStep.index > 0;
  }
  get nextStepAvailable() {
    return this.activeStep && this.activeStep.index < this.steps.length - 1;
  }
  get nextCheck() {
    return true;
  }
  stepCssClass(step) {
    let cssClass = step.type + " " + step.progress;
    const previousStep = this.previousStep(step);
    if (this.stepNextAllowed(previousStep) || step.type === advisor["c" /* StepType */].ADVISE && this.adviseActive) {
      cssClass += " " + "step-allowed";
    }
    return cssClass;
  }
  onPrevious() {
    if (this.previousStepAvailable) {
      this.$emit("previous");
    }
  }
  previousStep(step) {
    return this.steps.find(s => s.index === step.index - 1);
  }
  stepAllowed(step) {
    const stepAllowed = false;
    const activeStep = this.activeStep;
    if (activeStep !== undefined && activeStep.index === step.index) {
      return false;
    }
    if (step.progress !== advisor["b" /* StepProgress */].UNANSWERED || step.type === advisor["c" /* StepType */].HOME || step.type === advisor["c" /* StepType */].ADVISE && this.adviseActive) {
      return true;
    }
    if (step.progress === advisor["b" /* StepProgress */].UNANSWERED) {
      const previousStep = this.previousStep(step);
      if (this.stepNextAllowed(previousStep)) {
        return true;
      }
    }
    return stepAllowed;
  }
  stepNextAllowed(step) {
    const stepAllowed = false;
    if (step !== undefined) {
      if (step.type === advisor["c" /* StepType */].HOME) {
        return true;
      }
      if (step.progress === advisor["b" /* StepProgress */].COMPLETED || step.progress === advisor["b" /* StepProgress */].SKIPPED) {
        return true;
      }
      // Check if active step already is answered
      if (step.progress === advisor["b" /* StepProgress */].ACTIVE) {
        if (this.answers[step.index] !== null) {
          return true;
        }
      }
    }
    return stepAllowed;
  }
  onStep(step) {
    const stepAllowed = this.stepAllowed(step);
    // Available
    if (stepAllowed) {
      this.$emit("step", step);
    } else {
      this.$emit("stepNotAllowed");
    }
  }
  onNext() {
    if (this.nextStepAvailable) {
      let stepAllowed = false;
      const activeStep = this.activeStep;
      if (activeStep !== undefined) {
        stepAllowed = this.stepNextAllowed(activeStep);
      }
      if (stepAllowed) {
        this.$emit("next");
      } else {
        this.$emit("stepNotAllowed");
      }
    }
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorProgressTextvue_type_script_lang_ts_AdvisorProgressText.prototype, "steps", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorProgressTextvue_type_script_lang_ts_AdvisorProgressText.prototype, "answers", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: false
})], AdvisorProgressTextvue_type_script_lang_ts_AdvisorProgressText.prototype, "adviseActive", void 0);
AdvisorProgressTextvue_type_script_lang_ts_AdvisorProgressText = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorProgressTextvue_type_script_lang_ts_AdvisorProgressText);
/* harmony default export */ var AdvisorProgressTextvue_type_script_lang_ts = (AdvisorProgressTextvue_type_script_lang_ts_AdvisorProgressText);
// CONCATENATED MODULE: ./src/components/advisor-progress/AdvisorProgressText.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_progress_AdvisorProgressTextvue_type_script_lang_ts = (AdvisorProgressTextvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-progress/AdvisorProgressText.vue?vue&type=style&index=0&id=38ef0796&prod&scoped=true&lang=scss
var AdvisorProgressTextvue_type_style_index_0_id_38ef0796_prod_scoped_true_lang_scss = __webpack_require__("eced");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-progress/AdvisorProgressText.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_progress_AdvisorProgressTextvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "38ef0796",
  null
  
)

/* harmony default export */ var advisor_progress_AdvisorProgressText = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "90e3":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "9111":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorRefineQuestionSimple_vue_vue_type_style_index_0_id_117ce998_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0063");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorRefineQuestionSimple_vue_vue_type_style_index_0_id_117ce998_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorRefineQuestionSimple_vue_vue_type_style_index_0_id_117ce998_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9224":
/***/ (function(module) {

module.exports = JSON.parse("{\"a\":\"0.1.46\"}");

/***/ }),

/***/ "924b":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 18 17",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-93 -159)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/chat",
        "transform": "translate(93 159)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M15.525 0H2.475A2.477 2.477 0 000 2.475v7.986a2.478 2.478 0 002.466 2.475v3.624l5.208-3.624h7.851A2.478 2.478 0 0018 10.461V2.475A2.477 2.477 0 0015.525 0zm1.42 10.461c0 .783-.637 1.42-1.42 1.42H7.343l-3.822 2.66v-2.66H2.475c-.783 0-1.42-.637-1.42-1.42V2.475c0-.783.637-1.42 1.42-1.42h13.05c.783 0 1.42.637 1.42 1.42v7.986z",
        "id": "Shape"
      }
    }), _c('path', {
      attrs: {
        "id": "Path",
        "d": "M4.818 3.727h8.364V4.78H4.818zM4.818 5.977h8.364V7.03H4.818zM4.818 8.227h8.364V9.28H4.818z"
      }
    })])])])]));
  }
};

/***/ }),

/***/ "93b2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-header/FailuresHeader.vue?vue&type=template&id=8a8178c6&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header__wrapper"},[_c('div',{staticClass:"header__content container"},[_c('h1',{staticClass:"header__title",attrs:{"name":"title"}},[_vm._t("title")],2),_c('h2',{staticClass:"header__title"},[_vm._t("sub-title")],2),_c('div',[_vm._t("text")],2)]),_c('div',{staticClass:"header__background-image"},[_c('img',{staticClass:"header__image",attrs:{"src":_vm.imageUrl}})])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failures-header/FailuresHeader.vue?vue&type=template&id=8a8178c6&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-header/FailuresHeader.vue?vue&type=script&lang=ts


let FailuresHeadervue_type_script_lang_ts_FailuresHeader = class FailuresHeader extends vue_property_decorator["c" /* Vue */] {};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: String
})], FailuresHeadervue_type_script_lang_ts_FailuresHeader.prototype, "imageUrl", void 0);
FailuresHeadervue_type_script_lang_ts_FailuresHeader = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {}
})], FailuresHeadervue_type_script_lang_ts_FailuresHeader);
/* harmony default export */ var FailuresHeadervue_type_script_lang_ts = (FailuresHeadervue_type_script_lang_ts_FailuresHeader);
// CONCATENATED MODULE: ./src/components/failures-header/FailuresHeader.vue?vue&type=script&lang=ts
 /* harmony default export */ var failures_header_FailuresHeadervue_type_script_lang_ts = (FailuresHeadervue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failures-header/FailuresHeader.vue?vue&type=style&index=0&id=8a8178c6&prod&lang=scss&scoped=true
var FailuresHeadervue_type_style_index_0_id_8a8178c6_prod_lang_scss_scoped_true = __webpack_require__("9a9b");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failures-header/FailuresHeader.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failures_header_FailuresHeadervue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "8a8178c6",
  null
  
)

/* harmony default export */ var failures_header_FailuresHeader = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "951f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-progress/AdvisorProgress.vue?vue&type=template&id=47be057d&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advisor-progress"},[_c('advisor-icon',{staticClass:"btn-left",class:{ disabled: !_vm.previousStepAvailable },attrs:{"name":"faArrowLeft","title":_vm.$t('progress.previous_question')},nativeOn:{"click":function($event){return _vm.onPrevious($event)}}}),_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"step",class:_vm.stepCssClass(step),attrs:{"title":_vm.$t(step.i18nLabel)},on:{"click":function($event){return _vm.onStep(step)}}},[_c('span',{staticClass:"btn-step",class:step.type},[(step.type !== _vm.StepType.QUESTION)?_c('advisor-icon',{attrs:{"name":step.icon}}):(step.progress === _vm.StepProgress.COMPLETED)?_c('advisor-icon',{attrs:{"name":"checkmark"}}):(step.progress === _vm.StepProgress.SKIPPED)?_c('span',{staticClass:"step-skipped"},[_vm._v("-")]):_c('span',{staticClass:"step-index"},[_vm._v(_vm._s(step.index))])],1)])}),_c('advisor-icon',{staticClass:"btn-right",class:{ disabled: !_vm.nextStepAvailable },attrs:{"name":"faArrowRight","title":_vm.$t('progress.next_question')},nativeOn:{"click":function($event){return _vm.onNext($event)}}})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-progress/AdvisorProgress.vue?vue&type=template&id=47be057d&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// EXTERNAL MODULE: ./src/components/advisor.ts
var advisor = __webpack_require__("3d8c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-progress/AdvisorProgress.vue?vue&type=script&lang=ts




let AdvisorProgressvue_type_script_lang_ts_AdvisorProgress = class AdvisorProgress extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    // expose type to template
    this.StepType = advisor["c" /* StepType */];
    this.StepProgress = advisor["b" /* StepProgress */];
  }
  /**
   * Gets the first step with progress active;
   */
  get activeStep() {
    return this.steps.find(step => step.progress === advisor["b" /* StepProgress */].ACTIVE);
  }
  get previousStepAvailable() {
    return this.activeStep && this.activeStep.index > 0;
  }
  get nextStepAvailable() {
    return this.activeStep && this.activeStep.index < this.steps.length - 1;
  }
  get nextCheck() {
    return true;
  }
  stepCssClass(step) {
    let cssClass = step.type + " " + step.progress;
    const previousStep = this.previousStep(step);
    if (this.stepNextAllowed(previousStep) || step.type === advisor["c" /* StepType */].ADVISE && this.adviseActive) {
      cssClass += " " + "step-allowed";
    }
    return cssClass;
  }
  onPrevious() {
    if (this.previousStepAvailable) {
      this.$emit("previous");
    }
  }
  previousStep(step) {
    return this.steps.find(s => s.index === step.index - 1);
  }
  stepAllowed(step) {
    const stepAllowed = false;
    const activeStep = this.activeStep;
    if (activeStep !== undefined && activeStep.index === step.index) {
      return false;
    }
    if (step.progress !== advisor["b" /* StepProgress */].UNANSWERED || step.type === advisor["c" /* StepType */].HOME || step.type === advisor["c" /* StepType */].ADVISE && this.adviseActive) {
      return true;
    }
    if (step.progress === advisor["b" /* StepProgress */].UNANSWERED) {
      const previousStep = this.previousStep(step);
      if (this.stepNextAllowed(previousStep)) {
        return true;
      }
    }
    return stepAllowed;
  }
  stepNextAllowed(step) {
    const stepAllowed = false;
    if (step !== undefined) {
      if (step.type === advisor["c" /* StepType */].HOME) {
        return true;
      }
      if (step.progress === advisor["b" /* StepProgress */].COMPLETED || step.progress === advisor["b" /* StepProgress */].SKIPPED) {
        return true;
      }
      // Check if active step already is answered
      if (step.progress === advisor["b" /* StepProgress */].ACTIVE) {
        if (this.answers[step.index] !== null) {
          return true;
        }
      }
    }
    return stepAllowed;
  }
  onStep(step) {
    const stepAllowed = this.stepAllowed(step);
    // Available
    if (stepAllowed) {
      this.$emit("step", step);
    } else {
      this.$emit("stepNotAllowed");
    }
  }
  onNext() {
    if (this.nextStepAvailable) {
      let stepAllowed = false;
      const activeStep = this.activeStep;
      if (activeStep !== undefined) {
        stepAllowed = this.stepNextAllowed(activeStep);
      }
      if (stepAllowed) {
        this.$emit("next");
      } else {
        this.$emit("stepNotAllowed");
      }
    }
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorProgressvue_type_script_lang_ts_AdvisorProgress.prototype, "steps", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorProgressvue_type_script_lang_ts_AdvisorProgress.prototype, "answers", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: false
})], AdvisorProgressvue_type_script_lang_ts_AdvisorProgress.prototype, "adviseActive", void 0);
AdvisorProgressvue_type_script_lang_ts_AdvisorProgress = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorProgressvue_type_script_lang_ts_AdvisorProgress);
/* harmony default export */ var AdvisorProgressvue_type_script_lang_ts = (AdvisorProgressvue_type_script_lang_ts_AdvisorProgress);
// CONCATENATED MODULE: ./src/components/advisor-progress/AdvisorProgress.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_progress_AdvisorProgressvue_type_script_lang_ts = (AdvisorProgressvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-progress/AdvisorProgress.vue?vue&type=style&index=0&id=47be057d&prod&scoped=true&lang=scss
var AdvisorProgressvue_type_style_index_0_id_47be057d_prod_scoped_true_lang_scss = __webpack_require__("aa4c");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-progress/AdvisorProgress.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_progress_AdvisorProgressvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "47be057d",
  null
  
)

/* harmony default export */ var advisor_progress_AdvisorProgress = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "965f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsButtonList_vue_vue_type_style_index_1_id_e35f8f8e_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b891");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsButtonList_vue_vue_type_style_index_1_id_e35f8f8e_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsButtonList_vue_vue_type_style_index_1_id_e35f8f8e_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9826":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 192 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M48 80a48 48 0 1196 0 48 48 0 11-96 0zM0 224c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v224h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V256H32c-17.7 0-32-14.3-32-32z"
      }
    })]));
  }
};

/***/ }),

/***/ "98b1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9903":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "991c":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3l105.3-105.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
      }
    })]));
  }
};

/***/ }),

/***/ "9a47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _package_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9224");
var _package_json__WEBPACK_IMPORTED_MODULE_0___namespace = /*#__PURE__*/__webpack_require__.t("9224", 1);

/* harmony default export */ __webpack_exports__["a"] = (_package_json__WEBPACK_IMPORTED_MODULE_0__[/* version */ "a"]);

/***/ }),

/***/ "9a9b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresHeader_vue_vue_type_style_index_0_id_8a8178c6_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9b5b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresHeader_vue_vue_type_style_index_0_id_8a8178c6_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresHeader_vue_vue_type_style_index_0_id_8a8178c6_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9ab4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* unused harmony export __assign */
/* unused harmony export __rest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __decorate; });
/* unused harmony export __param */
/* unused harmony export __esDecorate */
/* unused harmony export __runInitializers */
/* unused harmony export __propKey */
/* unused harmony export __setFunctionName */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/* unused harmony export __addDisposableResource */
/* unused harmony export __disposeResources */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
        env.stack.push({ async: true });
    }
    return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while (env.stack.length) {
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
            }
            catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
});


/***/ }),

/***/ "9b5b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9bdc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-risk-value/FailuresRiskValue.vue?vue&type=template&id=799af9d6&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"risk-value"},[(_vm.label)?_c('div',{staticClass:"risk-value__title"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"risk-value__value",style:({
      backgroundColor: _vm.revers ? this.reversColors[_vm.index] : this.colors[_vm.index]
    })},[_vm._v(" "+_vm._s(_vm.index + 1)+" ")]),(_vm.valueTitle)?_c('div',{staticClass:"risk-value__value-title"},[_vm._v(" "+_vm._s(_vm.valueTitle)+" ")]):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failures-risk-value/FailuresRiskValue.vue?vue&type=template&id=799af9d6&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-risk-value/FailuresRiskValue.vue?vue&type=script&lang=ts


let FailuresRiskValuevue_type_script_lang_ts_FailuresRiskValue = class FailuresRiskValue extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.colors = ["#7DE9A4", "#CBF6DB", "#E3FB76", "#FF9E9B", "#FF5E59"];
    this.reversColors = [...this.colors].reverse();
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: String
})], FailuresRiskValuevue_type_script_lang_ts_FailuresRiskValue.prototype, "label", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: String
})], FailuresRiskValuevue_type_script_lang_ts_FailuresRiskValue.prototype, "valueTitle", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Number
})], FailuresRiskValuevue_type_script_lang_ts_FailuresRiskValue.prototype, "index", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Boolean,
  default: false
})], FailuresRiskValuevue_type_script_lang_ts_FailuresRiskValue.prototype, "revers", void 0);
FailuresRiskValuevue_type_script_lang_ts_FailuresRiskValue = Object(tslib_es6["a" /* __decorate */])([vue_property_decorator["a" /* Component */]], FailuresRiskValuevue_type_script_lang_ts_FailuresRiskValue);
/* harmony default export */ var FailuresRiskValuevue_type_script_lang_ts = (FailuresRiskValuevue_type_script_lang_ts_FailuresRiskValue);
// CONCATENATED MODULE: ./src/components/failures-risk-value/FailuresRiskValue.vue?vue&type=script&lang=ts
 /* harmony default export */ var failures_risk_value_FailuresRiskValuevue_type_script_lang_ts = (FailuresRiskValuevue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failures-risk-value/FailuresRiskValue.vue?vue&type=style&index=0&id=799af9d6&prod&lang=scss&scoped=true
var FailuresRiskValuevue_type_style_index_0_id_799af9d6_prod_lang_scss_scoped_true = __webpack_require__("e810");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failures-risk-value/FailuresRiskValue.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failures_risk_value_FailuresRiskValuevue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "799af9d6",
  null
  
)

/* harmony default export */ var failures_risk_value_FailuresRiskValue = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var anObject = __webpack_require__("825a");
var toPropertyKey = __webpack_require__("a04b");

var $TypeError = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "a023":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorQuestionFilter_vue_vue_type_style_index_0_id_270f0cfd_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6466");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorQuestionFilter_vue_vue_type_style_index_0_id_270f0cfd_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorQuestionFilter_vue_vue_type_style_index_0_id_270f0cfd_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a04b":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("c04e");
var isSymbol = __webpack_require__("d9b5");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "a382":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-tabs/AdvisorTabs.vue?vue&type=template&id=536327da&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"advisor-tabs"},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:tab.title,staticClass:"advisor-tab",class:{ 'is-active': index === _vm.selectedIndex },on:{"click":function($event){return _vm.selectTab(index)}}},[_vm._v(" "+_vm._s(tab.title)+" ")])}),0),_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-tabs/AdvisorTabs.vue?vue&type=template&id=536327da&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-tabs/AdvisorTabs.vue?vue&type=script&lang=ts


let AdvisorTabsvue_type_script_lang_ts_AdvisorTabs = class AdvisorTabs extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.selectedIndex = 0;
    this.tabs = [];
  }
  created() {
    this.tabs = this.$children;
  }
  mounted() {
    this.selectTab(0);
  }
  selectTab(i) {
    this.selectedIndex = i;
    this.tabs.forEach((tab, index) => {
      tab.isActive = index === i;
    });
  }
};
AdvisorTabsvue_type_script_lang_ts_AdvisorTabs = Object(tslib_es6["a" /* __decorate */])([vue_property_decorator["a" /* Component */]], AdvisorTabsvue_type_script_lang_ts_AdvisorTabs);
/* harmony default export */ var AdvisorTabsvue_type_script_lang_ts = (AdvisorTabsvue_type_script_lang_ts_AdvisorTabs);
// CONCATENATED MODULE: ./src/components/advisor-tabs/AdvisorTabs.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_tabs_AdvisorTabsvue_type_script_lang_ts = (AdvisorTabsvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-tabs/AdvisorTabs.vue?vue&type=style&index=0&id=536327da&prod&lang=scss&scoped=true
var AdvisorTabsvue_type_style_index_0_id_536327da_prod_lang_scss_scoped_true = __webpack_require__("02bc");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-tabs/AdvisorTabs.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_tabs_AdvisorTabsvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "536327da",
  null
  
)

/* harmony default export */ var advisor_tabs_AdvisorTabs = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "a54b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-floating-actions/AdvisorShare.vue?vue&type=template&id=e28a02f8&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advisor-share",class:{ 'is-open': _vm.showDetails }},[_c('div',{staticClass:"advisor-share-header",on:{"click":function($event){_vm.showDetails = !_vm.showDetails}}},[_c('h4',{staticClass:"advisor-share--title"},[_vm._v(" "+_vm._s(_vm.$t("floating_actions.shareResults"))+" ")]),_c('div',{staticClass:"advisor-share--toggle"},[_c('advisor-icon',{attrs:{"name":"left"}})],1)]),_c('div',{staticClass:"advisor-share-content"},[_c('ul',{staticClass:"list-unstyled share-list"},[_c('li',[_c('button',{staticClass:"btn btn-md btn-icon btn-ev-link",on:{"click":function($event){return _vm.$emit('downloadPdf')}}},[_c('advisor-icon',{attrs:{"name":"email"}}),_c('span',[_vm._v(_vm._s(_vm.$t("floating_actions.download_pdf")))])],1)])])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-floating-actions/AdvisorShare.vue?vue&type=template&id=e28a02f8&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-floating-actions/AdvisorShare.vue?vue&type=script&lang=ts



let AdvisorSharevue_type_script_lang_ts_AdvisorShare = class AdvisorShare extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.showDetails = false;
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: true
})], AdvisorSharevue_type_script_lang_ts_AdvisorShare.prototype, "visible", void 0);
AdvisorSharevue_type_script_lang_ts_AdvisorShare = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorSharevue_type_script_lang_ts_AdvisorShare);
/* harmony default export */ var AdvisorSharevue_type_script_lang_ts = (AdvisorSharevue_type_script_lang_ts_AdvisorShare);
// CONCATENATED MODULE: ./src/components/advisor-floating-actions/AdvisorShare.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_floating_actions_AdvisorSharevue_type_script_lang_ts = (AdvisorSharevue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-floating-actions/AdvisorShare.vue?vue&type=style&index=0&id=e28a02f8&prod&lang=scss&scoped=true
var AdvisorSharevue_type_style_index_0_id_e28a02f8_prod_lang_scss_scoped_true = __webpack_require__("6bd5");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-floating-actions/AdvisorShare.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_floating_actions_AdvisorSharevue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "e28a02f8",
  null
  
)

/* harmony default export */ var advisor_floating_actions_AdvisorShare = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "a55a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a74a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a893":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 17 16",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, attrs),
      ...rest
    }, children.concat([_c('defs', [_c('path', {
      attrs: {
        "d": "M8.989 0a.9.9 0 01.892.764l.1.67c.424.132.832.3 1.222.506l.546-.402a.901.901 0 011.173.087l1.422 1.422a.901.901 0 01.087 1.173l-.402.546c.209.39.377.798.505 1.222l.668.1.108.023c.386.106.66.46.662.87v2.01a.902.902 0 01-.767.89l-.67.1a6.642 6.642 0 01-.506 1.222l.402.546a.901.901 0 01-.087 1.173l-1.422 1.422a.901.901 0 01-1.173.087l-.546-.402c-.39.209-.798.377-1.222.505l-.103.67a.9.9 0 01-.89.768H6.978a.902.902 0 01-.889-.767l-.1-.67a6.642 6.642 0 01-1.222-.506l-.546.402a.901.901 0 01-1.173-.087l-1.422-1.422a.901.901 0 01-.087-1.173l.402-.546a6.642 6.642 0 01-.505-1.222l-.668-.1A.9.9 0 010 8.99v-2.01c0-.447.327-.827.764-.893l.67-.1c.132-.424.3-.832.51-1.22l-.403-.545a.901.901 0 01.087-1.173l1.42-1.425a.901.901 0 011.172-.087l.546.402c.39-.209.798-.377 1.222-.505l.1-.668A.897.897 0 016.977 0zm-.21 1.138H7.184l-.184 1.226a5.676 5.676 0 00-2.296.951l-.998-.736-1.129 1.13.736.997a5.676 5.676 0 00-.951 2.296l-1.226.184v1.597l1.226.184c.147.842.477 1.622.951 2.295l-.736.998 1.13 1.13.997-.737A5.676 5.676 0 007 13.605l.184 1.225H8.78l.184-1.225a5.676 5.676 0 002.295-.952l.998.736 1.13-1.129-.737-.998a5.676 5.676 0 00.952-2.295l1.225-.184V7.186l-1.225-.184a5.676 5.676 0 00-.952-2.296l.736-.998-1.129-1.129-.998.736a5.676 5.676 0 00-2.295-.95L8.78 1.137zM7.985 4.99a2.995 2.995 0 11-.001 5.99 2.995 2.995 0 01.001-5.99zm0 .998a1.998 1.998 0 00-1.996 1.996c0 1.101.895 1.997 1.996 1.997a1.998 1.998 0 001.997-1.997 1.998 1.998 0 00-1.997-1.996z",
        "id": "cogIcon"
      }
    })]), _c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-138 -248)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/cog",
        "transform": "translate(138.895 248)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Icon"
      }
    }, [_c('g', {
      attrs: {
        "id": "cog"
      }
    }, [_c('mask', {
      attrs: {
        "id": "mask-2"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#path-1"
      }
    })]), _c('use', {
      attrs: {
        "id": "Combined-Shape",
        "xlink:href": "#cogIcon"
      }
    })])])])])])]));
  }
};

/***/ }),

/***/ "a8db":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorQuestion_vue_vue_type_style_index_0_id_01abc1e0_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("adc9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorQuestion_vue_vue_type_style_index_0_id_01abc1e0_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorQuestion_vue_vue_type_style_index_0_id_01abc1e0_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "aa4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorProgress_vue_vue_type_style_index_0_id_47be057d_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9903");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorProgress_vue_vue_type_style_index_0_id_47be057d_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorProgress_vue_vue_type_style_index_0_id_47be057d_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "adc9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "aed9":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "b0bf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorSpinner_vue_vue_type_style_index_0_id_11a0560e_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c6c9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorSpinner_vue_vue_type_style_index_0_id_11a0560e_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorSpinner_vue_vue_type_style_index_0_id_11a0560e_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b3d7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b42e":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "b4b0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-question/AdvisorQuestion.vue?vue&type=template&id=01abc1e0&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advisor-question"},[_c('div',{staticClass:"question"},[_c('h2',{staticClass:"question-title"},[_c('div',{staticClass:"question-number"},[_c('div',[_vm._v(_vm._s(_vm.question.index))])]),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.question.i18nQuestion)))])]),_c('div',{staticClass:"skipped"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip.open",value:({
          content: _vm.tooltipContent,
          html: true,
          classes: 'tooltip-200'
        }),expression:"{\n          content: tooltipContent,\n          html: true,\n          classes: 'tooltip-200'\n        }",modifiers:{"open":true}}],staticClass:"btn btn-md btn-ev-light-blue btn-icon",on:{"click":function($event){return _vm.$emit('skip')}}},[_c('span',[_vm._v(_vm._s(_vm.$t("question.skipped")))]),_c('advisor-icon',{attrs:{"name":"faArrowRight"}})],1)])]),_c('div',{staticClass:"answers"},_vm._l((_vm.question.answers),function(answer){return _c('label',{key:answer.value,staticClass:"answer",class:{ active: _vm.selected && _vm.selected.value === answer.value },on:{"click":function($event){return _vm.$emit('answer', answer)}}},[_c('figure',[_c('img',{attrs:{"src":answer.imgUrl}})]),_c('div',{staticClass:"answer-inner"},[_c('h3',{staticClass:"answer-title"},[_c('span',[_vm._v(_vm._s(_vm.$t(answer.i18nDescription)))])]),_c('p',{staticClass:"answer-description"},[_vm._v(_vm._s(_vm.$t(answer.i18nDescriptionText)))])]),_c('div',{staticClass:"rounded-icon"},[_c('advisor-icon',{attrs:{"name":"checkmark"}})],1)])}),0)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-question/AdvisorQuestion.vue?vue&type=template&id=01abc1e0&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-question/AdvisorQuestion.vue?vue&type=script&lang=ts



let AdvisorQuestionvue_type_script_lang_ts_AdvisorQuestion = class AdvisorQuestion extends vue_property_decorator["c" /* Vue */] {
  get tooltipContent() {
    return '<span class=\'font-weight-bold d-block tooltip-title\'>For the best results it is advised to answer each question.</span><span>Contact us if you want any help. Our experts will gladly assist you.</span>';
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorQuestionvue_type_script_lang_ts_AdvisorQuestion.prototype, "question", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorQuestionvue_type_script_lang_ts_AdvisorQuestion.prototype, "selected", void 0);
AdvisorQuestionvue_type_script_lang_ts_AdvisorQuestion = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorQuestionvue_type_script_lang_ts_AdvisorQuestion);
/* harmony default export */ var AdvisorQuestionvue_type_script_lang_ts = (AdvisorQuestionvue_type_script_lang_ts_AdvisorQuestion);
// CONCATENATED MODULE: ./src/components/advisor-question/AdvisorQuestion.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_question_AdvisorQuestionvue_type_script_lang_ts = (AdvisorQuestionvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-question/AdvisorQuestion.vue?vue&type=style&index=0&id=01abc1e0&prod&lang=scss&scoped=true
var AdvisorQuestionvue_type_style_index_0_id_01abc1e0_prod_lang_scss_scoped_true = __webpack_require__("a8db");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-question/AdvisorQuestion.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_question_AdvisorQuestionvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "01abc1e0",
  null
  
)

/* harmony default export */ var advisor_question_AdvisorQuestion = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var hasOwn = __webpack_require__("1a2d");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("04f8");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b7e4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsTotal_vue_vue_type_style_index_0_id_963fc638_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f7f4");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsTotal_vue_vue_type_style_index_0_id_963fc638_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsTotal_vue_vue_type_style_index_0_id_963fc638_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b891":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "bbe7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-root-cause/FailuresRootCause.vue?vue&type=template&id=5fa9912a&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-cause",class:{ open: _vm.open }},[_c('div',{staticClass:"top base-v-padding base-h-padding"},[_c('div',{staticClass:"root-cause__header-list"},[_c('div',{staticClass:"root-cause__title root-cause__title--no-margin"},[_c('div',{staticClass:"root-cause__round"},[_c('advisor-icon',{staticClass:"root-cause__icon",attrs:{"name":"exclamation"}})],1),_c('div',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"root-cause__phase"},[_vm._v(" "+_vm._s(_vm.phase)+" ")]),_c('div',{staticClass:"root-cause__risk"},[_c('div',{staticClass:"root-cause__risk-indicator",style:({ backgroundColor: this.colors[_vm.risk] })}),_c('div',{staticClass:"root-cause__risk-title"},[_vm._v(" Risk value "),_c('span',[_c('failures-info',{attrs:{"right":true}},[_vm._v(_vm._s(_vm.tooltipText))])],1)])])]),_c('div',{staticClass:"root-cause__description"},[_vm._v(" Based on your responses in the online tool ‘Potential Failures - Awareness & Prevention’, we have identified "),_c('b',[_vm._v(_vm._s(_vm.title))]),_vm._v(" as potential root cause of failure for your project in the phase: "),_c('b',[_vm._v(_vm._s(_vm.phase))]),_vm._v(". The associated risk is considered to be "),_c('b',[_vm._v(_vm._s(_vm.riskTitle[_vm.risk]))]),_vm._v(", which is based on your combined risk-assessment of the probability, severity and detectability of the potential failure. Please find below suggested mitigation action. While we’ve strived to make this report as accurate as possible, every situation and project is unique and root causes of potential failures and best mitigation actions may differ. Contact us for verification of outcomes and/or for a more detailed analysis and advice. ")])]),_c('div',{ref:"details",staticClass:"details-container"},[_c('div',{staticClass:"details base-v-padding"},[_c('div',{staticClass:"base-h-padding"},[_c('div',{staticClass:"root-cause__header-list"},[_c('div',{staticClass:"root-cause__title root-cause__title--no-margin"},[_c('div',{staticClass:"root-cause__round"},[_c('advisor-icon',{staticClass:"root-cause__icon",attrs:{"name":"umbrella"}})],1),_c('div',[_vm._v("Suggested mitigation")])]),_c('div',{staticClass:"root-cause__mitigation-sub-title"},[_vm._v(" Reduce and avoid risk ")])]),(_vm.mitigations)?_c('div',[_c('p',{staticClass:"root-cause__mitigation-text"},[_vm._v(_vm._s(_vm.mitigations))])]):_vm._e(),_c('p',{staticClass:"root-cause__mitigation-text font-italic"},[_vm._v(" To explore alternative mitigation actions, in case the failure originated in a different phase of your project than selected, please select another project phase "),_c('span',{staticClass:"back-to-question",on:{"click":function($event){return _vm.$emit('resetToQuestion', 2)}}},[_vm._v("here")]),_vm._v(". ")])]),_c('div',{staticClass:"base-h-padding"},[_c('div',{staticClass:"root-cause__title"},[_c('div',{staticClass:"root-cause__round"},[_c('advisor-icon',{staticClass:"root-cause__icon",attrs:{"name":"phone"}})],1),_c('div',[_vm._v("Contact an expert")])]),_c('div',{staticClass:"root-cause__contact section-margin-bottom"},[_c('div',{staticClass:"root-cause__contact-text"},[_vm._v(" "+_vm._s(_vm.$t(("" + (_vm.contact.text))))+" ")]),_c('a',{staticClass:"root-cause__contact-btn btn btn-ev-primary btn-with-icon",attrs:{"href":_vm.contact.linkURL,"target":_vm.contact.target}},[_vm._v(" contact ")])]),_c('div',{staticClass:"root-cause__title"},[_c('div',{staticClass:"root-cause__round"},[_c('advisor-icon',{staticClass:"root-cause__icon",attrs:{"name":"pager"}})],1),_c('div',[_vm._v("Related insights")])]),(_vm.insights)?_c('ul',{staticClass:"root-cause__insights"},_vm._l((_vm.insights),function(item,index){return _c('li',{key:index,staticClass:"root-cause__insight"},[_c('a',{attrs:{"href":item.linkURL,"target":item.target}},[_c('div',[_vm._v(_vm._s(_vm.$t(("" + (item.title)))))])])])}),0):_vm._e()])])]),_c('div',{staticClass:"root-cause__show-more",on:{"click":_vm.toggle}},[(_vm.open)?_c('span',[_vm._v("Hide mitigation action -")]):_vm._e(),(!_vm.open)?_c('span',[_vm._v("Show mitigation action +")]):_vm._e()])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failures-root-cause/FailuresRootCause.vue?vue&type=template&id=5fa9912a&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/failures-info/FailuresInfo.vue + 4 modules
var FailuresInfo = __webpack_require__("33ba");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-root-cause/FailuresRootCause.vue?vue&type=script&lang=ts




let FailuresRootCausevue_type_script_lang_ts_FailuresRootCause = class FailuresRootCause extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.open = false;
    this.backgroundColor = "#B7B9BA";
    this.colors = ["#7DE9A4", "#CBF6DB", "#E3FB76", "#FF9E9B", "#FF5E59"];
    this.riskTitle = ["very low", "low", "moderate", "high", "very high"];
    this.tooltipText = "This score is calculated by multiplying the risk-scores on Probability, Severity and Detectability (for Detectability, the given scores are mirrored). The overall risk is calculated based on the outcome of the risk scores Probability x Severity x Detectability. Very Low = score 1-25, Low = score 26-50, Moderate = score 51-75, High = score 76-100, Very High = score 101-125. Note that, in case Severity has been scored High (4) or Very High (5), the overall risk score is considered to be High or Very High as well, independent of the outcome of the calculation.";
  }
  toggle() {
    this.open = !this.open;
  }
  onOpenChanged(open) {
    const elem = this.$refs.details;
    if (!open) {
      elem.style.maxHeight = "";
    } else {
      elem.style.maxHeight = elem.scrollHeight + "px";
    }
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Number
})], FailuresRootCausevue_type_script_lang_ts_FailuresRootCause.prototype, "risk", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: String
})], FailuresRootCausevue_type_script_lang_ts_FailuresRootCause.prototype, "title", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: String
})], FailuresRootCausevue_type_script_lang_ts_FailuresRootCause.prototype, "phase", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: String
})], FailuresRootCausevue_type_script_lang_ts_FailuresRootCause.prototype, "description", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Array(String)
})], FailuresRootCausevue_type_script_lang_ts_FailuresRootCause.prototype, "mitigations", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Object
})], FailuresRootCausevue_type_script_lang_ts_FailuresRootCause.prototype, "contact", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Array
})], FailuresRootCausevue_type_script_lang_ts_FailuresRootCause.prototype, "insights", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: String
})], FailuresRootCausevue_type_script_lang_ts_FailuresRootCause.prototype, "failure", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["d" /* Watch */])("open")], FailuresRootCausevue_type_script_lang_ts_FailuresRootCause.prototype, "onOpenChanged", null);
FailuresRootCausevue_type_script_lang_ts_FailuresRootCause = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */],
    FailuresInfo: FailuresInfo["a" /* default */]
  }
})], FailuresRootCausevue_type_script_lang_ts_FailuresRootCause);
/* harmony default export */ var FailuresRootCausevue_type_script_lang_ts = (FailuresRootCausevue_type_script_lang_ts_FailuresRootCause);
// CONCATENATED MODULE: ./src/components/failures-root-cause/FailuresRootCause.vue?vue&type=script&lang=ts
 /* harmony default export */ var failures_root_cause_FailuresRootCausevue_type_script_lang_ts = (FailuresRootCausevue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failures-root-cause/FailuresRootCause.vue?vue&type=style&index=0&id=5fa9912a&prod&lang=scss&scoped=true
var FailuresRootCausevue_type_style_index_0_id_5fa9912a_prod_lang_scss_scoped_true = __webpack_require__("8568");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failures-root-cause/FailuresRootCause.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failures_root_cause_FailuresRootCausevue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "5fa9912a",
  null
  
)

/* harmony default export */ var failures_root_cause_FailuresRootCause = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "bda2":
/***/ (function(module, exports) {



/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var getMethod = __webpack_require__("dc4a");
var ordinaryToPrimitive = __webpack_require__("485a");
var wellKnownSymbol = __webpack_require__("b622");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "c2cd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c4ac":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c571":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 17 16",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, attrs),
      ...rest
    }, children.concat([_c('defs', [_c('path', {
      attrs: {
        "d": "M4.499 13a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm9 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM2.92 0a.5.5 0 01.465.322l.65 1.684H15.5c.275 0 .497.222.497.497v4.925c0 .256-.19.469-.444.497 0 0-9.453 1.087-9.531 1.087-.553 0-1.019.447-1.019.997s.46.994 1.012.994h9.482c.647.028.687.95.003.997H6.02c-1.103 0-2.016-.89-2.016-1.994 0-.86.569-1.584 1.331-1.865L2.58 1H.502C-.161.99-.173.022.499 0zm9.034 3.003H9.002v2L11.999 5l-.044-1.997zM15.002 3h-2l-.003 2h2.003V3zm-7.003.003H4.42L5.193 5h2.809l-.003-1.997z",
        "id": "cartIcon"
      }
    })]), _c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-316 -248)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/cart",
        "transform": "translate(316.127 248)"
      }
    }, [_c('mask', {
      attrs: {
        "id": "mask-2",
        "fill": "#fff"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#path-1"
      }
    })]), _c('use', {
      attrs: {
        "id": "shopping-cart",
        "fill-rule": "evenodd",
        "xlink:href": "#cartIcon"
      }
    })])])])]));
  }
};

/***/ }),

/***/ "c57a":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M512 240c0 114.9-114.6 208-256 208-37.1 0-72.3-6.4-104.1-17.9-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.8 3.4-17.4l.3-.3c.3-.3.7-.7 1.3-1.4 1.1-1.2 2.8-3.1 4.9-5.7 4.1-5 9.6-12.4 15.2-21.6 10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240 0 125.1 114.6 32 256 32s256 93.1 256 208z"
      }
    })]));
  }
};

/***/ }),

/***/ "c61c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-card-question/FailuresCardQuestion.vue?vue&type=template&id=036621e0&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('failures-accordion',{attrs:{"title":_vm.title,"number":_vm.number,"disabled":_vm.question === null,"open":_vm.open},on:{"toggle":_vm.toggle}},[_c('div',{staticClass:"failure-question__padded"},[(_vm.questions[0] !== null)?_c('div',[(_vm.answers[0] !== -1)?_c('div',[_c('failures-condensed-options',{attrs:{"options":_vm.encodeOptionsForCondensed(0),"selected":_vm.answers[0]},on:{"valueChanged":function (value) {
                _vm.updateValue(0, value);
              }}})],1):_c('div',[(_vm.question.i18nDescription !== undefined)?_c('div',{staticClass:"failure-question__prompt"},[_vm._v(" "+_vm._s(_vm.questions[0].i18nDescription)+" ")]):_vm._e(),_c('failures-option-cards',{attrs:{"options":_vm.questions[0].options},on:{"valueChanged":function (value) {
                _vm.updateValue(0, value);
              }}})],1)]):_vm._e(),_vm._l((_vm.subQuestions),function(question,index){return _c('div',{key:index},[_c('div',{staticClass:"failure-question__question"},[_c('div',{staticClass:"failure-question__title"},[_vm._v(" "+_vm._s(_vm.number)+"."+_vm._s(index + 1)+". "+_vm._s(_vm.$t(question.i18nTitle))+" ")])]),(_vm.step == index + 1 && question.i18nDescription !== undefined)?_c('div',{staticClass:"failure-question__prompt"},[_vm._v(" "+_vm._s(_vm.$t(question.i18nDescription))+" ")]):_vm._e(),(_vm.answers[index + 1] !== -1)?_c('div',[_c('failures-condensed-options',{attrs:{"options":_vm.encodeOptionsForCondensed(index + 1),"selected":_vm.answers[index + 1]},on:{"valueChanged":function (value) {
                _vm.updateValue(index + 1, value);
              }}})],1):_c('div',[_c('failures-option-cards',{attrs:{"options":question.options},on:{"valueChanged":function (value) {
                _vm.updateValue(index + 1, value);
              }}})],1)])})],2)]),_c('failures-accordion',{attrs:{"simple":true,"open":!_vm.open}},[(_vm.answers[0] !== -1)?_c('failures-condensed-options',{attrs:{"options":_vm.encodeOptionsForCondensed(0),"selected":_vm.answers[0]},on:{"valueChanged":function (value) {
          _vm.updateValue(0, value);
        }}}):_vm._e(),_vm._l((_vm.answeredSubQuestions),function(question,index){return _c('div',{key:index},[_c('div',{staticClass:"failure-question__question"},[_c('div',{staticClass:"failure-question__title"},[_vm._v(" "+_vm._s(_vm.number)+"."+_vm._s(index + 1)+". "+_vm._s(_vm.$t(question.i18nTitle))+" ")])]),_c('failures-condensed-options',{attrs:{"options":_vm.encodeOptionsForCondensed(index + 1),"selected":_vm.answers[index + 1]},on:{"valueChanged":function (value) {
            _vm.updateValue(index + 1, value);
          }}})],1)})],2)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failures-card-question/FailuresCardQuestion.vue?vue&type=template&id=036621e0&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// EXTERNAL MODULE: ./src/components/failures-condensed-options/FailuresCondensedOptions.vue + 4 modules
var FailuresCondensedOptions = __webpack_require__("63e6");

// EXTERNAL MODULE: ./src/components/failures-accordion/FailuresAccordion.vue + 4 modules
var FailuresAccordion = __webpack_require__("3157");

// EXTERNAL MODULE: ./src/components/failures-option-cards/FailuresOptionCards.vue + 4 modules
var FailuresOptionCards = __webpack_require__("e0ed");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-card-question/FailuresCardQuestion.vue?vue&type=script&lang=ts






let FailuresCardQuestionvue_type_script_lang_ts_FailureQuestion = class FailureQuestion extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    // We currently allow for 3 levels of subquestions
    this.answers = [-1, -1, -1];
    this.questions = [null, null, null];
    this.step = 0;
  }
  onBaseQuestionChanged() {
    vue_property_decorator["c" /* Vue */].set(this.questions, 0, this.question);
    for (let i = 1; i < this.questions.length; ++i) {
      vue_property_decorator["c" /* Vue */].set(this.questions, i, null);
      vue_property_decorator["c" /* Vue */].set(this.answers, i, -1);
    }
    vue_property_decorator["c" /* Vue */].set(this.answers, 0, -1);
    this.step = 0;
  }
  get subQuestions() {
    return this.questions.filter(v => v != null).slice(1);
  }
  get answeredSubQuestions() {
    return this.subQuestions.filter((val, i) => val !== null && this.answers[i + 1] != -1);
  }
  // Life cycle
  created() {
    vue_property_decorator["c" /* Vue */].set(this.questions, 0, this.question);
  }
  // Logic
  encodeOptionsForCondensed(set) {
    if (this.questions[set] === null) return [];
    return this.questions[set].options.map(value => value.i18nTitle);
  }
  updateValue(step, newValue) {
    if (this.answers[step] === newValue) return;
    vue_property_decorator["c" /* Vue */].set(this.answers, step, newValue);
    this.requestOpen();
    // Invalidate everything after this step
    this.invalidate();
    for (let i = step + 1; i < this.answers.length; i++) {
      vue_property_decorator["c" /* Vue */].set(this.answers, i, -1);
      vue_property_decorator["c" /* Vue */].set(this.questions, i, null);
    }
    // Check if there is a question after this one
    if (this.questions[step].options[newValue].subQuestion !== undefined) {
      const subQ = this.questions[step].options[newValue].subQuestion;
      this.questions[step + 1] = subQ === undefined ? null : subQ;
    } else {
      // Here we've reached the end of the form, and we emit the final
      // value to the parent component.
      this.$emit("valueChanged", this.questions[step].options[newValue].data);
    }
    this.step = step + 1;
  }
  // Events
  toggle() {
    this.$emit("toggle");
  }
  invalidate() {
    this.$emit("invalidate");
  }
  // Asks the parent component to open our component
  requestOpen() {
    this.$emit("requestOpen");
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailuresCardQuestionvue_type_script_lang_ts_FailureQuestion.prototype, "title", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailuresCardQuestionvue_type_script_lang_ts_FailureQuestion.prototype, "number", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailuresCardQuestionvue_type_script_lang_ts_FailureQuestion.prototype, "question", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], FailuresCardQuestionvue_type_script_lang_ts_FailureQuestion.prototype, "open", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["d" /* Watch */])("question")], FailuresCardQuestionvue_type_script_lang_ts_FailureQuestion.prototype, "onBaseQuestionChanged", null);
FailuresCardQuestionvue_type_script_lang_ts_FailureQuestion = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */],
    FailuresAccordion: FailuresAccordion["a" /* default */],
    FailuresCondensedOptions: FailuresCondensedOptions["a" /* default */],
    FailuresOptionCards: FailuresOptionCards["a" /* default */]
  }
})], FailuresCardQuestionvue_type_script_lang_ts_FailureQuestion);
/* harmony default export */ var FailuresCardQuestionvue_type_script_lang_ts = (FailuresCardQuestionvue_type_script_lang_ts_FailureQuestion);
// CONCATENATED MODULE: ./src/components/failures-card-question/FailuresCardQuestion.vue?vue&type=script&lang=ts
 /* harmony default export */ var failures_card_question_FailuresCardQuestionvue_type_script_lang_ts = (FailuresCardQuestionvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failures-card-question/FailuresCardQuestion.vue?vue&type=style&index=0&id=036621e0&prod&lang=scss&scoped=true
var FailuresCardQuestionvue_type_style_index_0_id_036621e0_prod_lang_scss_scoped_true = __webpack_require__("3300");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failures-card-question/FailuresCardQuestion.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failures_card_question_FailuresCardQuestionvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "036621e0",
  null
  
)

/* harmony default export */ var FailuresCardQuestion = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "c65b":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "c6c9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var defineGlobalProperty = __webpack_require__("6374");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c967":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 27 27",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-429 -307)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/question",
        "transform": "translate(429 307)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M26.4 17.866a8.553 8.553 0 00-6.25-8.223C19.922 4.287 15.493 0 10.08 0 4.522 0 0 4.522 0 10.08c0 1.812.482 3.576 1.398 5.124l-1.36 4.92 4.919-1.36a10.043 10.043 0 004.686 1.386 8.553 8.553 0 008.223 6.25c1.536 0 3.03-.41 4.343-1.186l4.154 1.149-1.15-4.154a8.503 8.503 0 001.187-4.343zm-21.2-.775l-2.944.814.814-2.945-.185-.29a8.505 8.505 0 01-1.338-4.59c0-4.705 3.828-8.533 8.533-8.533 4.706 0 8.534 3.828 8.534 8.533 0 4.706-3.828 8.534-8.534 8.534a8.505 8.505 0 01-4.589-1.338l-.29-.185zm18.944 7.053l-2.185-.604-.292.19a6.96 6.96 0 01-3.8 1.123 7.004 7.004 0 01-6.624-4.76c4.631-.533 8.317-4.219 8.85-8.85a7.005 7.005 0 014.76 6.623 6.96 6.96 0 01-1.123 3.801l-.19.292.604 2.185z",
        "id": "Shape"
      }
    }), _c('path', {
      attrs: {
        "id": "Path",
        "d": "M9.307 13.973h1.547v1.547H9.307zM11.627 7.734c0 .44-.179.845-.503 1.142L9.307 10.54v1.888h1.547V11.22l1.314-1.203a3.102 3.102 0 001.006-2.283 3.097 3.097 0 00-3.094-3.093 3.097 3.097 0 00-3.093 3.093h1.547c0-.853.693-1.546 1.546-1.546.853 0 1.547.693 1.547 1.546z"
      }
    })])])])]));
  }
};

/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "cb2d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var definePropertyModule = __webpack_require__("9bf2");
var makeBuiltIn = __webpack_require__("13d2");
var defineGlobalProperty = __webpack_require__("6374");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cdce":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d0b6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailureReport_vue_vue_type_style_index_0_id_7ed54e95_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("399f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailureReport_vue_vue_type_style_index_0_id_7ed54e95_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailureReport_vue_vue_type_style_index_0_id_7ed54e95_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d509":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-progress/AdvisorProgressActiveStep.vue?vue&type=template&id=6720efcd&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advisor-progress-active-step"},[(_vm.activeStep && _vm.activeStep.index === 1)?_c('span',[_vm._v(_vm._s(_vm.$t("progress.letsStart"))+" ")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.activeStep.i18nLabel)))])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-progress/AdvisorProgressActiveStep.vue?vue&type=template&id=6720efcd&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// EXTERNAL MODULE: ./src/components/advisor.ts
var advisor = __webpack_require__("3d8c");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-progress/AdvisorProgressActiveStep.vue?vue&type=script&lang=ts




let AdvisorProgressActiveStepvue_type_script_lang_ts_AdvisorProgressActiveStep = class AdvisorProgressActiveStep extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    // expose type to template
    this.StepProgress = advisor["b" /* StepProgress */];
  }
  /**
   * Gets the first step with progress active;
   */
  get activeStep() {
    return this.steps.find(step => step.progress === advisor["b" /* StepProgress */].ACTIVE);
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorProgressActiveStepvue_type_script_lang_ts_AdvisorProgressActiveStep.prototype, "steps", void 0);
AdvisorProgressActiveStepvue_type_script_lang_ts_AdvisorProgressActiveStep = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorProgressActiveStepvue_type_script_lang_ts_AdvisorProgressActiveStep);
/* harmony default export */ var AdvisorProgressActiveStepvue_type_script_lang_ts = (AdvisorProgressActiveStepvue_type_script_lang_ts_AdvisorProgressActiveStep);
// CONCATENATED MODULE: ./src/components/advisor-progress/AdvisorProgressActiveStep.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_progress_AdvisorProgressActiveStepvue_type_script_lang_ts = (AdvisorProgressActiveStepvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-progress/AdvisorProgressActiveStep.vue?vue&type=style&index=0&id=6720efcd&prod&scoped=true&lang=scss
var AdvisorProgressActiveStepvue_type_style_index_0_id_6720efcd_prod_scoped_true_lang_scss = __webpack_require__("1183");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-progress/AdvisorProgressActiveStep.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_progress_AdvisorProgressActiveStepvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "6720efcd",
  null
  
)

/* harmony default export */ var advisor_progress_AdvisorProgressActiveStep = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "d708":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsMatchScoreTable_vue_vue_type_style_index_0_id_be5975f4_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e12e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsMatchScoreTable_vue_vue_type_style_index_0_id_be5975f4_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsMatchScoreTable_vue_vue_type_style_index_0_id_be5975f4_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d74c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d869":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 16 28",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-597 -343)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/right",
        "transform": "translate(597 343)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 14c.012.381.168.76.466 1.05l12.811 12.494a1.622 1.622 0 002.255 0 1.527 1.527 0 000-2.2L3.9 14 15.532 2.655a1.527 1.527 0 000-2.199 1.622 1.622 0 00-2.255 0L.467 12.949c-.3.292-.455.67-.467 1.051z",
        "id": "Shape",
        "transform": "matrix(-1 0 0 1 16 0)"
      }
    })])])])]));
  }
};

/***/ }),

/***/ "d977":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 14 15",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-160 -392)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/external",
        "transform": "translate(160 392.2)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M13.133 0H8.321a.864.864 0 000 1.725h2.73L6.497 6.28a.857.857 0 00-.253.61c0 .23.09.447.253.61.163.163.38.253.61.253.23 0 .447-.09.61-.253l4.554-4.554v2.73a.864.864 0 001.725 0V.863A.864.864 0 0013.133 0z",
        "id": "Path"
      }
    }), _c('path', {
      attrs: {
        "d": "M9.915 12.517H1.48V4.081h6.345l1.479-1.479H.739a.74.74 0 00-.739.74v9.915c0 .408.331.74.74.74h9.915a.74.74 0 00.74-.74V4.694l-1.48 1.478v6.345z",
        "id": "Path"
      }
    })])])])]));
  }
};

/***/ }),

/***/ "d9b5":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "daa6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorCtaBar_vue_vue_type_style_index_0_id_43e824fd_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("75f1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorCtaBar_vue_vue_type_style_index_0_id_43e824fd_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorCtaBar_vue_vue_type_style_index_0_id_43e824fd_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "db3f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8ddf");
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_0__);


/***/ }),

/***/ "dc04":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 512 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304c0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.9-22.2-26.4-22.2-56.8 0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144a31.76 31.76 0 00-34.4-5.4z"
      }
    })]));
  }
};

/***/ }),

/***/ "dc4a":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("59ed");
var isNullOrUndefined = __webpack_require__("7234");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ "dcbd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorIcon_vue_vue_type_style_index_0_id_758ece00_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("873f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorIcon_vue_vue_type_style_index_0_id_758ece00_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorIcon_vue_vue_type_style_index_0_id_758ece00_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "dcda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-bar/AdvisorResultsBar.vue?vue&type=template&id=3e7965a3&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"advisor-results-bar",class:_vm.resultsStatusClass},[_c('div',{staticClass:"container"},[_c('span',[_vm._v(_vm._s(_vm.$t("results_bar.materials_found"))),_c('span',{staticClass:"total-results"},[_vm._v(_vm._s(_vm.totalResults))])]),(_vm.adviseActive)?_c('button',{staticClass:"btn btn-sm btn-ev-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('toResultsPage')}}},[_c('span',{staticClass:"results-bar-large"},[_vm._v(_vm._s(_vm.$t("results_bar.go_to_results_directly")))]),_c('span',{staticClass:"results-bar-small"},[_vm._v(_vm._s(_vm.$t("results_bar.go_to_results")))])]):_vm._e()])]):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-results-bar/AdvisorResultsBar.vue?vue&type=template&id=3e7965a3&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-bar/AdvisorResultsBar.vue?vue&type=script&lang=ts


let AdvisorResultsBarvue_type_script_lang_ts_AdvisorResultsBar = class AdvisorResultsBar extends vue_property_decorator["c" /* Vue */] {
  get resultsStatusClass() {
    let resultsStatus = "status";
    if (this.totalResults === 0) {
      return resultsStatus += "-0";
    }
    if (this.totalResults <= parseInt(this.statusMap[0]) && this.totalResults > 0) {
      return resultsStatus += "-xs";
    }
    if (this.totalResults <= parseInt(this.statusMap[1]) && this.totalResults > 0) {
      return resultsStatus += "-sm";
    }
    if (this.totalResults <= parseInt(this.statusMap[2]) && this.totalResults > 0) {
      return resultsStatus += "-md";
    }
    return resultsStatus += "-lg";
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: true
})], AdvisorResultsBarvue_type_script_lang_ts_AdvisorResultsBar.prototype, "visible", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: 0
})], AdvisorResultsBarvue_type_script_lang_ts_AdvisorResultsBar.prototype, "totalResults", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: false
})], AdvisorResultsBarvue_type_script_lang_ts_AdvisorResultsBar.prototype, "adviseActive", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: () => [49, 99, 299],
  type: Array
})], AdvisorResultsBarvue_type_script_lang_ts_AdvisorResultsBar.prototype, "statusMap", void 0);
AdvisorResultsBarvue_type_script_lang_ts_AdvisorResultsBar = Object(tslib_es6["a" /* __decorate */])([vue_property_decorator["a" /* Component */]], AdvisorResultsBarvue_type_script_lang_ts_AdvisorResultsBar);
/* harmony default export */ var AdvisorResultsBarvue_type_script_lang_ts = (AdvisorResultsBarvue_type_script_lang_ts_AdvisorResultsBar);
// CONCATENATED MODULE: ./src/components/advisor-results-bar/AdvisorResultsBar.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_results_bar_AdvisorResultsBarvue_type_script_lang_ts = (AdvisorResultsBarvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-results-bar/AdvisorResultsBar.vue?vue&type=style&index=0&id=3e7965a3&prod&lang=scss&scoped=true
var AdvisorResultsBarvue_type_style_index_0_id_3e7965a3_prod_lang_scss_scoped_true = __webpack_require__("23de");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-results-bar/AdvisorResultsBar.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_results_bar_AdvisorResultsBarvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "3e7965a3",
  null
  
)

/* harmony default export */ var advisor_results_bar_AdvisorResultsBar = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "dcf9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "df5d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "optionDefaults", function() { return optionDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentLibrary", function() { return ComponentLibrary; });
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("db3f");
/* harmony import */ var v_tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e37d");
/* harmony import */ var _advisor_icon_AdvisorIcon_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1b70");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorIcon", function() { return _advisor_icon_AdvisorIcon_vue__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _advisor_progress_AdvisorProgress_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("951f");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorProgress", function() { return _advisor_progress_AdvisorProgress_vue__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _advisor_progress_AdvisorProgressText_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("904a");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorProgressText", function() { return _advisor_progress_AdvisorProgressText_vue__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony import */ var _advisor_progress_AdvisorProgressActiveStep_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("d509");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorProgressActiveStep", function() { return _advisor_progress_AdvisorProgressActiveStep_vue__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony import */ var _advisor_floating_actions_AdvisorFloatingActions_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8990");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorFloatingActions", function() { return _advisor_floating_actions_AdvisorFloatingActions_vue__WEBPACK_IMPORTED_MODULE_6__["a"]; });

/* harmony import */ var _advisor_floating_actions_AdvisorShare_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("a54b");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorShare", function() { return _advisor_floating_actions_AdvisorShare_vue__WEBPACK_IMPORTED_MODULE_7__["a"]; });

/* harmony import */ var _advisor_question_AdvisorQuestion_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("b4b0");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorQuestion", function() { return _advisor_question_AdvisorQuestion_vue__WEBPACK_IMPORTED_MODULE_8__["a"]; });

/* harmony import */ var _advisor_question_filter_AdvisorQuestionFilter_vue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ffc4");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorQuestionFilter", function() { return _advisor_question_filter_AdvisorQuestionFilter_vue__WEBPACK_IMPORTED_MODULE_9__["a"]; });

/* harmony import */ var _advisor_refine_question_AdvisorRefineQuestion_vue__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("6e04");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorRefineQuestion", function() { return _advisor_refine_question_AdvisorRefineQuestion_vue__WEBPACK_IMPORTED_MODULE_10__["a"]; });

/* harmony import */ var _advisor_refine_question_AdvisorRefineQuestionSimple_vue__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("f20a");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorRefineQuestionSimple", function() { return _advisor_refine_question_AdvisorRefineQuestionSimple_vue__WEBPACK_IMPORTED_MODULE_11__["a"]; });

/* harmony import */ var _advisor_results_bar_AdvisorResultsBar_vue__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("dcda");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorResultsBar", function() { return _advisor_results_bar_AdvisorResultsBar_vue__WEBPACK_IMPORTED_MODULE_12__["a"]; });

/* harmony import */ var _advisor_results_total_AdvisorResultsTotal_vue__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("04fe");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorResultsTotal", function() { return _advisor_results_total_AdvisorResultsTotal_vue__WEBPACK_IMPORTED_MODULE_13__["a"]; });

/* harmony import */ var _advisor_results_item_AdvisorResultsItem_vue__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("5fac");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorResultsItem", function() { return _advisor_results_item_AdvisorResultsItem_vue__WEBPACK_IMPORTED_MODULE_14__["a"]; });

/* harmony import */ var _advisor_results_item_rd_AdvisorResultsItemRd_vue__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("69fd");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorResultsItemRd", function() { return _advisor_results_item_rd_AdvisorResultsItemRd_vue__WEBPACK_IMPORTED_MODULE_15__["a"]; });

/* harmony import */ var _advisor_results_item_rd_AdvisorResultsItemSm_vue__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("f771");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorResultsItemSm", function() { return _advisor_results_item_rd_AdvisorResultsItemSm_vue__WEBPACK_IMPORTED_MODULE_16__["a"]; });

/* harmony import */ var _advisor_results_tab_AdvisorResultsButtonList_vue__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("62ad");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorResultsButtonList", function() { return _advisor_results_tab_AdvisorResultsButtonList_vue__WEBPACK_IMPORTED_MODULE_17__["a"]; });

/* harmony import */ var _advisor_results_tab_AdvisorResultsLinkList_vue__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("31d3");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorResultsLinkList", function() { return _advisor_results_tab_AdvisorResultsLinkList_vue__WEBPACK_IMPORTED_MODULE_18__["a"]; });

/* harmony import */ var _advisor_results_tab_AdvisorResultsMatchScoreTable_vue__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("f9ca");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorResultsMatchScoreTable", function() { return _advisor_results_tab_AdvisorResultsMatchScoreTable_vue__WEBPACK_IMPORTED_MODULE_19__["a"]; });

/* harmony import */ var _advisor_tabs_AdvisorTabs_vue__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("a382");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorTabs", function() { return _advisor_tabs_AdvisorTabs_vue__WEBPACK_IMPORTED_MODULE_20__["a"]; });

/* harmony import */ var _advisor_tab_AdvisorTab_vue__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("7d2f");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorTab", function() { return _advisor_tab_AdvisorTab_vue__WEBPACK_IMPORTED_MODULE_21__["a"]; });

/* harmony import */ var _advisor_cta_bar_AdvisorCtaBar_vue__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("1af0");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorCtaBar", function() { return _advisor_cta_bar_AdvisorCtaBar_vue__WEBPACK_IMPORTED_MODULE_22__["a"]; });

/* harmony import */ var _advisor_compare_AdvisorCompare_vue__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("32e0");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorCompare", function() { return _advisor_compare_AdvisorCompare_vue__WEBPACK_IMPORTED_MODULE_23__["a"]; });

/* harmony import */ var _advisor_spinner_AdvisorSpinner_vue__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("3891");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorSpinner", function() { return _advisor_spinner_AdvisorSpinner_vue__WEBPACK_IMPORTED_MODULE_24__["a"]; });

/* harmony import */ var _advisor_breadcrumb_AdvisorBreadcrumb_vue__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("e36c");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdvisorBreadcrumb", function() { return _advisor_breadcrumb_AdvisorBreadcrumb_vue__WEBPACK_IMPORTED_MODULE_25__["a"]; });

/* harmony import */ var _advisor__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("3d8c");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StepEvent", function() { return _advisor__WEBPACK_IMPORTED_MODULE_26__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StepType", function() { return _advisor__WEBPACK_IMPORTED_MODULE_26__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StepProgress", function() { return _advisor__WEBPACK_IMPORTED_MODULE_26__["b"]; });

/* harmony import */ var _failures_accordion_FailuresAccordion_vue__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("3157");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailuresAccordion", function() { return _failures_accordion_FailuresAccordion_vue__WEBPACK_IMPORTED_MODULE_27__["a"]; });

/* harmony import */ var _failures_condensed_options_FailuresCondensedOptions_vue__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("63e6");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailuresCondensedOptions", function() { return _failures_condensed_options_FailuresCondensedOptions_vue__WEBPACK_IMPORTED_MODULE_28__["a"]; });

/* harmony import */ var _failures_related_insights_FailuresRelatedInsights_vue__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("9030");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailuresRelatedInsights", function() { return _failures_related_insights_FailuresRelatedInsights_vue__WEBPACK_IMPORTED_MODULE_29__["a"]; });

/* harmony import */ var _failures_risk_picker_FailuresRiskPicker_vue__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("1538");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailuresRiskPicker", function() { return _failures_risk_picker_FailuresRiskPicker_vue__WEBPACK_IMPORTED_MODULE_30__["a"]; });

/* harmony import */ var _failures_risk_value_FailuresRiskValue_vue__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("9bdc");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailuresRiskValue", function() { return _failures_risk_value_FailuresRiskValue_vue__WEBPACK_IMPORTED_MODULE_31__["a"]; });

/* harmony import */ var _failures_root_cause_FailuresRootCause_vue__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("bbe7");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailuresRootCause", function() { return _failures_root_cause_FailuresRootCause_vue__WEBPACK_IMPORTED_MODULE_32__["a"]; });

/* harmony import */ var _failures_root_cause_list_FailuresRootCauseList_vue__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("5380");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailuresRootCauseList", function() { return _failures_root_cause_list_FailuresRootCauseList_vue__WEBPACK_IMPORTED_MODULE_33__["a"]; });

/* harmony import */ var _failure_question_FailureQuestion_vue__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("3d27");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailureQuestion", function() { return _failure_question_FailureQuestion_vue__WEBPACK_IMPORTED_MODULE_34__["a"]; });

/* harmony import */ var _failure_disclaimer_FailureDisclaimer_vue__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__("8965");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailureDisclaimer", function() { return _failure_disclaimer_FailureDisclaimer_vue__WEBPACK_IMPORTED_MODULE_35__["a"]; });

/* harmony import */ var _failure_report_FailureReport_vue__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__("265c");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailureReport", function() { return _failure_report_FailureReport_vue__WEBPACK_IMPORTED_MODULE_36__["a"]; });

/* harmony import */ var _failures_option_cards_FailuresOptionCards_vue__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__("e0ed");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailuresOptionCards", function() { return _failures_option_cards_FailuresOptionCards_vue__WEBPACK_IMPORTED_MODULE_37__["a"]; });

/* harmony import */ var _failures_card_question_FailuresCardQuestion_vue__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__("c61c");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailuresCardQuestion", function() { return _failures_card_question_FailuresCardQuestion_vue__WEBPACK_IMPORTED_MODULE_38__["a"]; });

/* harmony import */ var _failures_header_FailuresHeader_vue__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__("93b2");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailuresHeader", function() { return _failures_header_FailuresHeader_vue__WEBPACK_IMPORTED_MODULE_39__["a"]; });

/* harmony import */ var _failures_info_FailuresInfo_vue__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__("33ba");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FailuresInfo", function() { return _failures_info_FailuresInfo_vue__WEBPACK_IMPORTED_MODULE_40__["a"]; });

/* harmony import */ var _failures__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__("bda2");
/* harmony import */ var _failures__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_failures__WEBPACK_IMPORTED_MODULE_41__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _failures__WEBPACK_IMPORTED_MODULE_41__) if(["default","optionDefaults","ComponentLibrary","AdvisorIcon","AdvisorProgress","AdvisorProgressText","AdvisorProgressActiveStep","AdvisorFloatingActions","AdvisorShare","AdvisorQuestion","AdvisorQuestionFilter","AdvisorRefineQuestion","AdvisorRefineQuestionSimple","AdvisorResultsBar","AdvisorResultsTotal","AdvisorResultsItem","AdvisorResultsItemRd","AdvisorResultsItemSm","AdvisorResultsButtonList","AdvisorResultsLinkList","AdvisorResultsMatchScoreTable","AdvisorTabs","AdvisorTab","AdvisorCtaBar","AdvisorCompare","AdvisorSpinner","AdvisorBreadcrumb","FailuresAccordion","FailuresCondensedOptions","FailuresRelatedInsights","FailuresRiskPicker","FailuresRiskValue","FailuresRootCause","FailuresRootCauseList","FailureQuestion","FailureDisclaimer","FailureReport","FailuresOptionCards","FailuresCardQuestion","FailuresHeader","FailuresInfo","version","StepEvent","StepType","StepProgress"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _failures__WEBPACK_IMPORTED_MODULE_41__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _version__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__("9a47");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "version", function() { return _version__WEBPACK_IMPORTED_MODULE_42__["a"]; });




// 3rd party

// 1. Add any default options for use in application
const optionDefaults = {
  vtooltip: {
    defaultTrigger: "hover focus click",
    autoHide: false
  }
};
const ComponentLibrary = {
  install(Vue, opts = {}) {
    // combine options
    const options = Object.assign({}, optionDefaults, opts);
    // use given i18n library
    if (options.i18n) {
      Vue.use(options.i18n);
    }
    Vue.use(v_tooltip__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], options.vtooltip);
  }
};
// 2. Make sure to export component

























// Failure modes tool project

















/***/ }),

/***/ "e0ed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-option-cards/FailuresOptionCards.vue?vue&type=template&id=ba6667fc&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"failure-question"},[_c('div',{staticClass:"failure-question__wrapper"},[_c('div',{staticClass:"failure-question__answers-list",class:{ 'answers-more-then-two': _vm.options.length > 2 }},_vm._l((_vm.options),function(value,index){return _c('label',{key:index,staticClass:"failure-question__answer-item bg-img-gradient gradient-blue-500",on:{"click":function($event){return _vm.valueChanged(index)}}},[_c('div',{staticClass:"failure-question__image bg-img",style:({ backgroundImage: ("url(" + (value.image) + ")") })}),_c('div',{staticClass:"failure-question__answer-inner"},[_c('h3',{staticClass:"failure-question__answer-title"},[_vm._v(" "+_vm._s(_vm.$t(value.i18nTitle))+" ")]),_c('p',{staticClass:"failure-question__answer-description"},[_vm._v(" "+_vm._s(_vm.$t(value.i18nDescription))+" ")])])])}),0)])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/failures-option-cards/FailuresOptionCards.vue?vue&type=template&id=ba6667fc&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/failures-option-cards/FailuresOptionCards.vue?vue&type=script&lang=ts



let FailuresOptionCardsvue_type_script_lang_ts_FailureQuestion = class FailureQuestion extends vue_property_decorator["c" /* Vue */] {
  valueChanged(option) {
    this.$emit("valueChanged", option);
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Array(Object)
})], FailuresOptionCardsvue_type_script_lang_ts_FailureQuestion.prototype, "options", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  type: Number
})], FailuresOptionCardsvue_type_script_lang_ts_FailureQuestion.prototype, "selected", void 0);
FailuresOptionCardsvue_type_script_lang_ts_FailureQuestion = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], FailuresOptionCardsvue_type_script_lang_ts_FailureQuestion);
/* harmony default export */ var FailuresOptionCardsvue_type_script_lang_ts = (FailuresOptionCardsvue_type_script_lang_ts_FailureQuestion);
// CONCATENATED MODULE: ./src/components/failures-option-cards/FailuresOptionCards.vue?vue&type=script&lang=ts
 /* harmony default export */ var failures_option_cards_FailuresOptionCardsvue_type_script_lang_ts = (FailuresOptionCardsvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/failures-option-cards/FailuresOptionCards.vue?vue&type=style&index=0&id=ba6667fc&prod&lang=scss&scoped=true
var FailuresOptionCardsvue_type_style_index_0_id_ba6667fc_prod_lang_scss_scoped_true = __webpack_require__("e235");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/failures-option-cards/FailuresOptionCards.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  failures_option_cards_FailuresOptionCardsvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "ba6667fc",
  null
  
)

/* harmony default export */ var FailuresOptionCards = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "e12e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "e216":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 22 20",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, attrs),
      ...rest
    }, children.concat([_c('defs', [_c('path', {
      attrs: {
        "d": "M22 5.806c0 .254-.09.47-.267.649a.884.884 0 01-.65.267.884.884 0 01-.649-.267L19.059 5.08 9.778 14.4a.884.884 0 01-.65.267.884.884 0 01-.649-.268l-.878-.878a.884.884 0 01-.268-.65c0-.254.09-.47.268-.649l9.32-9.281-1.376-1.375a.884.884 0 01-.267-.65c0-.254.089-.47.267-.649a.884.884 0 01.65-.267h4.888c.255 0 .471.09.65.267a.884.884 0 01.267.65v4.889zm-6.455 4.545a.776.776 0 01.65-.287.997.997 0 01.649.268c.178.165.267.388.267.668v6.722c0 .51-.178.942-.535 1.299-.356.356-.789.535-1.298.535H1.833c-.509 0-.942-.179-1.298-.535A1.768 1.768 0 010 17.722V4.278c0-.51.178-.942.535-1.299.356-.356.79-.535 1.298-.535H13.14c.254 0 .47.09.65.268a.884.884 0 01.267.65c0 .254-.09.47-.268.648l-.61.612a.884.884 0 01-.65.267H2.444V17.11h12.223v-5.5c0-.255.089-.47.267-.65l.611-.61z",
        "id": "path-1"
      }
    })]), _c('g', {
      attrs: {
        "id": "Artboard-Copy",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Group"
      }
    }, [_c('g', {
      attrs: {
        "id": "Regular/calendar-times-Copy"
      }
    }, [_c('mask', {
      attrs: {
        "id": "mask-2",
        "fill": "#fff"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#path-1"
      }
    })]), _c('use', {
      attrs: {
        "id": "",
        "fill": "#009FE3",
        "xlink:href": "#path-1"
      }
    }), _c('g', {
      attrs: {
        "id": "Group",
        "mask": "url(#mask-2)",
        "fill": "#003478"
      }
    }, [_c('g', {
      attrs: {
        "id": "Branding-/-Colors-/-DSM-Cyan"
      }
    }, [_c('path', {
      attrs: {
        "id": "Rectangle-Copy",
        "d": "M0 0h22v19.556H0z"
      }
    })])])])])])]));
  }
};

/***/ }),

/***/ "e235":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresOptionCards_vue_vue_type_style_index_0_id_ba6667fc_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d74c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresOptionCards_vue_vue_type_style_index_0_id_ba6667fc_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresOptionCards_vue_vue_type_style_index_0_id_ba6667fc_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e330":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var uncurryThis = NATIVE_BIND && bind.bind(call, call);

module.exports = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis(fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "e36c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-breadcrumb/AdvisorBreadcrumb.vue?vue&type=template&id=400001a0&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible && _vm.steps.length > 0)?_c('ul',{staticClass:"breadcrumb"},_vm._l((_vm.steps),function(step,index){return _c('li',{key:step.index,staticClass:"breadcrumb-item",on:{"click":function($event){index < _vm.steps.length - 1 ? _vm.onStep(step) : ''}}},[_vm._v(" "+_vm._s(_vm.$t(step.i18nPath))+" ")])}),0):_vm._e()}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-breadcrumb/AdvisorBreadcrumb.vue?vue&type=template&id=400001a0&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-breadcrumb/AdvisorBreadcrumb.vue?vue&type=script&lang=ts


let AdvisorBreadcrumbvue_type_script_lang_ts_AdvisorBreadcrumb = class AdvisorBreadcrumb extends vue_property_decorator["c" /* Vue */] {
  onStep(step) {
    if (typeof step.index !== "undefined") {
      this.$emit("step", step);
    }
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: false
})], AdvisorBreadcrumbvue_type_script_lang_ts_AdvisorBreadcrumb.prototype, "visible", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorBreadcrumbvue_type_script_lang_ts_AdvisorBreadcrumb.prototype, "steps", void 0);
AdvisorBreadcrumbvue_type_script_lang_ts_AdvisorBreadcrumb = Object(tslib_es6["a" /* __decorate */])([vue_property_decorator["a" /* Component */]], AdvisorBreadcrumbvue_type_script_lang_ts_AdvisorBreadcrumb);
/* harmony default export */ var AdvisorBreadcrumbvue_type_script_lang_ts = (AdvisorBreadcrumbvue_type_script_lang_ts_AdvisorBreadcrumb);
// CONCATENATED MODULE: ./src/components/advisor-breadcrumb/AdvisorBreadcrumb.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_breadcrumb_AdvisorBreadcrumbvue_type_script_lang_ts = (AdvisorBreadcrumbvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-breadcrumb/AdvisorBreadcrumb.vue?vue&type=style&index=0&id=400001a0&prod&scoped=true&lang=scss
var AdvisorBreadcrumbvue_type_style_index_0_id_400001a0_prod_scoped_true_lang_scss = __webpack_require__("4699");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-breadcrumb/AdvisorBreadcrumb.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_breadcrumb_AdvisorBreadcrumbvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "400001a0",
  null
  
)

/* harmony default export */ var advisor_breadcrumb_AdvisorBreadcrumb = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "e37d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export VClosePopover */
/* unused harmony export VPopover */
/* unused harmony export VTooltip */
/* unused harmony export createTooltip */
/* unused harmony export destroyTooltip */
/* unused harmony export install */
/* harmony import */ var popper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f0bd");
/* harmony import */ var vue_resize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("252c");



function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var SVGAnimatedString = function SVGAnimatedString() {};

if (typeof window !== 'undefined') {
  SVGAnimatedString = window.SVGAnimatedString;
}

function convertToArray(value) {
  if (typeof value === 'string') {
    value = value.split(' ');
  }

  return value;
}
/**
 * Add classes to an element.
 * This method checks to ensure that the classes don't already exist before adding them.
 * It uses el.className rather than classList in order to be IE friendly.
 * @param {object} el - The element to add the classes to.
 * @param {classes} string - List of space separated classes to be added to the element.
 */

function addClasses(el, classes) {
  var newClasses = convertToArray(classes);
  var classList;

  if (el.className instanceof SVGAnimatedString) {
    classList = convertToArray(el.className.baseVal);
  } else {
    classList = convertToArray(el.className);
  }

  newClasses.forEach(function (newClass) {
    if (classList.indexOf(newClass) === -1) {
      classList.push(newClass);
    }
  });

  if (el instanceof SVGElement) {
    el.setAttribute('class', classList.join(' '));
  } else {
    el.className = classList.join(' ');
  }
}
/**
 * Remove classes from an element.
 * It uses el.className rather than classList in order to be IE friendly.
 * @export
 * @param {any} el The element to remove the classes from.
 * @param {any} classes List of space separated classes to be removed from the element.
 */

function removeClasses(el, classes) {
  var newClasses = convertToArray(classes);
  var classList;

  if (el.className instanceof SVGAnimatedString) {
    classList = convertToArray(el.className.baseVal);
  } else {
    classList = convertToArray(el.className);
  }

  newClasses.forEach(function (newClass) {
    var index = classList.indexOf(newClass);

    if (index !== -1) {
      classList.splice(index, 1);
    }
  });

  if (el instanceof SVGElement) {
    el.setAttribute('class', classList.join(' '));
  } else {
    el.className = classList.join(' ');
  }
}
var supportsPassive = false;

if (typeof window !== 'undefined') {
  supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}
}

var DEFAULT_OPTIONS = {
  container: false,
  delay: 0,
  html: false,
  placement: 'top',
  title: '',
  template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  trigger: 'hover focus',
  offset: 0
};
var openTooltips = [];

var Tooltip =
/*#__PURE__*/
function () {
  /**
   * Create a new Tooltip.js instance
   * @class Tooltip
   * @param {HTMLElement} reference - The DOM node used as reference of the tooltip (it can be a jQuery element).
   * @param {Object} options
   * @param {String} options.placement=bottom
   *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -end),
   *      left(-start, -end)`
   * @param {HTMLElement|String|false} options.container=false - Append the tooltip to a specific element.
   * @param {Number|Object} options.delay=0
   *      Delay showing and hiding the tooltip (ms) - does not apply to manual trigger type.
   *      If a number is supplied, delay is applied to both hide/show.
   *      Object structure is: `{ show: 500, hide: 100 }`
   * @param {Boolean} options.html=false - Insert HTML into the tooltip. If false, the content will inserted with `innerText`.
   * @param {String|PlacementFunction} options.placement='top' - One of the allowed placements, or a function returning one of them.
   * @param {String} [options.template='<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>']
   *      Base HTML to used when creating the tooltip.
   *      The tooltip's `title` will be injected into the `.tooltip-inner` or `.tooltip__inner`.
   *      `.tooltip-arrow` or `.tooltip__arrow` will become the tooltip's arrow.
   *      The outermost wrapper element should have the `.tooltip` class.
   * @param {String|HTMLElement|TitleFunction} options.title='' - Default title value if `title` attribute isn't present.
   * @param {String} [options.trigger='hover focus']
   *      How tooltip is triggered - click, hover, focus, manual.
   *      You may pass multiple triggers; separate them with a space. `manual` cannot be combined with any other trigger.
   * @param {HTMLElement} options.boundariesElement
   *      The element used as boundaries for the tooltip. For more information refer to Popper.js'
   *      [boundariesElement docs](https://popper.js.org/popper-documentation.html)
   * @param {Number|String} options.offset=0 - Offset of the tooltip relative to its reference. For more information refer to Popper.js'
   *      [offset docs](https://popper.js.org/popper-documentation.html)
   * @param {Object} options.popperOptions={} - Popper options, will be passed directly to popper instance. For more information refer to Popper.js'
   *      [options docs](https://popper.js.org/popper-documentation.html)
   * @return {Object} instance - The generated tooltip instance
   */
  function Tooltip(_reference, _options) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    _defineProperty(this, "_events", []);

    _defineProperty(this, "_setTooltipNodeEvent", function (evt, reference, delay, options) {
      var relatedreference = evt.relatedreference || evt.toElement || evt.relatedTarget;

      var callback = function callback(evt2) {
        var relatedreference2 = evt2.relatedreference || evt2.toElement || evt2.relatedTarget; // Remove event listener after call

        _this._tooltipNode.removeEventListener(evt.type, callback); // If the new reference is not the reference element


        if (!reference.contains(relatedreference2)) {
          // Schedule to hide tooltip
          _this._scheduleHide(reference, options.delay, options, evt2);
        }
      };

      if (_this._tooltipNode.contains(relatedreference)) {
        // listen to mouseleave on the tooltip element to be able to hide the tooltip
        _this._tooltipNode.addEventListener(evt.type, callback);

        return true;
      }

      return false;
    });

    // apply user options over default ones
    _options = _objectSpread({}, DEFAULT_OPTIONS, _options);
    _reference.jquery && (_reference = _reference[0]);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this); // cache reference and options

    this.reference = _reference;
    this.options = _options; // set initial state

    this._isOpen = false;

    this._init();
  } //
  // Public methods
  //

  /**
   * Reveals an element's tooltip. This is considered a "manual" triggering of the tooltip.
   * Tooltips with zero-length titles are never displayed.
   * @method Tooltip#show
   * @memberof Tooltip
   */


  _createClass(Tooltip, [{
    key: "show",
    value: function show() {
      this._show(this.reference, this.options);
    }
    /**
     * Hides an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * @method Tooltip#hide
     * @memberof Tooltip
     */

  }, {
    key: "hide",
    value: function hide() {
      this._hide();
    }
    /**
     * Hides and destroys an element’s tooltip.
     * @method Tooltip#dispose
     * @memberof Tooltip
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this._dispose();
    }
    /**
     * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * @method Tooltip#toggle
     * @memberof Tooltip
     */

  }, {
    key: "toggle",
    value: function toggle() {
      if (this._isOpen) {
        return this.hide();
      } else {
        return this.show();
      }
    }
  }, {
    key: "setClasses",
    value: function setClasses(classes) {
      this._classes = classes;
    }
  }, {
    key: "setContent",
    value: function setContent(content) {
      this.options.title = content;

      if (this._tooltipNode) {
        this._setContent(content, this.options);
      }
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var classesUpdated = false;
      var classes = options && options.classes || directive.options.defaultClass;

      if (this._classes !== classes) {
        this.setClasses(classes);
        classesUpdated = true;
      }

      options = getOptions(options);
      var needPopperUpdate = false;
      var needRestart = false;

      if (this.options.offset !== options.offset || this.options.placement !== options.placement) {
        needPopperUpdate = true;
      }

      if (this.options.template !== options.template || this.options.trigger !== options.trigger || this.options.container !== options.container || classesUpdated) {
        needRestart = true;
      }

      for (var key in options) {
        this.options[key] = options[key];
      }

      if (this._tooltipNode) {
        if (needRestart) {
          var isOpen = this._isOpen;
          this.dispose();

          this._init();

          if (isOpen) {
            this.show();
          }
        } else if (needPopperUpdate) {
          this.popperInstance.update();
        }
      }
    } //
    // Private methods
    //

  }, {
    key: "_init",
    value: function _init() {
      // get events list
      var events = typeof this.options.trigger === 'string' ? this.options.trigger.split(' ') : [];
      this._isDisposed = false;
      this._enableDocumentTouch = events.indexOf('manual') === -1;
      events = events.filter(function (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
      }); // set event listeners

      this._setEventListeners(this.reference, events, this.options); // title attribute


      this.$_originalTitle = this.reference.getAttribute('title');
      this.reference.removeAttribute('title');
      this.reference.setAttribute('data-original-title', this.$_originalTitle);
    }
    /**
     * Creates a new tooltip node
     * @memberof Tooltip
     * @private
     * @param {HTMLElement} reference
     * @param {String} template
     * @param {String|HTMLElement|TitleFunction} title
     * @param {Boolean} allowHtml
     * @return {HTMLelement} tooltipNode
     */

  }, {
    key: "_create",
    value: function _create(reference, template) {
      // create tooltip element
      var tooltipGenerator = window.document.createElement('div');
      tooltipGenerator.innerHTML = template.trim();
      var tooltipNode = tooltipGenerator.childNodes[0]; // add unique ID to our tooltip (needed for accessibility reasons)

      tooltipNode.id = "tooltip_".concat(Math.random().toString(36).substr(2, 10)); // Initially hide the tooltip
      // The attribute will be switched in a next frame so
      // CSS transitions can play

      tooltipNode.setAttribute('aria-hidden', 'true');

      if (this.options.autoHide && this.options.trigger.indexOf('hover') !== -1) {
        tooltipNode.addEventListener('mouseenter', this.hide);
        tooltipNode.addEventListener('click', this.hide);
      } // return the generated tooltip node


      return tooltipNode;
    }
  }, {
    key: "_setContent",
    value: function _setContent(content, options) {
      var _this2 = this;

      this.asyncContent = false;

      this._applyContent(content, options).then(function () {
        _this2.popperInstance.update();
      });
    }
  }, {
    key: "_applyContent",
    value: function _applyContent(title, options) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var allowHtml = options.html;
        var rootNode = _this3._tooltipNode;
        if (!rootNode) return;
        var titleNode = rootNode.querySelector(_this3.options.innerSelector);

        if (title.nodeType === 1) {
          // if title is a node, append it only if allowHtml is true
          if (allowHtml) {
            while (titleNode.firstChild) {
              titleNode.removeChild(titleNode.firstChild);
            }

            titleNode.appendChild(title);
          }
        } else if (typeof title === 'function') {
          // if title is a function, call it and set innerText or innerHtml depending by `allowHtml` value
          var result = title();

          if (result && typeof result.then === 'function') {
            _this3.asyncContent = true;
            options.loadingClass && addClasses(rootNode, options.loadingClass);

            if (options.loadingContent) {
              _this3._applyContent(options.loadingContent, options);
            }

            result.then(function (asyncResult) {
              options.loadingClass && removeClasses(rootNode, options.loadingClass);
              return _this3._applyContent(asyncResult, options);
            }).then(resolve).catch(reject);
          } else {
            _this3._applyContent(result, options).then(resolve).catch(reject);
          }

          return;
        } else {
          // if it's just a simple text, set innerText or innerHtml depending by `allowHtml` value
          allowHtml ? titleNode.innerHTML = title : titleNode.innerText = title;
        }

        resolve();
      });
    }
  }, {
    key: "_show",
    value: function _show(reference, options) {
      if (options && typeof options.container === 'string') {
        var container = document.querySelector(options.container);
        if (!container) return;
      }

      clearTimeout(this._disposeTimer);
      options = Object.assign({}, options);
      delete options.offset;
      var updateClasses = true;

      if (this._tooltipNode) {
        addClasses(this._tooltipNode, this._classes);
        updateClasses = false;
      }

      var result = this._ensureShown(reference, options);

      if (updateClasses && this._tooltipNode) {
        addClasses(this._tooltipNode, this._classes);
      }

      addClasses(reference, ['v-tooltip-open']);
      return result;
    }
  }, {
    key: "_ensureShown",
    value: function _ensureShown(reference, options) {
      var _this4 = this;

      // don't show if it's already visible
      if (this._isOpen) {
        return this;
      }

      this._isOpen = true;
      openTooltips.push(this); // if the tooltipNode already exists, just show it

      if (this._tooltipNode) {
        this._tooltipNode.style.display = '';

        this._tooltipNode.setAttribute('aria-hidden', 'false');

        this.popperInstance.enableEventListeners();
        this.popperInstance.update();

        if (this.asyncContent) {
          this._setContent(options.title, options);
        }

        return this;
      } // get title


      var title = reference.getAttribute('title') || options.title; // don't show tooltip if no title is defined

      if (!title) {
        return this;
      } // create tooltip node


      var tooltipNode = this._create(reference, options.template);

      this._tooltipNode = tooltipNode; // Add `aria-describedby` to our reference element for accessibility reasons

      reference.setAttribute('aria-describedby', tooltipNode.id); // append tooltip to container

      var container = this._findContainer(options.container, reference);

      this._append(tooltipNode, container);

      var popperOptions = _objectSpread({}, options.popperOptions, {
        placement: options.placement
      });

      popperOptions.modifiers = _objectSpread({}, popperOptions.modifiers, {
        arrow: {
          element: this.options.arrowSelector
        }
      });

      if (options.boundariesElement) {
        popperOptions.modifiers.preventOverflow = {
          boundariesElement: options.boundariesElement
        };
      }

      this.popperInstance = new popper_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](reference, tooltipNode, popperOptions);

      this._setContent(title, options); // Fix position


      requestAnimationFrame(function () {
        if (!_this4._isDisposed && _this4.popperInstance) {
          _this4.popperInstance.update(); // Show the tooltip


          requestAnimationFrame(function () {
            if (!_this4._isDisposed) {
              _this4._isOpen && tooltipNode.setAttribute('aria-hidden', 'false');
            } else {
              _this4.dispose();
            }
          });
        } else {
          _this4.dispose();
        }
      });
      return this;
    }
  }, {
    key: "_noLongerOpen",
    value: function _noLongerOpen() {
      var index = openTooltips.indexOf(this);

      if (index !== -1) {
        openTooltips.splice(index, 1);
      }
    }
  }, {
    key: "_hide",
    value: function _hide()
    /* reference, options */
    {
      var _this5 = this;

      // don't hide if it's already hidden
      if (!this._isOpen) {
        return this;
      }

      this._isOpen = false;

      this._noLongerOpen(); // hide tooltipNode


      this._tooltipNode.style.display = 'none';

      this._tooltipNode.setAttribute('aria-hidden', 'true');

      this.popperInstance.disableEventListeners();
      clearTimeout(this._disposeTimer);
      var disposeTime = directive.options.disposeTimeout;

      if (disposeTime !== null) {
        this._disposeTimer = setTimeout(function () {
          if (_this5._tooltipNode) {
            _this5._tooltipNode.removeEventListener('mouseenter', _this5.hide);

            _this5._tooltipNode.removeEventListener('click', _this5.hide); // Don't remove popper instance, just the HTML element


            _this5._removeTooltipNode();
          }
        }, disposeTime);
      }

      removeClasses(this.reference, ['v-tooltip-open']);
      return this;
    }
  }, {
    key: "_removeTooltipNode",
    value: function _removeTooltipNode() {
      if (!this._tooltipNode) return;
      var parentNode = this._tooltipNode.parentNode;

      if (parentNode) {
        parentNode.removeChild(this._tooltipNode);
        this.reference.removeAttribute('aria-describedby');
      }

      this._tooltipNode = null;
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      var _this6 = this;

      this._isDisposed = true;
      this.reference.removeAttribute('data-original-title');

      if (this.$_originalTitle) {
        this.reference.setAttribute('title', this.$_originalTitle);
      } // remove event listeners first to prevent any unexpected behaviour


      this._events.forEach(function (_ref) {
        var func = _ref.func,
            event = _ref.event;

        _this6.reference.removeEventListener(event, func);
      });

      this._events = [];

      if (this._tooltipNode) {
        this._hide();

        this._tooltipNode.removeEventListener('mouseenter', this.hide);

        this._tooltipNode.removeEventListener('click', this.hide); // destroy instance


        this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

        if (!this.popperInstance.options.removeOnDestroy) {
          this._removeTooltipNode();
        }
      } else {
        this._noLongerOpen();
      }

      return this;
    }
  }, {
    key: "_findContainer",
    value: function _findContainer(container, reference) {
      // if container is a query, get the relative element
      if (typeof container === 'string') {
        container = window.document.querySelector(container);
      } else if (container === false) {
        // if container is `false`, set it to reference parent
        container = reference.parentNode;
      }

      return container;
    }
    /**
     * Append tooltip to container
     * @memberof Tooltip
     * @private
     * @param {HTMLElement} tooltip
     * @param {HTMLElement|String|false} container
     */

  }, {
    key: "_append",
    value: function _append(tooltipNode, container) {
      container.appendChild(tooltipNode);
    }
  }, {
    key: "_setEventListeners",
    value: function _setEventListeners(reference, events, options) {
      var _this7 = this;

      var directEvents = [];
      var oppositeEvents = [];
      events.forEach(function (event) {
        switch (event) {
          case 'hover':
            directEvents.push('mouseenter');
            oppositeEvents.push('mouseleave');
            if (_this7.options.hideOnTargetClick) oppositeEvents.push('click');
            break;

          case 'focus':
            directEvents.push('focus');
            oppositeEvents.push('blur');
            if (_this7.options.hideOnTargetClick) oppositeEvents.push('click');
            break;

          case 'click':
            directEvents.push('click');
            oppositeEvents.push('click');
            break;
        }
      }); // schedule show tooltip

      directEvents.forEach(function (event) {
        var func = function func(evt) {
          if (_this7._isOpen === true) {
            return;
          }

          evt.usedByTooltip = true;

          _this7._scheduleShow(reference, options.delay, options, evt);
        };

        _this7._events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      }); // schedule hide tooltip

      oppositeEvents.forEach(function (event) {
        var func = function func(evt) {
          if (evt.usedByTooltip === true) {
            return;
          }

          _this7._scheduleHide(reference, options.delay, options, evt);
        };

        _this7._events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });
    }
  }, {
    key: "_onDocumentTouch",
    value: function _onDocumentTouch(event) {
      if (this._enableDocumentTouch) {
        this._scheduleHide(this.reference, this.options.delay, this.options, event);
      }
    }
  }, {
    key: "_scheduleShow",
    value: function _scheduleShow(reference, delay, options
    /*, evt */
    ) {
      var _this8 = this;

      // defaults to 0
      var computedDelay = delay && delay.show || delay || 0;
      clearTimeout(this._scheduleTimer);
      this._scheduleTimer = window.setTimeout(function () {
        return _this8._show(reference, options);
      }, computedDelay);
    }
  }, {
    key: "_scheduleHide",
    value: function _scheduleHide(reference, delay, options, evt) {
      var _this9 = this;

      // defaults to 0
      var computedDelay = delay && delay.hide || delay || 0;
      clearTimeout(this._scheduleTimer);
      this._scheduleTimer = window.setTimeout(function () {
        if (_this9._isOpen === false) {
          return;
        }

        if (!document.body.contains(_this9._tooltipNode)) {
          return;
        } // if we are hiding because of a mouseleave, we must check that the new
        // reference isn't the tooltip, because in this case we don't want to hide it


        if (evt.type === 'mouseleave') {
          var isSet = _this9._setTooltipNodeEvent(evt, reference, delay, options); // if we set the new event, don't hide the tooltip yet
          // the new event will take care to hide it if necessary


          if (isSet) {
            return;
          }
        }

        _this9._hide(reference, options);
      }, computedDelay);
    }
  }]);

  return Tooltip;
}(); // Hide tooltips on touch devices

if (typeof document !== 'undefined') {
  document.addEventListener('touchstart', function (event) {
    for (var i = 0; i < openTooltips.length; i++) {
      openTooltips[i]._onDocumentTouch(event);
    }
  }, supportsPassive ? {
    passive: true,
    capture: true
  } : true);
}
/**
 * Placement function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback PlacementFunction
 * @param {HTMLElement} tooltip - tooltip DOM node.
 * @param {HTMLElement} reference - reference DOM node.
 * @return {String} placement - One of the allowed placement options.
 */

/**
 * Title function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback TitleFunction
 * @return {String} placement - The desired title.
 */

var state = {
  enabled: true
};
var positions = ['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end'];
var defaultOptions = {
  // Default tooltip placement relative to target element
  defaultPlacement: 'top',
  // Default CSS classes applied to the tooltip element
  defaultClass: 'vue-tooltip-theme',
  // Default CSS classes applied to the target element of the tooltip
  defaultTargetClass: 'has-tooltip',
  // Is the content HTML by default?
  defaultHtml: true,
  // Default HTML template of the tooltip element
  // It must include `tooltip-arrow` & `tooltip-inner` CSS classes (can be configured, see below)
  // Change if the classes conflict with other libraries (for example bootstrap)
  defaultTemplate: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  // Selector used to get the arrow element in the tooltip template
  defaultArrowSelector: '.tooltip-arrow, .tooltip__arrow',
  // Selector used to get the inner content element in the tooltip template
  defaultInnerSelector: '.tooltip-inner, .tooltip__inner',
  // Delay (ms)
  defaultDelay: 0,
  // Default events that trigger the tooltip
  defaultTrigger: 'hover focus',
  // Default position offset (px)
  defaultOffset: 0,
  // Default container where the tooltip will be appended
  defaultContainer: 'body',
  defaultBoundariesElement: undefined,
  defaultPopperOptions: {},
  // Class added when content is loading
  defaultLoadingClass: 'tooltip-loading',
  // Displayed when tooltip content is loading
  defaultLoadingContent: '...',
  // Hide on mouseover tooltip
  autoHide: true,
  // Close tooltip on click on tooltip target?
  defaultHideOnTargetClick: true,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 5000,
  // Options for popover
  popover: {
    defaultPlacement: 'bottom',
    // Use the `popoverClass` prop for theming
    defaultClass: 'vue-popover-theme',
    // Base class (change if conflicts with other libraries)
    defaultBaseClass: 'tooltip popover',
    // Wrapper class (contains arrow and inner)
    defaultWrapperClass: 'wrapper',
    // Inner content class
    defaultInnerClass: 'tooltip-inner popover-inner',
    // Arrow class
    defaultArrowClass: 'tooltip-arrow popover-arrow',
    // Class added when popover is open
    defaultOpenClass: 'open',
    defaultDelay: 0,
    defaultTrigger: 'click',
    defaultOffset: 0,
    defaultContainer: 'body',
    defaultBoundariesElement: undefined,
    defaultPopperOptions: {},
    // Hides if clicked outside of popover
    defaultAutoHide: true,
    // Update popper on content resize
    defaultHandleResize: true
  }
};
function getOptions(options) {
  var result = {
    placement: typeof options.placement !== 'undefined' ? options.placement : directive.options.defaultPlacement,
    delay: typeof options.delay !== 'undefined' ? options.delay : directive.options.defaultDelay,
    html: typeof options.html !== 'undefined' ? options.html : directive.options.defaultHtml,
    template: typeof options.template !== 'undefined' ? options.template : directive.options.defaultTemplate,
    arrowSelector: typeof options.arrowSelector !== 'undefined' ? options.arrowSelector : directive.options.defaultArrowSelector,
    innerSelector: typeof options.innerSelector !== 'undefined' ? options.innerSelector : directive.options.defaultInnerSelector,
    trigger: typeof options.trigger !== 'undefined' ? options.trigger : directive.options.defaultTrigger,
    offset: typeof options.offset !== 'undefined' ? options.offset : directive.options.defaultOffset,
    container: typeof options.container !== 'undefined' ? options.container : directive.options.defaultContainer,
    boundariesElement: typeof options.boundariesElement !== 'undefined' ? options.boundariesElement : directive.options.defaultBoundariesElement,
    autoHide: typeof options.autoHide !== 'undefined' ? options.autoHide : directive.options.autoHide,
    hideOnTargetClick: typeof options.hideOnTargetClick !== 'undefined' ? options.hideOnTargetClick : directive.options.defaultHideOnTargetClick,
    loadingClass: typeof options.loadingClass !== 'undefined' ? options.loadingClass : directive.options.defaultLoadingClass,
    loadingContent: typeof options.loadingContent !== 'undefined' ? options.loadingContent : directive.options.defaultLoadingContent,
    popperOptions: _objectSpread({}, typeof options.popperOptions !== 'undefined' ? options.popperOptions : directive.options.defaultPopperOptions)
  };

  if (result.offset) {
    var typeofOffset = _typeof(result.offset);

    var offset = result.offset; // One value -> switch

    if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
      offset = "0, ".concat(offset);
    }

    if (!result.popperOptions.modifiers) {
      result.popperOptions.modifiers = {};
    }

    result.popperOptions.modifiers.offset = {
      offset: offset
    };
  }

  if (result.trigger && result.trigger.indexOf('click') !== -1) {
    result.hideOnTargetClick = false;
  }

  return result;
}
function getPlacement(value, modifiers) {
  var placement = value.placement;

  for (var i = 0; i < positions.length; i++) {
    var pos = positions[i];

    if (modifiers[pos]) {
      placement = pos;
    }
  }

  return placement;
}
function getContent(value) {
  var type = _typeof(value);

  if (type === 'string') {
    return value;
  } else if (value && type === 'object') {
    return value.content;
  } else {
    return false;
  }
}
function createTooltip(el, value) {
  var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var content = getContent(value);
  var classes = typeof value.classes !== 'undefined' ? value.classes : directive.options.defaultClass;

  var opts = _objectSpread({
    title: content
  }, getOptions(_objectSpread({}, value, {
    placement: getPlacement(value, modifiers)
  })));

  var tooltip = el._tooltip = new Tooltip(el, opts);
  tooltip.setClasses(classes);
  tooltip._vueEl = el; // Class on target

  var targetClasses = typeof value.targetClasses !== 'undefined' ? value.targetClasses : directive.options.defaultTargetClass;
  el._tooltipTargetClasses = targetClasses;
  addClasses(el, targetClasses);
  return tooltip;
}
function destroyTooltip(el) {
  if (el._tooltip) {
    el._tooltip.dispose();

    delete el._tooltip;
    delete el._tooltipOldShow;
  }

  if (el._tooltipTargetClasses) {
    removeClasses(el, el._tooltipTargetClasses);
    delete el._tooltipTargetClasses;
  }
}
function bind(el, _ref) {
  var value = _ref.value,
      oldValue = _ref.oldValue,
      modifiers = _ref.modifiers;
  var content = getContent(value);

  if (!content || !state.enabled) {
    destroyTooltip(el);
  } else {
    var tooltip;

    if (el._tooltip) {
      tooltip = el._tooltip; // Content

      tooltip.setContent(content); // Options

      tooltip.setOptions(_objectSpread({}, value, {
        placement: getPlacement(value, modifiers)
      }));
    } else {
      tooltip = createTooltip(el, value, modifiers);
    } // Manual show


    if (typeof value.show !== 'undefined' && value.show !== el._tooltipOldShow) {
      el._tooltipOldShow = value.show;
      value.show ? tooltip.show() : tooltip.hide();
    }
  }
}
var directive = {
  options: defaultOptions,
  bind: bind,
  update: bind,
  unbind: function unbind(el) {
    destroyTooltip(el);
  }
};

function addListeners(el) {
  el.addEventListener('click', onClick);
  el.addEventListener('touchstart', onTouchStart, supportsPassive ? {
    passive: true
  } : false);
}

function removeListeners(el) {
  el.removeEventListener('click', onClick);
  el.removeEventListener('touchstart', onTouchStart);
  el.removeEventListener('touchend', onTouchEnd);
  el.removeEventListener('touchcancel', onTouchCancel);
}

function onClick(event) {
  var el = event.currentTarget;
  event.closePopover = !el.$_vclosepopover_touch;
  event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
}

function onTouchStart(event) {
  if (event.changedTouches.length === 1) {
    var el = event.currentTarget;
    el.$_vclosepopover_touch = true;
    var touch = event.changedTouches[0];
    el.$_vclosepopover_touchPoint = touch;
    el.addEventListener('touchend', onTouchEnd);
    el.addEventListener('touchcancel', onTouchCancel);
  }
}

function onTouchEnd(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;

  if (event.changedTouches.length === 1) {
    var touch = event.changedTouches[0];
    var firstTouch = el.$_vclosepopover_touchPoint;
    event.closePopover = Math.abs(touch.screenY - firstTouch.screenY) < 20 && Math.abs(touch.screenX - firstTouch.screenX) < 20;
    event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
  }
}

function onTouchCancel(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;
}

var vclosepopover = {
  bind: function bind(el, _ref) {
    var value = _ref.value,
        modifiers = _ref.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (typeof value === 'undefined' || value) {
      addListeners(el);
    }
  },
  update: function update(el, _ref2) {
    var value = _ref2.value,
        oldValue = _ref2.oldValue,
        modifiers = _ref2.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (value !== oldValue) {
      if (typeof value === 'undefined' || value) {
        addListeners(el);
      } else {
        removeListeners(el);
      }
    }
  },
  unbind: function unbind(el) {
    removeListeners(el);
  }
};

function getDefault(key) {
  var value = directive.options.popover[key];

  if (typeof value === 'undefined') {
    return directive.options[key];
  }

  return value;
}

var isIOS = false;

if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

var openPopovers = [];

var Element = function Element() {};

if (typeof window !== 'undefined') {
  Element = window.Element;
}

var script = {
  name: 'VPopover',
  components: {
    ResizeObserver: vue_resize__WEBPACK_IMPORTED_MODULE_1__[/* ResizeObserver */ "a"]
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: function _default() {
        return getDefault('defaultPlacement');
      }
    },
    delay: {
      type: [String, Number, Object],
      default: function _default() {
        return getDefault('defaultDelay');
      }
    },
    offset: {
      type: [String, Number],
      default: function _default() {
        return getDefault('defaultOffset');
      }
    },
    trigger: {
      type: String,
      default: function _default() {
        return getDefault('defaultTrigger');
      }
    },
    container: {
      type: [String, Object, Element, Boolean],
      default: function _default() {
        return getDefault('defaultContainer');
      }
    },
    boundariesElement: {
      type: [String, Element],
      default: function _default() {
        return getDefault('defaultBoundariesElement');
      }
    },
    popperOptions: {
      type: Object,
      default: function _default() {
        return getDefault('defaultPopperOptions');
      }
    },
    popoverClass: {
      type: [String, Array],
      default: function _default() {
        return getDefault('defaultClass');
      }
    },
    popoverBaseClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultBaseClass;
      }
    },
    popoverInnerClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultInnerClass;
      }
    },
    popoverWrapperClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultWrapperClass;
      }
    },
    popoverArrowClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultArrowClass;
      }
    },
    autoHide: {
      type: Boolean,
      default: function _default() {
        return directive.options.popover.defaultAutoHide;
      }
    },
    handleResize: {
      type: Boolean,
      default: function _default() {
        return directive.options.popover.defaultHandleResize;
      }
    },
    openGroup: {
      type: String,
      default: null
    },
    openClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultOpenClass;
      }
    }
  },
  data: function data() {
    return {
      isOpen: false,
      id: Math.random().toString(36).substr(2, 10)
    };
  },
  computed: {
    cssClass: function cssClass() {
      return _defineProperty({}, this.openClass, this.isOpen);
    },
    popoverId: function popoverId() {
      return "popover_".concat(this.id);
    }
  },
  watch: {
    open: function open(val) {
      if (val) {
        this.show();
      } else {
        this.hide();
      }
    },
    disabled: function disabled(val, oldVal) {
      if (val !== oldVal) {
        if (val) {
          this.hide();
        } else if (this.open) {
          this.show();
        }
      }
    },
    container: function container(val) {
      if (this.isOpen && this.popperInstance) {
        var popoverNode = this.$refs.popover;
        var reference = this.$refs.trigger;
        var container = this.$_findContainer(this.container, reference);

        if (!container) {
          console.warn('No container for popover', this);
          return;
        }

        container.appendChild(popoverNode);
        this.popperInstance.scheduleUpdate();
      }
    },
    trigger: function trigger(val) {
      this.$_removeEventListeners();
      this.$_addEventListeners();
    },
    placement: function placement(val) {
      var _this = this;

      this.$_updatePopper(function () {
        _this.popperInstance.options.placement = val;
      });
    },
    offset: '$_restartPopper',
    boundariesElement: '$_restartPopper',
    popperOptions: {
      handler: '$_restartPopper',
      deep: true
    }
  },
  created: function created() {
    this.$_isDisposed = false;
    this.$_mounted = false;
    this.$_events = [];
    this.$_preventOpen = false;
  },
  mounted: function mounted() {
    var popoverNode = this.$refs.popover;
    popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
    this.$_init();

    if (this.open) {
      this.show();
    }
  },
  deactivated: function deactivated() {
    this.hide();
  },
  beforeDestroy: function beforeDestroy() {
    this.dispose();
  },
  methods: {
    show: function show() {
      var _this2 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref2.event,
          _ref2$skipDelay = _ref2.skipDelay,
          _ref2$force = _ref2.force,
          force = _ref2$force === void 0 ? false : _ref2$force;

      if (force || !this.disabled) {
        this.$_scheduleShow(event);
        this.$emit('show');
      }

      this.$emit('update:open', true);
      this.$_beingShowed = true;
      requestAnimationFrame(function () {
        _this2.$_beingShowed = false;
      });
    },
    hide: function hide() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref3.event,
          _ref3$skipDelay = _ref3.skipDelay;

      this.$_scheduleHide(event);
      this.$emit('hide');
      this.$emit('update:open', false);
    },
    dispose: function dispose() {
      this.$_isDisposed = true;
      this.$_removeEventListeners();
      this.hide({
        skipDelay: true
      });

      if (this.popperInstance) {
        this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

        if (!this.popperInstance.options.removeOnDestroy) {
          var popoverNode = this.$refs.popover;
          popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
        }
      }

      this.$_mounted = false;
      this.popperInstance = null;
      this.isOpen = false;
      this.$emit('dispose');
    },
    $_init: function $_init() {
      if (this.trigger.indexOf('manual') === -1) {
        this.$_addEventListeners();
      }
    },
    $_show: function $_show() {
      var _this3 = this;

      var reference = this.$refs.trigger;
      var popoverNode = this.$refs.popover;
      clearTimeout(this.$_disposeTimer); // Already open

      if (this.isOpen) {
        return;
      } // Popper is already initialized


      if (this.popperInstance) {
        this.isOpen = true;
        this.popperInstance.enableEventListeners();
        this.popperInstance.scheduleUpdate();
      }

      if (!this.$_mounted) {
        var container = this.$_findContainer(this.container, reference);

        if (!container) {
          console.warn('No container for popover', this);
          return;
        }

        container.appendChild(popoverNode);
        this.$_mounted = true;
      }

      if (!this.popperInstance) {
        var popperOptions = _objectSpread({}, this.popperOptions, {
          placement: this.placement
        });

        popperOptions.modifiers = _objectSpread({}, popperOptions.modifiers, {
          arrow: _objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.arrow, {
            element: this.$refs.arrow
          })
        });

        if (this.offset) {
          var offset = this.$_getOffset();
          popperOptions.modifiers.offset = _objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.offset, {
            offset: offset
          });
        }

        if (this.boundariesElement) {
          popperOptions.modifiers.preventOverflow = _objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.preventOverflow, {
            boundariesElement: this.boundariesElement
          });
        }

        this.popperInstance = new popper_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](reference, popoverNode, popperOptions); // Fix position

        requestAnimationFrame(function () {
          if (_this3.hidden) {
            _this3.hidden = false;

            _this3.$_hide();

            return;
          }

          if (!_this3.$_isDisposed && _this3.popperInstance) {
            _this3.popperInstance.scheduleUpdate(); // Show the tooltip


            requestAnimationFrame(function () {
              if (_this3.hidden) {
                _this3.hidden = false;

                _this3.$_hide();

                return;
              }

              if (!_this3.$_isDisposed) {
                _this3.isOpen = true;
              } else {
                _this3.dispose();
              }
            });
          } else {
            _this3.dispose();
          }
        });
      }

      var openGroup = this.openGroup;

      if (openGroup) {
        var popover;

        for (var i = 0; i < openPopovers.length; i++) {
          popover = openPopovers[i];

          if (popover.openGroup !== openGroup) {
            popover.hide();
            popover.$emit('close-group');
          }
        }
      }

      openPopovers.push(this);
      this.$emit('apply-show');
    },
    $_hide: function $_hide() {
      var _this4 = this;

      // Already hidden
      if (!this.isOpen) {
        return;
      }

      var index = openPopovers.indexOf(this);

      if (index !== -1) {
        openPopovers.splice(index, 1);
      }

      this.isOpen = false;

      if (this.popperInstance) {
        this.popperInstance.disableEventListeners();
      }

      clearTimeout(this.$_disposeTimer);
      var disposeTime = directive.options.popover.disposeTimeout || directive.options.disposeTimeout;

      if (disposeTime !== null) {
        this.$_disposeTimer = setTimeout(function () {
          var popoverNode = _this4.$refs.popover;

          if (popoverNode) {
            // Don't remove popper instance, just the HTML element
            popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
            _this4.$_mounted = false;
          }
        }, disposeTime);
      }

      this.$emit('apply-hide');
    },
    $_findContainer: function $_findContainer(container, reference) {
      // if container is a query, get the relative element
      if (typeof container === 'string') {
        container = window.document.querySelector(container);
      } else if (container === false) {
        // if container is `false`, set it to reference parent
        container = reference.parentNode;
      }

      return container;
    },
    $_getOffset: function $_getOffset() {
      var typeofOffset = _typeof(this.offset);

      var offset = this.offset; // One value -> switch

      if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
        offset = "0, ".concat(offset);
      }

      return offset;
    },
    $_addEventListeners: function $_addEventListeners() {
      var _this5 = this;

      var reference = this.$refs.trigger;
      var directEvents = [];
      var oppositeEvents = [];
      var events = typeof this.trigger === 'string' ? this.trigger.split(' ').filter(function (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
      }) : [];
      events.forEach(function (event) {
        switch (event) {
          case 'hover':
            directEvents.push('mouseenter');
            oppositeEvents.push('mouseleave');
            break;

          case 'focus':
            directEvents.push('focus');
            oppositeEvents.push('blur');
            break;

          case 'click':
            directEvents.push('click');
            oppositeEvents.push('click');
            break;
        }
      }); // schedule show tooltip

      directEvents.forEach(function (event) {
        var func = function func(event) {
          if (_this5.isOpen) {
            return;
          }

          event.usedByTooltip = true;
          !_this5.$_preventOpen && _this5.show({
            event: event
          });
          _this5.hidden = false;
        };

        _this5.$_events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      }); // schedule hide tooltip

      oppositeEvents.forEach(function (event) {
        var func = function func(event) {
          if (event.usedByTooltip) {
            return;
          }

          _this5.hide({
            event: event
          });

          _this5.hidden = true;
        };

        _this5.$_events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });
    },
    $_scheduleShow: function $_scheduleShow() {
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this.$_scheduleTimer);

      if (skipDelay) {
        this.$_show();
      } else {
        // defaults to 0
        var computedDelay = parseInt(this.delay && this.delay.show || this.delay || 0);
        this.$_scheduleTimer = setTimeout(this.$_show.bind(this), computedDelay);
      }
    },
    $_scheduleHide: function $_scheduleHide() {
      var _this6 = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this.$_scheduleTimer);

      if (skipDelay) {
        this.$_hide();
      } else {
        // defaults to 0
        var computedDelay = parseInt(this.delay && this.delay.hide || this.delay || 0);
        this.$_scheduleTimer = setTimeout(function () {
          if (!_this6.isOpen) {
            return;
          } // if we are hiding because of a mouseleave, we must check that the new
          // reference isn't the tooltip, because in this case we don't want to hide it


          if (event && event.type === 'mouseleave') {
            var isSet = _this6.$_setTooltipNodeEvent(event); // if we set the new event, don't hide the tooltip yet
            // the new event will take care to hide it if necessary


            if (isSet) {
              return;
            }
          }

          _this6.$_hide();
        }, computedDelay);
      }
    },
    $_setTooltipNodeEvent: function $_setTooltipNodeEvent(event) {
      var _this7 = this;

      var reference = this.$refs.trigger;
      var popoverNode = this.$refs.popover;
      var relatedreference = event.relatedreference || event.toElement || event.relatedTarget;

      var callback = function callback(event2) {
        var relatedreference2 = event2.relatedreference || event2.toElement || event2.relatedTarget; // Remove event listener after call

        popoverNode.removeEventListener(event.type, callback); // If the new reference is not the reference element

        if (!reference.contains(relatedreference2)) {
          // Schedule to hide tooltip
          _this7.hide({
            event: event2
          });
        }
      };

      if (popoverNode.contains(relatedreference)) {
        // listen to mouseleave on the tooltip element to be able to hide the tooltip
        popoverNode.addEventListener(event.type, callback);
        return true;
      }

      return false;
    },
    $_removeEventListeners: function $_removeEventListeners() {
      var reference = this.$refs.trigger;
      this.$_events.forEach(function (_ref4) {
        var func = _ref4.func,
            event = _ref4.event;
        reference.removeEventListener(event, func);
      });
      this.$_events = [];
    },
    $_updatePopper: function $_updatePopper(cb) {
      if (this.popperInstance) {
        cb();
        if (this.isOpen) this.popperInstance.scheduleUpdate();
      }
    },
    $_restartPopper: function $_restartPopper() {
      if (this.popperInstance) {
        var isOpen = this.isOpen;
        this.dispose();
        this.$_isDisposed = false;
        this.$_init();

        if (isOpen) {
          this.show({
            skipDelay: true,
            force: true
          });
        }
      }
    },
    $_handleGlobalClose: function $_handleGlobalClose(event) {
      var _this8 = this;

      var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.$_beingShowed) return;
      this.hide({
        event: event
      });

      if (event.closePopover) {
        this.$emit('close-directive');
      } else {
        this.$emit('auto-hide');
      }

      if (touch) {
        this.$_preventOpen = true;
        setTimeout(function () {
          _this8.$_preventOpen = false;
        }, 300);
      }
    },
    $_handleResize: function $_handleResize() {
      if (this.isOpen && this.popperInstance) {
        this.popperInstance.scheduleUpdate();
        this.$emit('resize');
      }
    }
  }
};

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  if (isIOS) {
    document.addEventListener('touchend', handleGlobalTouchend, supportsPassive ? {
      passive: true,
      capture: true
    } : true);
  } else {
    window.addEventListener('click', handleGlobalClick, true);
  }
}

function handleGlobalClick(event) {
  handleGlobalClose(event);
}

function handleGlobalTouchend(event) {
  handleGlobalClose(event, true);
}

function handleGlobalClose(event) {
  var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _loop = function _loop(i) {
    var popover = openPopovers[i];

    if (popover.$refs.popover) {
      var contains = popover.$refs.popover.contains(event.target);
      requestAnimationFrame(function () {
        if (event.closeAllPopover || event.closePopover && contains || popover.autoHide && !contains) {
          popover.$_handleGlobalClose(event, touch);
        }
      });
    }
  };

  // Delay so that close directive has time to set values
  for (var i = 0; i < openPopovers.length; i++) {
    _loop(i);
  }
}

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "v-popover",
    class: _vm.cssClass
  }, [_c("div", {
    ref: "trigger",
    staticClass: "trigger",
    staticStyle: {
      display: "inline-block"
    },
    attrs: {
      "aria-describedby": _vm.popoverId,
      tabindex: _vm.trigger.indexOf("focus") !== -1 ? 0 : undefined
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c("div", {
    ref: "popover",
    class: [_vm.popoverBaseClass, _vm.popoverClass, _vm.cssClass],
    style: {
      visibility: _vm.isOpen ? "visible" : "hidden"
    },
    attrs: {
      id: _vm.popoverId,
      "aria-hidden": _vm.isOpen ? "false" : "true",
      tabindex: _vm.autoHide ? 0 : undefined
    },
    on: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        _vm.autoHide && _vm.hide();
      }
    }
  }, [_c("div", {
    class: _vm.popoverWrapperClass
  }, [_c("div", {
    ref: "inner",
    class: _vm.popoverInnerClass,
    staticStyle: {
      position: "relative"
    }
  }, [_c("div", [_vm._t("popover")], 2), _vm._v(" "), _vm.handleResize ? _c("ResizeObserver", {
    on: {
      notify: _vm.$_handleResize
    }
  }) : _vm._e()], 1), _vm._v(" "), _c("div", {
    ref: "arrow",
    class: _vm.popoverArrowClass
  })])])]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

var Popover = normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

var _Map = Map;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$1 = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty$1) {
    _defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq_1(object[key], value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

var _baseFor = baseFor;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$4.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike_1(value) && isArrayLike_1(value);
}

var isArrayLikeObject_1 = isArrayLikeObject;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$7 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$5.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$6.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, keysIn_1(value));
}

var toPlainObject_1 = toPlainObject;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray_1(srcValue),
        isBuff = !isArr && isBuffer_1(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray_1(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray_1(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject_1(objValue)) {
        newValue = _copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = _cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject_1(srcValue) || isArguments_1(srcValue)) {
      newValue = objValue;
      if (isArguments_1(objValue)) {
        newValue = toPlainObject_1(objValue);
      }
      else if (!isObject_1(objValue) || isFunction_1(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function(srcValue, key) {
    if (isObject_1(srcValue)) {
      stack || (stack = new _Stack);
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, keysIn_1);
}

var _baseMerge = baseMerge;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty$1 ? identity_1 : function(func, string) {
  return _defineProperty$1(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return _baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = _createAssigner(function(object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

var merge_1 = merge;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".resize-observer[data-v-b329ee4c]{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}.resize-observer[data-v-b329ee4c] object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}";
styleInject(css);

function install(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (install.installed) return;
  install.installed = true;
  var finalOptions = {};
  merge_1(finalOptions, defaultOptions, options);
  plugin.options = finalOptions;
  directive.options = finalOptions;
  Vue.directive('tooltip', directive);
  Vue.directive('close-popover', vclosepopover);
  Vue.component('v-popover', Popover);
}
var VTooltip = directive;
var VClosePopover = vclosepopover;
var VPopover = Popover;
var plugin = {
  install: install,

  get enabled() {
    return state.enabled;
  },

  set enabled(value) {
    state.enabled = value;
  }

}; // Auto-install

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "e810":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRiskValue_vue_vue_type_style_index_0_id_799af9d6_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a74a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRiskValue_vue_vue_type_style_index_0_id_799af9d6_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRiskValue_vue_vue_type_style_index_0_id_799af9d6_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es-x/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "e9bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsButtonList_vue_vue_type_style_index_0_id_e35f8f8e_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2a67");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsButtonList_vue_vue_type_style_index_0_id_e35f8f8e_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorResultsButtonList_vue_vue_type_style_index_0_id_e35f8f8e_prod_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "eade":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 18 14",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-70 -56)"
      }
    }, [_c('g', {
      attrs: {
        "id": "Symbol/email",
        "transform": "translate(70 56)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M16.418 0H1.582C.711 0 0 .71 0 1.582v10.547c0 .869.708 1.582 1.582 1.582h14.836c.869 0 1.582-.708 1.582-1.582V1.582C18 .713 17.292 0 16.418 0zM16.2 1.055L9.034 8.22 1.806 1.055H16.2zM1.055 11.91V1.795l5.079 5.036-5.08 5.08zm.745.745l5.083-5.082 1.78 1.765a.527.527 0 00.745-.001L11.145 7.6l5.055 5.055H1.8zm15.145-.746L11.89 6.855 16.945 1.8v10.11z",
        "id": "Shape"
      }
    })])])])]));
  }
};

/***/ }),

/***/ "ec83":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 320 512"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9S19 320.1 32 320.1h256c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
      }
    })]));
  }
};

/***/ }),

/***/ "eced":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorProgressText_vue_vue_type_style_index_0_id_38ef0796_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c2cd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorProgressText_vue_vue_type_style_index_0_id_38ef0796_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorProgressText_vue_vue_type_style_index_0_id_38ef0796_prod_scoped_true_lang_scss__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ed0b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorRefineQuestion_vue_vue_type_style_index_0_id_3bc14c1e_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98b1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorRefineQuestion_vue_vue_type_style_index_0_id_3bc14c1e_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_AdvisorRefineQuestion_vue_vue_type_style_index_0_id_3bc14c1e_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f04a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresInfo_vue_vue_type_style_index_0_id_1d5647fa_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6b75");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresInfo_vue_vue_type_style_index_0_id_1d5647fa_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresInfo_vue_vue_type_style_index_0_id_1d5647fa_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f0bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "f20a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-refine-question/AdvisorRefineQuestionSimple.vue?vue&type=template&id=117ce998&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advisor-refine-question"},[_c('label',{staticClass:"refine-question"},[_vm._v(_vm._s(_vm.$t(_vm.question.i18nQuestion)))]),_c('div',{staticClass:"refine-answer custom-selectbox"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.userAnswer),expression:"userAnswer"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.userAnswer=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.handleClickOnchange]}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t("refine.select_your_answer")))]),_vm._l((_vm.question.answers),function(qAnswer){return _c('option',{key:qAnswer.value,domProps:{"value":qAnswer.value}},[_vm._v(" "+_vm._s(_vm.$t(qAnswer.i18nDescription))+" ")])})],2)])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-refine-question/AdvisorRefineQuestionSimple.vue?vue&type=template&id=117ce998&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-refine-question/AdvisorRefineQuestionSimple.vue?vue&type=script&lang=ts



let AdvisorRefineQuestionSimplevue_type_script_lang_ts_AdvisorRefineQuestion = class AdvisorRefineQuestion extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.showAnswers = false;
    this.userAnswer = "";
  }
  created() {
    if (this.answer !== null) {
      this.userAnswer = this.answer.value;
    }
  }
  handleClickOnchange() {
    this.$emit("answer", this.question, this.question.answers.find(answer => {
      return answer.value === this.userAnswer;
    }));
  }
  handleClick(handle, answer) {
    this.$emit(handle, this.question, answer);
    this.userAnswer = answer.value;
    this.showAnswers = !this.showAnswers;
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorRefineQuestionSimplevue_type_script_lang_ts_AdvisorRefineQuestion.prototype, "question", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorRefineQuestionSimplevue_type_script_lang_ts_AdvisorRefineQuestion.prototype, "answer", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorRefineQuestionSimplevue_type_script_lang_ts_AdvisorRefineQuestion.prototype, "questionIndex", void 0);
AdvisorRefineQuestionSimplevue_type_script_lang_ts_AdvisorRefineQuestion = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorRefineQuestionSimplevue_type_script_lang_ts_AdvisorRefineQuestion);
/* harmony default export */ var AdvisorRefineQuestionSimplevue_type_script_lang_ts = (AdvisorRefineQuestionSimplevue_type_script_lang_ts_AdvisorRefineQuestion);
// CONCATENATED MODULE: ./src/components/advisor-refine-question/AdvisorRefineQuestionSimple.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_refine_question_AdvisorRefineQuestionSimplevue_type_script_lang_ts = (AdvisorRefineQuestionSimplevue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-refine-question/AdvisorRefineQuestionSimple.vue?vue&type=style&index=0&id=117ce998&prod&lang=scss&scoped=true
var AdvisorRefineQuestionSimplevue_type_style_index_0_id_117ce998_prod_lang_scss_scoped_true = __webpack_require__("9111");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-refine-question/AdvisorRefineQuestionSimple.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_refine_question_AdvisorRefineQuestionSimplevue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "117ce998",
  null
  
)

/* harmony default export */ var AdvisorRefineQuestionSimple = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "f283":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailureQuestion_vue_vue_type_style_index_0_id_78a66bb3_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6b8b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailureQuestion_vue_vue_type_style_index_0_id_78a66bb3_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailureQuestion_vue_vue_type_style_index_0_id_78a66bb3_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f292":
/***/ (function(module, exports) {

module.exports = {
  functional: true,
  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 16 28",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "id": "Icons",
        "stroke": "none",
        "stroke-width": "1",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "Desktop-HD",
        "transform": "translate(-597 -343)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 14c.012.381.168.76.466 1.05l12.811 12.494a1.622 1.622 0 002.255 0 1.527 1.527 0 000-2.2L3.9 14 15.532 2.655a1.527 1.527 0 000-2.199 1.622 1.622 0 00-2.255 0L.467 12.949c-.3.292-.455.67-.467 1.051z",
        "transform": "translate(597 343)",
        "id": "Symbol/right"
      }
    })])])]));
  }
};

/***/ }),

/***/ "f4ad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRelatedInsights_vue_vue_type_style_index_0_id_32b43797_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3769");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRelatedInsights_vue_vue_type_style_index_0_id_32b43797_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FailuresRelatedInsights_vue_vue_type_style_index_0_id_32b43797_prod_lang_scss_scoped_true__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f771":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-item-rd/AdvisorResultsItemSm.vue?vue&type=template&id=ce2950de&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advisor-results-item-sm",class:_vm.resultsItemClass,attrs:{"id":'item-' + _vm.item.id}},[_c('div',{staticClass:"item-header",on:{"click":function($event){return _vm.toggleItem($event)}}},[_c('div',{staticClass:"item-header__header"},[_c('div',{staticClass:"item-header__title"},[_c('div',{staticClass:"item-header--compare"},[_c('label',{staticClass:"checkbox-wrapper",class:{ disabled: !_vm.allowedToCompare(_vm.item.id) }},[_c('input',{attrs:{"type":"checkbox","disabled":!_vm.allowedToCompare(_vm.item.id)},domProps:{"value":_vm.item.id,"checked":_vm.compareExists(_vm.item.id)},on:{"change":function($event){return _vm.compareItem($event)}}}),_c('span',{staticClass:"checkmark"})])]),_c('h3',{staticClass:"title"},[_c('a',{attrs:{"href":_vm.item.url,"target":"_blank"}},[_c('span',[_vm._v(_vm._s(_vm.item.title))]),_c('advisor-icon',{attrs:{"name":"faArrowRight"}})],1)])]),_c('div',{staticClass:"item-header__list"},[_c('div',{staticClass:"list"},[_c('div',{staticClass:"list-row"},[_c('div',{staticClass:"cell cell-header"},[_vm._v(" "+_vm._s(_vm.$t("results_item.polymer"))+": ")]),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm.item.polymer))])]),_c('div',{staticClass:"list-row"},[_c('div',{staticClass:"cell cell-header"},[_vm._v(" "+_vm._s(_vm.$t("results_item.processing_technology"))+": ")]),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm.item.processing))])]),_c('div',{staticClass:"list-row"},[_c('div',{staticClass:"cell cell-header"},[_vm._v(" "+_vm._s(_vm.$t("results_item.features"))+": ")]),_c('div',{staticClass:"cell"},[_vm._v(_vm._s(_vm.item.special))])])])])]),_c('div',{staticClass:"item-header__actions"},[_c('div',{staticClass:"score"},[_c('label',[_vm._v("Requirements matched:")]),_c('div',{staticClass:"score-bar"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.scoreMatch)+"/"+_vm._s(_vm.totalQuestions))]),_c('div',{staticClass:"inner",style:({ width: (_vm.scoreBarWidth + "%") })})])]),(_vm.datasheetLink !== '')?_c('div',{staticClass:"document"},[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_c('a',{staticClass:"link",attrs:{"href":_vm.datasheetLink}},[_c('advisor-icon',{attrs:{"name":"adobe"}}),_c('span',[_vm._v("Datasheet properties")])],1)])])]):_vm._e(),_c('div',{staticClass:"toggle"},[_c('div',{staticClass:"btn btn-icon btn-ev-link btn-sm"},[_c('span',[_vm._v("Expand result to show details")]),_c('advisor-icon',{attrs:{"name":"left"}})],1)])])]),(_vm.item.active || _vm.showDetails)?_c('div',{staticClass:"item-content"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-results-item-rd/AdvisorResultsItemSm.vue?vue&type=template&id=ce2950de&scoped=true

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__("14d9");

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-item-rd/AdvisorResultsItemSm.vue?vue&type=script&lang=ts




let AdvisorResultsItemSmvue_type_script_lang_ts_AdvisorResultsItemSm = class AdvisorResultsItemSm extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.showDetails = false;
    this.activeItem = "home";
  }
  get scoreMatch() {
    return this.matchScore.filter(score => score.match).length;
  }
  get totalQuestions() {
    return this.matchScore.length;
  }
  get scoreBarWidth() {
    return this.scoreMatch / this.matchScore.length * 100;
  }
  get datasheetLink() {
    const downloads = this.item.linkListDownloads.find(item => item.title === "Property Data (PDS)");
    if (downloads) {
      return downloads.link;
    }
    return "";
  }
  get resultsItemClass() {
    let cssClass = "";
    if (this.item.active || this.showDetails) {
      cssClass = "is-active";
    }
    if (parseInt(this.item.matchScore) >= parseInt(this.scoreMap[2])) {
      cssClass += " is-match-high";
    } else if (parseInt(this.item.matchScore) >= parseInt(this.scoreMap[1])) {
      cssClass += " is-match-medium";
    } else if (parseInt(this.item.matchScore) >= parseInt(this.scoreMap[0])) {
      cssClass += " is-match-low";
    } else {
      cssClass += " is-match-very-low";
    }
    return cssClass;
  }
  get answersInChunks() {
    const results = [];
    const chunk = 3;
    if (this.matchScore) {
      const items = this.matchScore;
      if (items.length > 0) {
        for (let i = 0; i < items.length; i += chunk) {
          const item = items.slice(i, i + chunk);
          if (typeof item !== "undefined") {
            results.push(item);
          }
        }
      }
    }
    return results;
  }
  setProgressMatchScore(score) {
    return "right:" + (100 - score) + "px;";
  }
  toggleItem(e) {
    if (e.target.nodeName !== "A" && e.target.nodeName !== "INPUT" && e.target.nodeName !== "LABEL" && e.target.className !== "checkmark") {
      this.showDetails = !this.showDetails;
      this.$emit("toggleItem");
    }
  }
  allowedToCompare(item) {
    const allowed = false;
    const compareItemExists = this.compareItems.some(compareItem => compareItem.id === item);
    if (this.compareItems.length < this.compareMax || compareItemExists) {
      return true;
    }
    return allowed;
  }
  compareExists(item) {
    return this.compareItems.some(compareItem => compareItem.id === item);
  }
  compareItem(e) {
    const CompareItem = {
      id: "",
      title: ""
    };
    CompareItem.id = this.item.id;
    CompareItem.title = this.item.title;
    const checked = e.target.checked;
    this.$emit("compareItem", checked, CompareItem);
  }
  isActive(menuItem) {
    return this.activeItem === menuItem;
  }
  setActive(menuItem) {
    this.activeItem = menuItem;
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: false
})], AdvisorResultsItemSmvue_type_script_lang_ts_AdvisorResultsItemSm.prototype, "multiple", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: () => [50, 70, 100],
  type: Array
})], AdvisorResultsItemSmvue_type_script_lang_ts_AdvisorResultsItemSm.prototype, "scoreMap", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorResultsItemSmvue_type_script_lang_ts_AdvisorResultsItemSm.prototype, "item", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorResultsItemSmvue_type_script_lang_ts_AdvisorResultsItemSm.prototype, "matchScore", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: false
})], AdvisorResultsItemSmvue_type_script_lang_ts_AdvisorResultsItemSm.prototype, "refineQuestions", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorResultsItemSmvue_type_script_lang_ts_AdvisorResultsItemSm.prototype, "compareItems", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])({
  default: 5
})], AdvisorResultsItemSmvue_type_script_lang_ts_AdvisorResultsItemSm.prototype, "compareMax", void 0);
AdvisorResultsItemSmvue_type_script_lang_ts_AdvisorResultsItemSm = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorResultsItemSmvue_type_script_lang_ts_AdvisorResultsItemSm);
/* harmony default export */ var AdvisorResultsItemSmvue_type_script_lang_ts = (AdvisorResultsItemSmvue_type_script_lang_ts_AdvisorResultsItemSm);
// CONCATENATED MODULE: ./src/components/advisor-results-item-rd/AdvisorResultsItemSm.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_results_item_rd_AdvisorResultsItemSmvue_type_script_lang_ts = (AdvisorResultsItemSmvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-results-item-rd/AdvisorResultsItemSm.vue?vue&type=style&index=0&id=ce2950de&prod&lang=scss&scoped=true
var AdvisorResultsItemSmvue_type_style_index_0_id_ce2950de_prod_lang_scss_scoped_true = __webpack_require__("1214");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-results-item-rd/AdvisorResultsItemSm.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_results_item_rd_AdvisorResultsItemSmvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "ce2950de",
  null
  
)

/* harmony default export */ var advisor_results_item_rd_AdvisorResultsItemSm = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f7f4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f9ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-tab/AdvisorResultsMatchScoreTable.vue?vue&type=template&id=be5975f4&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advisor-results-match-score-table table-responsive"},[(_vm.matchScore)?_c('table',{staticClass:"table table-striped table-borderless"},[_c('thead',[_c('tr',_vm._l((_vm.matchScore.headers),function(header,index){return _c('th',{key:index,class:'column-' + index},[_vm._v(" "+_vm._s(header)+" ")])}),0)]),_c('tbody',_vm._l((_vm.matchScore.rows),function(row,index){return _c('tr',{key:index},[_c('th',{staticClass:"column-label"},[_c('div',{staticClass:"question"},[_c('div',{},[_vm._v(_vm._s(index + 1)+".")]),_c('div',{},[_vm._v(_vm._s(_vm.$t(row.label)))])])]),_c('td',{staticClass:"column-yourAnswer"},[_vm._v(_vm._s(_vm.$t(row.your_answer)))]),_c('td',{staticClass:"column-matchScore"},[_c('div',{staticClass:"match-score"},[_c('div',{staticClass:"match-score-icon",class:{ 'is-match': row.match }}),_c('div',{},[_vm._v(_vm._s(row.material_property))])])])])}),0)]):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-results-tab/AdvisorResultsMatchScoreTable.vue?vue&type=template&id=be5975f4&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-results-tab/AdvisorResultsMatchScoreTable.vue?vue&type=script&lang=ts



let AdvisorResultsMatchScoreTablevue_type_script_lang_ts_AdvisorResultsMatchScoreTable = class AdvisorResultsMatchScoreTable extends vue_property_decorator["c" /* Vue */] {};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorResultsMatchScoreTablevue_type_script_lang_ts_AdvisorResultsMatchScoreTable.prototype, "matchScore", void 0);
AdvisorResultsMatchScoreTablevue_type_script_lang_ts_AdvisorResultsMatchScoreTable = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorResultsMatchScoreTablevue_type_script_lang_ts_AdvisorResultsMatchScoreTable);
/* harmony default export */ var AdvisorResultsMatchScoreTablevue_type_script_lang_ts = (AdvisorResultsMatchScoreTablevue_type_script_lang_ts_AdvisorResultsMatchScoreTable);
// CONCATENATED MODULE: ./src/components/advisor-results-tab/AdvisorResultsMatchScoreTable.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_results_tab_AdvisorResultsMatchScoreTablevue_type_script_lang_ts = (AdvisorResultsMatchScoreTablevue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-results-tab/AdvisorResultsMatchScoreTable.vue?vue&type=style&index=0&id=be5975f4&prod&lang=scss&scoped=true
var AdvisorResultsMatchScoreTablevue_type_style_index_0_id_be5975f4_prod_lang_scss_scoped_true = __webpack_require__("d708");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-results-tab/AdvisorResultsMatchScoreTable.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_results_tab_AdvisorResultsMatchScoreTablevue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "be5975f4",
  null
  
)

/* harmony default export */ var advisor_results_tab_AdvisorResultsMatchScoreTable = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "fae3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _setPublicPath__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1eb2");
/* harmony import */ var _entry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("df5d");
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _entry__WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _entry__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));




/***/ }),

/***/ "fb41":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("04f8");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "ffc4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"238869c6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-question-filter/AdvisorQuestionFilter.vue?vue&type=template&id=270f0cfd&scoped=true
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advisor-question-filter",class:{ 'is-active': _vm.showAnswers }},[_c('div',{staticClass:"filter-toggle",on:{"click":function($event){_vm.showAnswers = !_vm.showAnswers}}},[_c('advisor-icon',{attrs:{"name":"faCaretDown"}})],1),_c('div',{staticClass:"filter-question",on:{"click":function($event){_vm.showAnswers = !_vm.showAnswers}}},[_c('span',{staticClass:"filter-question--question"},[_vm._v(_vm._s(_vm.$t(_vm.question.i18nShortQuestion))+":")]),_c('span',{staticClass:"filter-question--answer"},[_vm._v(_vm._s(_vm.$t(_vm.answerValue)))])]),(_vm.showAnswers)?_c('div',{staticClass:"filter-answers"},[_vm._l((_vm.question.answers),function(answer){return _c('button',{key:answer.value,staticClass:"btn btn-sm btn-ev-blueberry-teal btn-block",class:[{ active: _vm.selected && _vm.selected.value === answer.value }],on:{"click":function($event){return _vm.handleClick('answer', answer)}}},[_vm._v(" "+_vm._s(_vm.$t(answer.i18nDescription))+" ")])}),_c('button',{staticClass:"btn btn-sm btn-block btn-ev-glooming-coral",on:{"click":function($event){return _vm.onSkip('skip')}}},[_vm._v(" "+_vm._s(_vm.$t("question.skipped"))+" ")])],2):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/advisor-question-filter/AdvisorQuestionFilter.vue?vue&type=template&id=270f0cfd&scoped=true

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("9ab4");

// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js + 1 modules
var vue_property_decorator = __webpack_require__("60a3");

// EXTERNAL MODULE: ./src/components/advisor.ts
var advisor = __webpack_require__("3d8c");

// EXTERNAL MODULE: ./src/components/advisor-icon/AdvisorIcon.vue + 4 modules
var AdvisorIcon = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--14-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--14-3!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/advisor-question-filter/AdvisorQuestionFilter.vue?vue&type=script&lang=ts




let AdvisorQuestionFiltervue_type_script_lang_ts_AdvisorQuestionFilter = class AdvisorQuestionFilter extends vue_property_decorator["c" /* Vue */] {
  constructor() {
    super(...arguments);
    this.showAnswers = false;
  }
  get answerValue() {
    if (this.selected !== null && typeof this.selected !== "undefined") {
      if (this.selected === advisor["b" /* StepProgress */].SKIPPED) {
        return "-";
      } else if (typeof this.selected === "object") {
        return this.selected.i18nDescription;
      }
    }
    return "-";
  }
  handleClick(handle, value) {
    this.$emit(handle, this.question, value);
    this.showAnswers = !this.showAnswers;
  }
  onSkip(handle) {
    this.$emit(handle, this.question);
    this.showAnswers = !this.showAnswers;
  }
};
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorQuestionFiltervue_type_script_lang_ts_AdvisorQuestionFilter.prototype, "question", void 0);
Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["b" /* Prop */])()], AdvisorQuestionFiltervue_type_script_lang_ts_AdvisorQuestionFilter.prototype, "selected", void 0);
AdvisorQuestionFiltervue_type_script_lang_ts_AdvisorQuestionFilter = Object(tslib_es6["a" /* __decorate */])([Object(vue_property_decorator["a" /* Component */])({
  components: {
    AdvisorIcon: AdvisorIcon["a" /* default */]
  }
})], AdvisorQuestionFiltervue_type_script_lang_ts_AdvisorQuestionFilter);
/* harmony default export */ var AdvisorQuestionFiltervue_type_script_lang_ts = (AdvisorQuestionFiltervue_type_script_lang_ts_AdvisorQuestionFilter);
// CONCATENATED MODULE: ./src/components/advisor-question-filter/AdvisorQuestionFilter.vue?vue&type=script&lang=ts
 /* harmony default export */ var advisor_question_filter_AdvisorQuestionFiltervue_type_script_lang_ts = (AdvisorQuestionFiltervue_type_script_lang_ts); 
// EXTERNAL MODULE: ./src/components/advisor-question-filter/AdvisorQuestionFilter.vue?vue&type=style&index=0&id=270f0cfd&prod&lang=scss&scoped=true
var AdvisorQuestionFiltervue_type_style_index_0_id_270f0cfd_prod_lang_scss_scoped_true = __webpack_require__("a023");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/components/advisor-question-filter/AdvisorQuestionFilter.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  advisor_question_filter_AdvisorQuestionFiltervue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  "270f0cfd",
  null
  
)

/* harmony default export */ var advisor_question_filter_AdvisorQuestionFilter = __webpack_exports__["a"] = (component.exports);

/***/ })

/******/ });
//# sourceMappingURL=dsm.common.js.map